//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface ISearchHttpService {
    /**
     * Searches in full, original files included: needs viewSearches, importSearch or removeSearch.
     */
    getProjectSearches(projectId: string): Observable<SearchDto[]>;
    deleteSearch(projectId: string, searchId: string, request?: SearchDeletionRequestDto | undefined): Observable<ProjectStandardDto>;
    deleteSearchImportJob(projectId: string, searchId: string, request?: SearchDeletionRequestDto | undefined): Observable<ProjectStandardDto>;
    getS3RequestSignature(projectId: string, requestInfo: SearchUploadSignatureRequestDto): Observable<FileUploadSignature>;
    addLivingSearch(projectId: string, livingSearchDto: CreateLivingSearchDto): Observable<ProjectStandardDto>;
    updateLivingSearch(projectId: string, livingSearchId: string, isActive: boolean): Observable<ProjectStandardDto>;
    calculateRob(projectId: string, searchId: string): Observable<RiskOfBiasJobDto>;
}

@Injectable({
    providedIn: 'root'
})
export class SearchHttpService implements ISearchHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Searches in full, original files included: needs viewSearches, importSearch or removeSearch.
     */
    getProjectSearches(projectId: string): Observable<SearchDto[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/searches";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectSearches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectSearches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchDto[]>;
        }));
    }

    protected processGetProjectSearches(response: HttpResponseBase): Observable<SearchDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchDto[];
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSearch(projectId: string, searchId: string, request?: SearchDeletionRequestDto | undefined): Observable<ProjectStandardDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/searches/{searchId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (searchId === undefined || searchId === null)
            throw new Error("The parameter 'searchId' must be defined.");
        url_ = url_.replace("{searchId}", encodeURIComponent("" + searchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStandardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStandardDto>;
        }));
    }

    protected processDeleteSearch(response: HttpResponseBase): Observable<ProjectStandardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStandardDto;
            return _observableOf(result200);
            }));
        } else if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeletionOperationDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSearchImportJob(projectId: string, searchId: string, request?: SearchDeletionRequestDto | undefined): Observable<ProjectStandardDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/searches/importJobs/{searchId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (searchId === undefined || searchId === null)
            throw new Error("The parameter 'searchId' must be defined.");
        url_ = url_.replace("{searchId}", encodeURIComponent("" + searchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSearchImportJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSearchImportJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStandardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStandardDto>;
        }));
    }

    protected processDeleteSearchImportJob(response: HttpResponseBase): Observable<ProjectStandardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStandardDto;
            return _observableOf(result200);
            }));
        } else if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeletionOperationDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getS3RequestSignature(projectId: string, requestInfo: SearchUploadSignatureRequestDto): Observable<FileUploadSignature> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/searches/getSignature";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestInfo);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetS3RequestSignature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetS3RequestSignature(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadSignature>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadSignature>;
        }));
    }

    protected processGetS3RequestSignature(response: HttpResponseBase): Observable<FileUploadSignature> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileUploadSignature;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addLivingSearch(projectId: string, livingSearchDto: CreateLivingSearchDto): Observable<ProjectStandardDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/searches/livingSearch";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(livingSearchDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLivingSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLivingSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStandardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStandardDto>;
        }));
    }

    protected processAddLivingSearch(response: HttpResponseBase): Observable<ProjectStandardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStandardDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateLivingSearch(projectId: string, livingSearchId: string, isActive: boolean): Observable<ProjectStandardDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/searches/livingSearch/{livingSearchId}/edit";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (livingSearchId === undefined || livingSearchId === null)
            throw new Error("The parameter 'livingSearchId' must be defined.");
        url_ = url_.replace("{livingSearchId}", encodeURIComponent("" + livingSearchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(isActive);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLivingSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLivingSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStandardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStandardDto>;
        }));
    }

    protected processUpdateLivingSearch(response: HttpResponseBase): Observable<ProjectStandardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStandardDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    calculateRob(projectId: string, searchId: string): Observable<RiskOfBiasJobDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/searches/{searchId}/rob/calculate";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (searchId === undefined || searchId === null)
            throw new Error("The parameter 'searchId' must be defined.");
        url_ = url_.replace("{searchId}", encodeURIComponent("" + searchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateRob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateRob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskOfBiasJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskOfBiasJobDto>;
        }));
    }

    protected processCalculateRob(response: HttpResponseBase): Observable<RiskOfBiasJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RiskOfBiasJobDto;
            return _observableOf(result202);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAccountAnnouncementsHttpService {
    /**
     * Records that the caller has seen and/or dismissed one announcement. Validation is by format only
    ({releaseId}:{LimitedRelease|GeneralRelease}, revision at least 1, at least one of seen and
    dismissed true), so a 400 never depends on data. It writes only when the announcement is one that
    availability reports now (a released, non-quiet record of this binding) and the revision is at most the
    announcement's current one; either way it answers 204, so the response never says whether a release exists.
     * @param request (optional) 
     */
    putState(announcementId: string, request?: AnnouncementStateRequest | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class AccountAnnouncementsHttpService implements IAccountAnnouncementsHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Records that the caller has seen and/or dismissed one announcement. Validation is by format only
    ({releaseId}:{LimitedRelease|GeneralRelease}, revision at least 1, at least one of seen and
    dismissed true), so a 400 never depends on data. It writes only when the announcement is one that
    availability reports now (a released, non-quiet record of this binding) and the revision is at most the
    announcement's current one; either way it answers 204, so the response never says whether a release exists.
     * @param request (optional) 
     */
    putState(announcementId: string, request?: AnnouncementStateRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/account/announcements/{announcementId}/state";
        if (announcementId === undefined || announcementId === null)
            throw new Error("The parameter 'announcementId' must be defined.");
        url_ = url_.replace("{announcementId}", encodeURIComponent("" + announcementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutState(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeatureAvailabilityDisabled;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IFeatureConsentHttpService {
    /**
     * Records the caller's own choice for a Personal feature (under full support impersonation, on the person's behalf).
     * @param request (optional) 
     */
    putAccountConsent(featureId: string, request?: FeatureConsentRequest | undefined): Observable<void>;
    /**
     * Records a project's choice for a Project feature; only the project's administrator's choice is written.
     * @param request (optional) 
     */
    putProjectConsent(projectId: string, featureId: string, request?: FeatureConsentRequest | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class FeatureConsentHttpService implements IFeatureConsentHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Records the caller's own choice for a Personal feature (under full support impersonation, on the person's behalf).
     * @param request (optional) 
     */
    putAccountConsent(featureId: string, request?: FeatureConsentRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/account/features/{featureId}/consent";
        if (featureId === undefined || featureId === null)
            throw new Error("The parameter 'featureId' must be defined.");
        url_ = url_.replace("{featureId}", encodeURIComponent("" + featureId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutAccountConsent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutAccountConsent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutAccountConsent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Records a project's choice for a Project feature; only the project's administrator's choice is written.
     * @param request (optional) 
     */
    putProjectConsent(projectId: string, featureId: string, request?: FeatureConsentRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/features/{featureId}/consent";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (featureId === undefined || featureId === null)
            throw new Error("The parameter 'featureId' must be defined.");
        url_ = url_.replace("{featureId}", encodeURIComponent("" + featureId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutProjectConsent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutProjectConsent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutProjectConsent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IFeaturesHttpService {
    /**
     * Availability without a project: features that need a project permission are omitted (D25 option A).
     */
    getAvailability(): Observable<FeatureAvailabilityResponse>;
    /**
     * Availability in one project, which ProjectViewPolicy admitted.
     */
    getProjectAvailability(projectId: string): Observable<FeatureAvailabilityResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class FeaturesHttpService implements IFeaturesHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Availability without a project: features that need a project permission are omitted (D25 option A).
     */
    getAvailability(): Observable<FeatureAvailabilityResponse> {
        let url_ = this.baseUrl + "/api/features/availability";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailability(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeatureAvailabilityResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeatureAvailabilityResponse>;
        }));
    }

    protected processGetAvailability(response: HttpResponseBase): Observable<FeatureAvailabilityResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeatureAvailabilityResponse;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeatureAvailabilityDisabled;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Availability in one project, which ProjectViewPolicy admitted.
     */
    getProjectAvailability(projectId: string): Observable<FeatureAvailabilityResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/features/availability";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectAvailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectAvailability(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeatureAvailabilityResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeatureAvailabilityResponse>;
        }));
    }

    protected processGetProjectAvailability(response: HttpResponseBase): Observable<FeatureAvailabilityResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeatureAvailabilityResponse;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeatureAvailabilityDisabled;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IWhatsNewHttpService {
    /**
     * The published runtime What's New entries, newest first.
     */
    getPublic(): Observable<PublicWhatsNewResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class WhatsNewHttpService implements IWhatsNewHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * The published runtime What's New entries, newest first.
     */
    getPublic(): Observable<PublicWhatsNewResponse> {
        let url_ = this.baseUrl + "/api/whats-new/public";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicWhatsNewResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicWhatsNewResponse>;
        }));
    }

    protected processGetPublic(response: HttpResponseBase): Observable<PublicWhatsNewResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PublicWhatsNewResponse;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeatureAvailabilityDisabled;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAccountHttpService {
    getAccountManagement(): Observable<AccountManagementDto>;
    /**
     * The caller's own application capabilities as decided by current PM authority (M1b self-
    capabilities contract). One uncached linearizable read per request; the UI uses this to
    explain, never to enforce. Exists only while PM application authority is enforced (otherwise
    404); refused while impersonating; 503 when authority is unavailable.
     */
    getCapabilities(): Observable<CapabilitiesDto>;
    checkInvestigatorEmail(emailLookupDto: EmailLookupDto): Observable<AccountCheckResponse>;
    publicCheckInvestigator(emailLookupDto: EmailLookupDto): Observable<AccountCheckCountResponse>;
    informAccountLink(accountLinkInformDto: AccountLinkInformDto): Observable<void>;
    checkIsImage(canRead?: boolean | undefined, canWrite?: boolean | undefined, canSeek?: boolean | undefined, canTimeout?: boolean | undefined, length?: number | undefined, position?: number | undefined, readTimeout?: number | undefined, writeTimeout?: number | undefined, extension?: string | undefined): Observable<FileResponse>;
    sendResetPasswordEmail(): Observable<void>;
    deleteProfile(removePersonalData?: boolean | undefined): Observable<void>;
    updateProfileName(profileNameUpdateDto: ProfileNameUpdateDto): Observable<ProfileUpdatedDto>;
    updatePrimaryEmail(profileEmailUpdateDto: ProfileEmailUpdateDto): Observable<ProfileUpdatedDto>;
    deleteProfileEmail(emailToDelete: string): Observable<ProfileUpdatedDto>;
    sendProfileEmailUpdateVerificationEmail(profileEmailUpdateDto: ProfileEmailUpdateDto): Observable<InvestigatorFullDto>;
    verifyAddProfileEmailChange(profileEmailConfirmDto: ProfileEmailConfirmDto): Observable<ProfileUpdatedDto>;
    updateProfilePicture(profileImageUpdateDto: ProfileImageUpdateDto): Observable<ProfileUpdatedDto>;
    signUp(createUserDto: CreateUserDto): Observable<NewUserCreatedDto>;
}

@Injectable({
    providedIn: 'root'
})
export class AccountHttpService implements IAccountHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAccountManagement(): Observable<AccountManagementDto> {
        let url_ = this.baseUrl + "/api/account/account-management";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountManagement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountManagement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountManagementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountManagementDto>;
        }));
    }

    protected processGetAccountManagement(response: HttpResponseBase): Observable<AccountManagementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountManagementDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 502) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The caller's own application capabilities as decided by current PM authority (M1b self-
    capabilities contract). One uncached linearizable read per request; the UI uses this to
    explain, never to enforce. Exists only while PM application authority is enforced (otherwise
    404); refused while impersonating; 503 when authority is unavailable.
     */
    getCapabilities(): Observable<CapabilitiesDto> {
        let url_ = this.baseUrl + "/api/account/capabilities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCapabilities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCapabilities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CapabilitiesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CapabilitiesDto>;
        }));
    }

    protected processGetCapabilities(response: HttpResponseBase): Observable<CapabilitiesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CapabilitiesDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkInvestigatorEmail(emailLookupDto: EmailLookupDto): Observable<AccountCheckResponse> {
        let url_ = this.baseUrl + "/api/account/email-lookup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailLookupDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckInvestigatorEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckInvestigatorEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountCheckResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountCheckResponse>;
        }));
    }

    protected processCheckInvestigatorEmail(response: HttpResponseBase): Observable<AccountCheckResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountCheckResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    publicCheckInvestigator(emailLookupDto: EmailLookupDto): Observable<AccountCheckCountResponse> {
        let url_ = this.baseUrl + "/api/account/email-lookup-p";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailLookupDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublicCheckInvestigator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublicCheckInvestigator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountCheckCountResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountCheckCountResponse>;
        }));
    }

    protected processPublicCheckInvestigator(response: HttpResponseBase): Observable<AccountCheckCountResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountCheckCountResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    informAccountLink(accountLinkInformDto: AccountLinkInformDto): Observable<void> {
        let url_ = this.baseUrl + "/api/account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountLinkInformDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInformAccountLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInformAccountLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInformAccountLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkIsImage(canRead?: boolean | undefined, canWrite?: boolean | undefined, canSeek?: boolean | undefined, canTimeout?: boolean | undefined, length?: number | undefined, position?: number | undefined, readTimeout?: number | undefined, writeTimeout?: number | undefined, extension?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/account?";
        if (canRead === null)
            throw new Error("The parameter 'canRead' cannot be null.");
        else if (canRead !== undefined)
            url_ += "CanRead=" + encodeURIComponent("" + canRead) + "&";
        if (canWrite === null)
            throw new Error("The parameter 'canWrite' cannot be null.");
        else if (canWrite !== undefined)
            url_ += "CanWrite=" + encodeURIComponent("" + canWrite) + "&";
        if (canSeek === null)
            throw new Error("The parameter 'canSeek' cannot be null.");
        else if (canSeek !== undefined)
            url_ += "CanSeek=" + encodeURIComponent("" + canSeek) + "&";
        if (canTimeout === null)
            throw new Error("The parameter 'canTimeout' cannot be null.");
        else if (canTimeout !== undefined)
            url_ += "CanTimeout=" + encodeURIComponent("" + canTimeout) + "&";
        if (length === null)
            throw new Error("The parameter 'length' cannot be null.");
        else if (length !== undefined)
            url_ += "Length=" + encodeURIComponent("" + length) + "&";
        if (position === null)
            throw new Error("The parameter 'position' cannot be null.");
        else if (position !== undefined)
            url_ += "Position=" + encodeURIComponent("" + position) + "&";
        if (readTimeout === null)
            throw new Error("The parameter 'readTimeout' cannot be null.");
        else if (readTimeout !== undefined)
            url_ += "ReadTimeout=" + encodeURIComponent("" + readTimeout) + "&";
        if (writeTimeout === null)
            throw new Error("The parameter 'writeTimeout' cannot be null.");
        else if (writeTimeout !== undefined)
            url_ += "WriteTimeout=" + encodeURIComponent("" + writeTimeout) + "&";
        if (extension === null)
            throw new Error("The parameter 'extension' cannot be null.");
        else if (extension !== undefined)
            url_ += "extension=" + encodeURIComponent("" + extension) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIsImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIsImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCheckIsImage(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendResetPasswordEmail(): Observable<void> {
        let url_ = this.baseUrl + "/api/account/profile/tickets/password";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendResetPasswordEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendResetPasswordEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendResetPasswordEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteProfile(removePersonalData?: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/account/profile?";
        if (removePersonalData === null)
            throw new Error("The parameter 'removePersonalData' cannot be null.");
        else if (removePersonalData !== undefined)
            url_ += "removePersonalData=" + encodeURIComponent("" + removePersonalData) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateProfileName(profileNameUpdateDto: ProfileNameUpdateDto): Observable<ProfileUpdatedDto> {
        let url_ = this.baseUrl + "/api/account/profile/name";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profileNameUpdateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfileName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfileName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileUpdatedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileUpdatedDto>;
        }));
    }

    protected processUpdateProfileName(response: HttpResponseBase): Observable<ProfileUpdatedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileUpdatedDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePrimaryEmail(profileEmailUpdateDto: ProfileEmailUpdateDto): Observable<ProfileUpdatedDto> {
        let url_ = this.baseUrl + "/api/account/profile/email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profileEmailUpdateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePrimaryEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePrimaryEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileUpdatedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileUpdatedDto>;
        }));
    }

    protected processUpdatePrimaryEmail(response: HttpResponseBase): Observable<ProfileUpdatedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileUpdatedDto;
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteProfileEmail(emailToDelete: string): Observable<ProfileUpdatedDto> {
        let url_ = this.baseUrl + "/api/account/profile/email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailToDelete);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProfileEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProfileEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileUpdatedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileUpdatedDto>;
        }));
    }

    protected processDeleteProfileEmail(response: HttpResponseBase): Observable<ProfileUpdatedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileUpdatedDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendProfileEmailUpdateVerificationEmail(profileEmailUpdateDto: ProfileEmailUpdateDto): Observable<InvestigatorFullDto> {
        let url_ = this.baseUrl + "/api/account/profile/tickets/email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profileEmailUpdateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendProfileEmailUpdateVerificationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendProfileEmailUpdateVerificationEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvestigatorFullDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvestigatorFullDto>;
        }));
    }

    protected processSendProfileEmailUpdateVerificationEmail(response: HttpResponseBase): Observable<InvestigatorFullDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InvestigatorFullDto;
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateEmailErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    verifyAddProfileEmailChange(profileEmailConfirmDto: ProfileEmailConfirmDto): Observable<ProfileUpdatedDto> {
        let url_ = this.baseUrl + "/api/account/profile/email/confirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profileEmailConfirmDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyAddProfileEmailChange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyAddProfileEmailChange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileUpdatedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileUpdatedDto>;
        }));
    }

    protected processVerifyAddProfileEmailChange(response: HttpResponseBase): Observable<ProfileUpdatedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileUpdatedDto;
            return _observableOf(result202);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VerificationErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateProfilePicture(profileImageUpdateDto: ProfileImageUpdateDto): Observable<ProfileUpdatedDto> {
        let url_ = this.baseUrl + "/api/account/profile/picture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profileImageUpdateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileUpdatedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileUpdatedDto>;
        }));
    }

    protected processUpdateProfilePicture(response: HttpResponseBase): Observable<ProfileUpdatedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileUpdatedDto;
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    signUp(createUserDto: CreateUserDto): Observable<NewUserCreatedDto> {
        let url_ = this.baseUrl + "/api/account/signup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createUserDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignUp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NewUserCreatedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NewUserCreatedDto>;
        }));
    }

    protected processSignUp(response: HttpResponseBase): Observable<NewUserCreatedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewUserCreatedDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IApplicationHttpService {
    recordSignin(): Observable<InvestigatorInitialInfoDto>;
    getProtocols(): Observable<ProtocolDto[]>;
    getLibraries(): Observable<LibraryDto[]>;
    getFaqs(): Observable<FaqsDto[]>;
    /**
     * Returns application environment and version information.
    Used by the frontend to display environment indicators and warnings.
     */
    getApplicationInfo(): Observable<ApplicationInfoDto>;
    submitGeneralEnquiry(generalInquiryFormDto: GeneralInquiryFormDto): Observable<EmailSendResult>;
    submitSupportRequest(supportFormDto: SupportFormDto): Observable<EmailSendResult>;
    generator(aggregates: Aggregates): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ApplicationHttpService implements IApplicationHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    recordSignin(): Observable<InvestigatorInitialInfoDto> {
        let url_ = this.baseUrl + "/api/signin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecordSignin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecordSignin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvestigatorInitialInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvestigatorInitialInfoDto>;
        }));
    }

    protected processRecordSignin(response: HttpResponseBase): Observable<InvestigatorInitialInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InvestigatorInitialInfoDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProtocols(): Observable<ProtocolDto[]> {
        let url_ = this.baseUrl + "/api/protocols";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProtocols(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProtocols(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProtocolDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProtocolDto[]>;
        }));
    }

    protected processGetProtocols(response: HttpResponseBase): Observable<ProtocolDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProtocolDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLibraries(): Observable<LibraryDto[]> {
        let url_ = this.baseUrl + "/api/libraries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLibraries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLibraries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LibraryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LibraryDto[]>;
        }));
    }

    protected processGetLibraries(response: HttpResponseBase): Observable<LibraryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LibraryDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFaqs(): Observable<FaqsDto[]> {
        let url_ = this.baseUrl + "/api/faqs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFaqs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFaqs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FaqsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FaqsDto[]>;
        }));
    }

    protected processGetFaqs(response: HttpResponseBase): Observable<FaqsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FaqsDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns application environment and version information.
    Used by the frontend to display environment indicators and warnings.
     */
    getApplicationInfo(): Observable<ApplicationInfoDto> {
        let url_ = this.baseUrl + "/api/application/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationInfoDto>;
        }));
    }

    protected processGetApplicationInfo(response: HttpResponseBase): Observable<ApplicationInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationInfoDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    submitGeneralEnquiry(generalInquiryFormDto: GeneralInquiryFormDto): Observable<EmailSendResult> {
        let url_ = this.baseUrl + "/api/submit-general-inquiry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(generalInquiryFormDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitGeneralEnquiry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitGeneralEnquiry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailSendResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailSendResult>;
        }));
    }

    protected processSubmitGeneralEnquiry(response: HttpResponseBase): Observable<EmailSendResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailSendResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    submitSupportRequest(supportFormDto: SupportFormDto): Observable<EmailSendResult> {
        let url_ = this.baseUrl + "/api/submit-support-request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(supportFormDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitSupportRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitSupportRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailSendResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailSendResult>;
        }));
    }

    protected processSubmitSupportRequest(response: HttpResponseBase): Observable<EmailSendResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailSendResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    generator(aggregates: Aggregates): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Generator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(aggregates);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGenerator(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBulkPdfNotifierAuthorityHttpService {
    getReleaseState(releaseId: string): Observable<IGetBulkPdfReleaseStateResult>;
    resolveBinding(request: ResolveStorageBindingRequest): Observable<IResolveBulkPdfStorageBindingResult>;
    registerCleanup(request: RegisterCleanupRequest): Observable<IRegisterBulkPdfCleanupResult>;
    registerQuarantine(request: RegisterQuarantineRequest): Observable<IRegisterBulkPdfQuarantineFenceResult>;
    transferQuarantine(request: TransferQuarantineRequest): Observable<ITransferBulkPdfQuarantineFenceResult>;
    acknowledgeCleanup(request: AcknowledgeCleanupRequest): Observable<IAcknowledgeBulkPdfCleanupResult>;
    confirmHoldRetired(request: ConfirmHoldRetiredRequest): Observable<IConfirmBulkPdfHoldRetiredResult>;
}

@Injectable({
    providedIn: 'root'
})
export class BulkPdfNotifierAuthorityHttpService implements IBulkPdfNotifierAuthorityHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getReleaseState(releaseId: string): Observable<IGetBulkPdfReleaseStateResult> {
        let url_ = this.baseUrl + "/api/notifier/bulk-pdf/releases/{releaseId}";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReleaseState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReleaseState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IGetBulkPdfReleaseStateResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IGetBulkPdfReleaseStateResult>;
        }));
    }

    protected processGetReleaseState(response: HttpResponseBase): Observable<IGetBulkPdfReleaseStateResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IGetBulkPdfReleaseStateResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resolveBinding(request: ResolveStorageBindingRequest): Observable<IResolveBulkPdfStorageBindingResult> {
        let url_ = this.baseUrl + "/api/notifier/bulk-pdf/bindings/resolve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveBinding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveBinding(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IResolveBulkPdfStorageBindingResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IResolveBulkPdfStorageBindingResult>;
        }));
    }

    protected processResolveBinding(response: HttpResponseBase): Observable<IResolveBulkPdfStorageBindingResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IResolveBulkPdfStorageBindingResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    registerCleanup(request: RegisterCleanupRequest): Observable<IRegisterBulkPdfCleanupResult> {
        let url_ = this.baseUrl + "/api/notifier/bulk-pdf/cleanup/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterCleanup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterCleanup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IRegisterBulkPdfCleanupResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IRegisterBulkPdfCleanupResult>;
        }));
    }

    protected processRegisterCleanup(response: HttpResponseBase): Observable<IRegisterBulkPdfCleanupResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IRegisterBulkPdfCleanupResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    registerQuarantine(request: RegisterQuarantineRequest): Observable<IRegisterBulkPdfQuarantineFenceResult> {
        let url_ = this.baseUrl + "/api/notifier/bulk-pdf/quarantine/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterQuarantine(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterQuarantine(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IRegisterBulkPdfQuarantineFenceResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IRegisterBulkPdfQuarantineFenceResult>;
        }));
    }

    protected processRegisterQuarantine(response: HttpResponseBase): Observable<IRegisterBulkPdfQuarantineFenceResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IRegisterBulkPdfQuarantineFenceResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transferQuarantine(request: TransferQuarantineRequest): Observable<ITransferBulkPdfQuarantineFenceResult> {
        let url_ = this.baseUrl + "/api/notifier/bulk-pdf/quarantine/transfer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransferQuarantine(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransferQuarantine(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ITransferBulkPdfQuarantineFenceResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ITransferBulkPdfQuarantineFenceResult>;
        }));
    }

    protected processTransferQuarantine(response: HttpResponseBase): Observable<ITransferBulkPdfQuarantineFenceResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ITransferBulkPdfQuarantineFenceResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    acknowledgeCleanup(request: AcknowledgeCleanupRequest): Observable<IAcknowledgeBulkPdfCleanupResult> {
        let url_ = this.baseUrl + "/api/notifier/bulk-pdf/cleanup/acknowledge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcknowledgeCleanup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcknowledgeCleanup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IAcknowledgeBulkPdfCleanupResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IAcknowledgeBulkPdfCleanupResult>;
        }));
    }

    protected processAcknowledgeCleanup(response: HttpResponseBase): Observable<IAcknowledgeBulkPdfCleanupResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IAcknowledgeBulkPdfCleanupResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    confirmHoldRetired(request: ConfirmHoldRetiredRequest): Observable<IConfirmBulkPdfHoldRetiredResult> {
        let url_ = this.baseUrl + "/api/notifier/bulk-pdf/holds/retire";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmHoldRetired(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmHoldRetired(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IConfirmBulkPdfHoldRetiredResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IConfirmBulkPdfHoldRetiredResult>;
        }));
    }

    protected processConfirmHoldRetired(response: HttpResponseBase): Observable<IConfirmBulkPdfHoldRetiredResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IConfirmBulkPdfHoldRetiredResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBulkPdfUploadHttpService {
    initiateUpload(projectId: string, searchId: string, request: BulkPdfUploadInitiateRequestDto): Observable<BulkPdfUploadJobDto>;
    getUploadSession(projectId: string, searchId: string, uploadId: string): Observable<BulkPdfUploadJobDto>;
    signPart(projectId: string, searchId: string, uploadId: string, partNumber: number, request: BulkPdfUploadPartRequestDto): Observable<BulkPdfUploadPartSignatureDto>;
    acknowledgePart(projectId: string, searchId: string, uploadId: string, partNumber: number, request: BulkPdfUploadPartRequestDto): Observable<BulkPdfUploadJobDto>;
    heartbeat(projectId: string, searchId: string, uploadId: string): Observable<BulkPdfUploadHeartbeatDto>;
    completeUpload(projectId: string, searchId: string, uploadId: string): Observable<BulkPdfUploadJobDto>;
    abandonUpload(projectId: string, searchId: string, uploadId: string, request: BulkPdfUploadAbandonRequestDto): Observable<BulkPdfUploadJobDto>;
    cancelUpload(projectId: string, searchId: string, uploadId: string): Observable<BulkPdfUploadJobDto>;
    retryUpload(projectId: string, searchId: string, oldUploadId: string, request: BulkPdfUploadRetryRequestDto): Observable<BulkPdfUploadJobDto>;
    getBulkPdfUploadHistory(projectId: string, searchId: string): Observable<BulkPdfUploadJobDto[]>;
    getBulkPdfUploadReport(projectId: string, searchId: string, uploadId: string): Observable<FileResponse>;
    getStudyPdfPaths(projectId: string, searchId: string): Observable<StudyPdfPathSnapshotDto>;
}

@Injectable({
    providedIn: 'root'
})
export class BulkPdfUploadHttpService implements IBulkPdfUploadHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    initiateUpload(projectId: string, searchId: string, request: BulkPdfUploadInitiateRequestDto): Observable<BulkPdfUploadJobDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/searches/{searchId}/bulkPdfUpload/uploads";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (searchId === undefined || searchId === null)
            throw new Error("The parameter 'searchId' must be defined.");
        url_ = url_.replace("{searchId}", encodeURIComponent("" + searchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInitiateUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInitiateUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkPdfUploadJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkPdfUploadJobDto>;
        }));
    }

    protected processInitiateUpload(response: HttpResponseBase): Observable<BulkPdfUploadJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadJobDto;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUploadSession(projectId: string, searchId: string, uploadId: string): Observable<BulkPdfUploadJobDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/searches/{searchId}/bulkPdfUpload/uploads/{uploadId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (searchId === undefined || searchId === null)
            throw new Error("The parameter 'searchId' must be defined.");
        url_ = url_.replace("{searchId}", encodeURIComponent("" + searchId));
        if (uploadId === undefined || uploadId === null)
            throw new Error("The parameter 'uploadId' must be defined.");
        url_ = url_.replace("{uploadId}", encodeURIComponent("" + uploadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUploadSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUploadSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkPdfUploadJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkPdfUploadJobDto>;
        }));
    }

    protected processGetUploadSession(response: HttpResponseBase): Observable<BulkPdfUploadJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadJobDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    signPart(projectId: string, searchId: string, uploadId: string, partNumber: number, request: BulkPdfUploadPartRequestDto): Observable<BulkPdfUploadPartSignatureDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/searches/{searchId}/bulkPdfUpload/uploads/{uploadId}/parts/{partNumber}/signature";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (searchId === undefined || searchId === null)
            throw new Error("The parameter 'searchId' must be defined.");
        url_ = url_.replace("{searchId}", encodeURIComponent("" + searchId));
        if (uploadId === undefined || uploadId === null)
            throw new Error("The parameter 'uploadId' must be defined.");
        url_ = url_.replace("{uploadId}", encodeURIComponent("" + uploadId));
        if (partNumber === undefined || partNumber === null)
            throw new Error("The parameter 'partNumber' must be defined.");
        url_ = url_.replace("{partNumber}", encodeURIComponent("" + partNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignPart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignPart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkPdfUploadPartSignatureDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkPdfUploadPartSignatureDto>;
        }));
    }

    protected processSignPart(response: HttpResponseBase): Observable<BulkPdfUploadPartSignatureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadPartSignatureDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result410: any = null;
            result410 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result410);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    acknowledgePart(projectId: string, searchId: string, uploadId: string, partNumber: number, request: BulkPdfUploadPartRequestDto): Observable<BulkPdfUploadJobDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/searches/{searchId}/bulkPdfUpload/uploads/{uploadId}/parts/{partNumber}/completed";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (searchId === undefined || searchId === null)
            throw new Error("The parameter 'searchId' must be defined.");
        url_ = url_.replace("{searchId}", encodeURIComponent("" + searchId));
        if (uploadId === undefined || uploadId === null)
            throw new Error("The parameter 'uploadId' must be defined.");
        url_ = url_.replace("{uploadId}", encodeURIComponent("" + uploadId));
        if (partNumber === undefined || partNumber === null)
            throw new Error("The parameter 'partNumber' must be defined.");
        url_ = url_.replace("{partNumber}", encodeURIComponent("" + partNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcknowledgePart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcknowledgePart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkPdfUploadJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkPdfUploadJobDto>;
        }));
    }

    protected processAcknowledgePart(response: HttpResponseBase): Observable<BulkPdfUploadJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadJobDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result410: any = null;
            result410 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result410);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    heartbeat(projectId: string, searchId: string, uploadId: string): Observable<BulkPdfUploadHeartbeatDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/searches/{searchId}/bulkPdfUpload/uploads/{uploadId}/heartbeat";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (searchId === undefined || searchId === null)
            throw new Error("The parameter 'searchId' must be defined.");
        url_ = url_.replace("{searchId}", encodeURIComponent("" + searchId));
        if (uploadId === undefined || uploadId === null)
            throw new Error("The parameter 'uploadId' must be defined.");
        url_ = url_.replace("{uploadId}", encodeURIComponent("" + uploadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHeartbeat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHeartbeat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkPdfUploadHeartbeatDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkPdfUploadHeartbeatDto>;
        }));
    }

    protected processHeartbeat(response: HttpResponseBase): Observable<BulkPdfUploadHeartbeatDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadHeartbeatDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result410: any = null;
            result410 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result410);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    completeUpload(projectId: string, searchId: string, uploadId: string): Observable<BulkPdfUploadJobDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/searches/{searchId}/bulkPdfUpload/uploads/{uploadId}/complete";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (searchId === undefined || searchId === null)
            throw new Error("The parameter 'searchId' must be defined.");
        url_ = url_.replace("{searchId}", encodeURIComponent("" + searchId));
        if (uploadId === undefined || uploadId === null)
            throw new Error("The parameter 'uploadId' must be defined.");
        url_ = url_.replace("{uploadId}", encodeURIComponent("" + uploadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkPdfUploadJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkPdfUploadJobDto>;
        }));
    }

    protected processCompleteUpload(response: HttpResponseBase): Observable<BulkPdfUploadJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadJobDto;
            return _observableOf(result200);
            }));
        } else if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadJobDto;
            return _observableOf(result202);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result410: any = null;
            result410 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result410);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    abandonUpload(projectId: string, searchId: string, uploadId: string, request: BulkPdfUploadAbandonRequestDto): Observable<BulkPdfUploadJobDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/searches/{searchId}/bulkPdfUpload/uploads/{uploadId}/abandon";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (searchId === undefined || searchId === null)
            throw new Error("The parameter 'searchId' must be defined.");
        url_ = url_.replace("{searchId}", encodeURIComponent("" + searchId));
        if (uploadId === undefined || uploadId === null)
            throw new Error("The parameter 'uploadId' must be defined.");
        url_ = url_.replace("{uploadId}", encodeURIComponent("" + uploadId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbandonUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbandonUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkPdfUploadJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkPdfUploadJobDto>;
        }));
    }

    protected processAbandonUpload(response: HttpResponseBase): Observable<BulkPdfUploadJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadJobDto;
            return _observableOf(result200);
            }));
        } else if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadJobDto;
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancelUpload(projectId: string, searchId: string, uploadId: string): Observable<BulkPdfUploadJobDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/searches/{searchId}/bulkPdfUpload/uploads/{uploadId}/cancel";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (searchId === undefined || searchId === null)
            throw new Error("The parameter 'searchId' must be defined.");
        url_ = url_.replace("{searchId}", encodeURIComponent("" + searchId));
        if (uploadId === undefined || uploadId === null)
            throw new Error("The parameter 'uploadId' must be defined.");
        url_ = url_.replace("{uploadId}", encodeURIComponent("" + uploadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkPdfUploadJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkPdfUploadJobDto>;
        }));
    }

    protected processCancelUpload(response: HttpResponseBase): Observable<BulkPdfUploadJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadJobDto;
            return _observableOf(result200);
            }));
        } else if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadJobDto;
            return _observableOf(result202);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retryUpload(projectId: string, searchId: string, oldUploadId: string, request: BulkPdfUploadRetryRequestDto): Observable<BulkPdfUploadJobDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/searches/{searchId}/bulkPdfUpload/uploads/{oldUploadId}/retry";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (searchId === undefined || searchId === null)
            throw new Error("The parameter 'searchId' must be defined.");
        url_ = url_.replace("{searchId}", encodeURIComponent("" + searchId));
        if (oldUploadId === undefined || oldUploadId === null)
            throw new Error("The parameter 'oldUploadId' must be defined.");
        url_ = url_.replace("{oldUploadId}", encodeURIComponent("" + oldUploadId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetryUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetryUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkPdfUploadJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkPdfUploadJobDto>;
        }));
    }

    protected processRetryUpload(response: HttpResponseBase): Observable<BulkPdfUploadJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadJobDto;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBulkPdfUploadHistory(projectId: string, searchId: string): Observable<BulkPdfUploadJobDto[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/searches/{searchId}/bulkPdfUpload/history";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (searchId === undefined || searchId === null)
            throw new Error("The parameter 'searchId' must be defined.");
        url_ = url_.replace("{searchId}", encodeURIComponent("" + searchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBulkPdfUploadHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBulkPdfUploadHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkPdfUploadJobDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkPdfUploadJobDto[]>;
        }));
    }

    protected processGetBulkPdfUploadHistory(response: HttpResponseBase): Observable<BulkPdfUploadJobDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadJobDto[];
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBulkPdfUploadReport(projectId: string, searchId: string, uploadId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/searches/{searchId}/bulkPdfUpload/{uploadId}/report";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (searchId === undefined || searchId === null)
            throw new Error("The parameter 'searchId' must be defined.");
        url_ = url_.replace("{searchId}", encodeURIComponent("" + searchId));
        if (uploadId === undefined || uploadId === null)
            throw new Error("The parameter 'uploadId' must be defined.");
        url_ = url_.replace("{uploadId}", encodeURIComponent("" + uploadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBulkPdfUploadReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBulkPdfUploadReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetBulkPdfUploadReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStudyPdfPaths(projectId: string, searchId: string): Observable<StudyPdfPathSnapshotDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/searches/{searchId}/pdfPaths";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (searchId === undefined || searchId === null)
            throw new Error("The parameter 'searchId' must be defined.");
        url_ = url_.replace("{searchId}", encodeURIComponent("" + searchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStudyPdfPaths(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStudyPdfPaths(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StudyPdfPathSnapshotDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StudyPdfPathSnapshotDto>;
        }));
    }

    protected processGetStudyPdfPaths(response: HttpResponseBase): Observable<StudyPdfPathSnapshotDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyPdfPathSnapshotDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkPdfUploadProblemDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDataExportHttpService {
    createDataExportJob(projectId: string, dataExportRequest: DataExportRequest): Observable<DataExportJobCreatedDto>;
    getDataExport(projectId: string, jobId: string, delimiter?: CsvDelimiter | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class DataExportHttpService implements IDataExportHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createDataExportJob(projectId: string, dataExportRequest: DataExportRequest): Observable<DataExportJobCreatedDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/data-export-jobs";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataExportRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDataExportJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDataExportJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataExportJobCreatedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataExportJobCreatedDto>;
        }));
    }

    protected processCreateDataExportJob(response: HttpResponseBase): Observable<DataExportJobCreatedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataExportJobCreatedDto;
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDataExport(projectId: string, jobId: string, delimiter?: CsvDelimiter | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/data-export/{jobId}?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (delimiter === null)
            throw new Error("The parameter 'delimiter' cannot be null.");
        else if (delimiter !== undefined)
            url_ += "delimiter=" + encodeURIComponent("" + delimiter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetDataExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAdminEmailHttpService {
    sendEmail(emailSendDtoRequest: TemplatedEmailSendDto): Observable<EmailSendResult[]>;
    sendBulkEmail(emailSendDtoRequest: TemplatedEmailSendDto): Observable<HttpStatusCode>;
    sendEmailToAllActiveInvestigators(templateName?: string | undefined, templateData?: any | null | undefined): Observable<BatchedStatusCode[]>;
    getEmailTemplates(): Observable<AwsEmailTemplateInfo[]>;
    createEmailTemplate(emailTemplateDetails: AwsEmailTemplateDetails): Observable<AwsEmailTemplateDetails>;
    updateEmailTemplate(templateName: string, emailTemplateDetails: AwsEmailTemplateDetails): Observable<AwsEmailTemplateDetails>;
    deleteEmailTemplate(templateName: string): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class AdminEmailHttpService implements IAdminEmailHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    sendEmail(emailSendDtoRequest: TemplatedEmailSendDto): Observable<EmailSendResult[]> {
        let url_ = this.baseUrl + "/api/admin-email/send-templated-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailSendDtoRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailSendResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailSendResult[]>;
        }));
    }

    protected processSendEmail(response: HttpResponseBase): Observable<EmailSendResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailSendResult[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendBulkEmail(emailSendDtoRequest: TemplatedEmailSendDto): Observable<HttpStatusCode> {
        let url_ = this.baseUrl + "/api/admin-email/send-bulk-templated-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailSendDtoRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendBulkEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendBulkEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HttpStatusCode>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HttpStatusCode>;
        }));
    }

    protected processSendBulkEmail(response: HttpResponseBase): Observable<HttpStatusCode> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HttpStatusCode;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendEmailToAllActiveInvestigators(templateName?: string | undefined, templateData?: any | null | undefined): Observable<BatchedStatusCode[]> {
        let url_ = this.baseUrl + "/api/admin-email/send-templated-email-to-all-active-investigators?";
        if (templateName === null)
            throw new Error("The parameter 'templateName' cannot be null.");
        else if (templateName !== undefined)
            url_ += "TemplateName=" + encodeURIComponent("" + templateName) + "&";
        if (templateData !== undefined && templateData !== null)
            url_ += "TemplateData=" + encodeURIComponent("" + templateData) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmailToAllActiveInvestigators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailToAllActiveInvestigators(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchedStatusCode[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchedStatusCode[]>;
        }));
    }

    protected processSendEmailToAllActiveInvestigators(response: HttpResponseBase): Observable<BatchedStatusCode[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BatchedStatusCode[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmailTemplates(): Observable<AwsEmailTemplateInfo[]> {
        let url_ = this.baseUrl + "/api/admin-email/email-templates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AwsEmailTemplateInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AwsEmailTemplateInfo[]>;
        }));
    }

    protected processGetEmailTemplates(response: HttpResponseBase): Observable<AwsEmailTemplateInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AwsEmailTemplateInfo[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createEmailTemplate(emailTemplateDetails: AwsEmailTemplateDetails): Observable<AwsEmailTemplateDetails> {
        let url_ = this.baseUrl + "/api/admin-email/email-templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailTemplateDetails);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEmailTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEmailTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AwsEmailTemplateDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AwsEmailTemplateDetails>;
        }));
    }

    protected processCreateEmailTemplate(response: HttpResponseBase): Observable<AwsEmailTemplateDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AwsEmailTemplateDetails;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEmailTemplate(templateName: string, emailTemplateDetails: AwsEmailTemplateDetails): Observable<AwsEmailTemplateDetails> {
        let url_ = this.baseUrl + "/api/admin-email/email-templates/{templateName}";
        if (templateName === undefined || templateName === null)
            throw new Error("The parameter 'templateName' must be defined.");
        url_ = url_.replace("{templateName}", encodeURIComponent("" + templateName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailTemplateDetails);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEmailTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEmailTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AwsEmailTemplateDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AwsEmailTemplateDetails>;
        }));
    }

    protected processUpdateEmailTemplate(response: HttpResponseBase): Observable<AwsEmailTemplateDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AwsEmailTemplateDetails;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteEmailTemplate(templateName: string): Observable<string> {
        let url_ = this.baseUrl + "/api/admin-email/email-templates/{templateName}";
        if (templateName === undefined || templateName === null)
            throw new Error("The parameter 'templateName' must be defined.");
        url_ = url_.replace("{templateName}", encodeURIComponent("" + templateName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEmailTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEmailTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteEmailTemplate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEnvironmentCompatibilityReportsHttpService {
    getRetained(reportId: string): Observable<RuntimeEnvironmentCompatibilityReport>;
    getCurrent(purpose?: string | null | undefined): Observable<RuntimeEnvironmentCompatibilityReport>;
}

@Injectable({
    providedIn: 'root'
})
export class EnvironmentCompatibilityReportsHttpService implements IEnvironmentCompatibilityReportsHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getRetained(reportId: string): Observable<RuntimeEnvironmentCompatibilityReport> {
        let url_ = this.baseUrl + "/api/environment/compatibility-reports/{reportId}";
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRetained(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRetained(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimeEnvironmentCompatibilityReport>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimeEnvironmentCompatibilityReport>;
        }));
    }

    protected processGetRetained(response: HttpResponseBase): Observable<RuntimeEnvironmentCompatibilityReport> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeEnvironmentCompatibilityReport;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCurrent(purpose?: string | null | undefined): Observable<RuntimeEnvironmentCompatibilityReport> {
        let url_ = this.baseUrl + "/api/environment/compatibility-reports/current?";
        if (purpose !== undefined && purpose !== null)
            url_ += "purpose=" + encodeURIComponent("" + purpose) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimeEnvironmentCompatibilityReport>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimeEnvironmentCompatibilityReport>;
        }));
    }

    protected processGetCurrent(response: HttpResponseBase): Observable<RuntimeEnvironmentCompatibilityReport> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeEnvironmentCompatibilityReport;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEnvironmentDeploymentConstraintsHttpService {
    put(rolloutId: string, request: RuntimeCoordinatorChangeRequest): Observable<RuntimeCoordinatorReceipt>;
    release(rolloutId: string, request: RuntimeCoordinatorChangeRequest): Observable<RuntimeCoordinatorReceipt>;
}

@Injectable({
    providedIn: 'root'
})
export class EnvironmentDeploymentConstraintsHttpService implements IEnvironmentDeploymentConstraintsHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    put(rolloutId: string, request: RuntimeCoordinatorChangeRequest): Observable<RuntimeCoordinatorReceipt> {
        let url_ = this.baseUrl + "/api/environment/deployment-constraints/{rolloutId}";
        if (rolloutId === undefined || rolloutId === null)
            throw new Error("The parameter 'rolloutId' must be defined.");
        url_ = url_.replace("{rolloutId}", encodeURIComponent("" + rolloutId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimeCoordinatorReceipt>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimeCoordinatorReceipt>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<RuntimeCoordinatorReceipt> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeCoordinatorReceipt;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    release(rolloutId: string, request: RuntimeCoordinatorChangeRequest): Observable<RuntimeCoordinatorReceipt> {
        let url_ = this.baseUrl + "/api/environment/deployment-constraints/{rolloutId}";
        if (rolloutId === undefined || rolloutId === null)
            throw new Error("The parameter 'rolloutId' must be defined.");
        url_ = url_.replace("{rolloutId}", encodeURIComponent("" + rolloutId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRelease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRelease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimeCoordinatorReceipt>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimeCoordinatorReceipt>;
        }));
    }

    protected processRelease(response: HttpResponseBase): Observable<RuntimeCoordinatorReceipt> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeCoordinatorReceipt;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEnvironmentObservationsHttpService {
    publish(request: RuntimeWorkloadObservation): Observable<RuntimeWorkloadObservationReceipt>;
}

@Injectable({
    providedIn: 'root'
})
export class EnvironmentObservationsHttpService implements IEnvironmentObservationsHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    publish(request: RuntimeWorkloadObservation): Observable<RuntimeWorkloadObservationReceipt> {
        let url_ = this.baseUrl + "/api/environment/observations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublish(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimeWorkloadObservationReceipt>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimeWorkloadObservationReceipt>;
        }));
    }

    protected processPublish(response: HttpResponseBase): Observable<RuntimeWorkloadObservationReceipt> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeWorkloadObservationReceipt;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IGravatarBackfillHttpService {
    /**
     * The dry run: how many Investigators the backfill would import. Contacts no one and writes nothing.
     */
    preview(): Observable<GravatarBackfillPreview>;
    /**
     * Runs one batch after after. Repeat with after set to the answer's next until next is
    null; stop on FlagOff or RepeatedFailures.
     * @param request (optional) 
     */
    runBatch(request?: GravatarBackfillRequest | undefined): Observable<GravatarBackfillBatch>;
}

@Injectable({
    providedIn: 'root'
})
export class GravatarBackfillHttpService implements IGravatarBackfillHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * The dry run: how many Investigators the backfill would import. Contacts no one and writes nothing.
     */
    preview(): Observable<GravatarBackfillPreview> {
        let url_ = this.baseUrl + "/api/admin/gravatar-backfill";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GravatarBackfillPreview>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GravatarBackfillPreview>;
        }));
    }

    protected processPreview(response: HttpResponseBase): Observable<GravatarBackfillPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GravatarBackfillPreview;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Runs one batch after after. Repeat with after set to the answer's next until next is
    null; stop on FlagOff or RepeatedFailures.
     * @param request (optional) 
     */
    runBatch(request?: GravatarBackfillRequest | undefined): Observable<GravatarBackfillBatch> {
        let url_ = this.baseUrl + "/api/admin/gravatar-backfill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GravatarBackfillBatch>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GravatarBackfillBatch>;
        }));
    }

    protected processRunBatch(response: HttpResponseBase): Observable<GravatarBackfillBatch> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GravatarBackfillBatch;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IInvestigatorHttpService {
    getInvestigators(): Observable<InvestigatorFullDto[]>;
    /**
     * The authoritative application roles and role revision of one Investigator (M1b). Available
    only while PM application authority is enforced; otherwise the route does not exist (404).
    Requires current PM role administration authority, read uncached for this request.
     */
    getApplicationRoles(investigatorId: string): Observable<ApplicationRolesDto>;
    /**
     * Grant or revoke application roles (M1b): PUT the complete desired set with the revision last
    read, a reason and a client-generated operation ID. See
    docs/how-to/administer-application-roles.md for every response.
     * @param change (optional) 
     */
    putApplicationRoles(investigatorId: string, change?: ApplicationRolesChangeDto | undefined): Observable<ApplicationRoleChangeResultDto>;
    /**
     * Reconciles an account deletion whose outcome was left ambiguous (M1c): resumes its pending
    deactivation reservation (same server-bound operation ID and Identity subject, bound when the
    account owner asked for the deletion) and drives it to a settled state. Idempotent. Requires
    current role administration authority; enforced mode only (otherwise 404). It never creates a
    reservation and never deletes an account nobody asked to delete.
     */
    reconcilePendingDeactivation(investigatorId: string): Observable<PendingDeactivationReconcileResultDto>;
    /**
     * M4a: the suspension state of one Investigator, as stored. Enforced application authority only (otherwise
    404); requires current role administration authority. With applicationSuspension off (#4290) it
    still answers, read-only, with enforced: false: the suspension is kept but refuses nothing until
    the flag is switched back on. Suspend and restore stay unavailable (404) while it is off.
     */
    getApplicationSuspension(investigatorId: string): Observable<ApplicationSuspensionDto>;
    /**
     * M4a: suspend an account's application access (reversible). The last-active-administrator guard admits
    it, the PM denial commits, then native sessions are withdrawn. 200 when the withdrawal is settled;
    202 suspension-committed-withdrawal-pending when the suspension committed but the withdrawal did
    not complete (reconcile with POST …/pending-deactivation/reconcile). See
    docs/how-to/suspend-application-access.md for every response.
     * @param change (optional) 
     */
    suspendApplicationAccess(investigatorId: string, change?: ApplicationSuspensionChangeDto | undefined): Observable<ApplicationSuspensionResultDto>;
    /**
     * M4a: restore a suspended account's application access. Only a suspension whose withdrawal has settled,
    never a deleted account. Removes the suspension only: roles stay as they are now, Identity lockouts and
    recovery requirements stand, and withdrawn sessions need a new sign-in.
     * @param change (optional) 
     */
    restoreApplicationAccess(investigatorId: string, change?: ApplicationSuspensionChangeDto | undefined): Observable<ApplicationSuspensionResultDto>;
}

@Injectable({
    providedIn: 'root'
})
export class InvestigatorHttpService implements IInvestigatorHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getInvestigators(): Observable<InvestigatorFullDto[]> {
        let url_ = this.baseUrl + "/api/investigators";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvestigators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvestigators(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvestigatorFullDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvestigatorFullDto[]>;
        }));
    }

    protected processGetInvestigators(response: HttpResponseBase): Observable<InvestigatorFullDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InvestigatorFullDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The authoritative application roles and role revision of one Investigator (M1b). Available
    only while PM application authority is enforced; otherwise the route does not exist (404).
    Requires current PM role administration authority, read uncached for this request.
     */
    getApplicationRoles(investigatorId: string): Observable<ApplicationRolesDto> {
        let url_ = this.baseUrl + "/api/investigators/{investigatorId}/application-roles";
        if (investigatorId === undefined || investigatorId === null)
            throw new Error("The parameter 'investigatorId' must be defined.");
        url_ = url_.replace("{investigatorId}", encodeURIComponent("" + investigatorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationRolesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationRolesDto>;
        }));
    }

    protected processGetApplicationRoles(response: HttpResponseBase): Observable<ApplicationRolesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationRolesDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Grant or revoke application roles (M1b): PUT the complete desired set with the revision last
    read, a reason and a client-generated operation ID. See
    docs/how-to/administer-application-roles.md for every response.
     * @param change (optional) 
     */
    putApplicationRoles(investigatorId: string, change?: ApplicationRolesChangeDto | undefined): Observable<ApplicationRoleChangeResultDto> {
        let url_ = this.baseUrl + "/api/investigators/{investigatorId}/application-roles";
        if (investigatorId === undefined || investigatorId === null)
            throw new Error("The parameter 'investigatorId' must be defined.");
        url_ = url_.replace("{investigatorId}", encodeURIComponent("" + investigatorId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(change);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutApplicationRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutApplicationRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationRoleChangeResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationRoleChangeResultDto>;
        }));
    }

    protected processPutApplicationRoles(response: HttpResponseBase): Observable<ApplicationRoleChangeResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationRoleChangeResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reconciles an account deletion whose outcome was left ambiguous (M1c): resumes its pending
    deactivation reservation (same server-bound operation ID and Identity subject, bound when the
    account owner asked for the deletion) and drives it to a settled state. Idempotent. Requires
    current role administration authority; enforced mode only (otherwise 404). It never creates a
    reservation and never deletes an account nobody asked to delete.
     */
    reconcilePendingDeactivation(investigatorId: string): Observable<PendingDeactivationReconcileResultDto> {
        let url_ = this.baseUrl + "/api/investigators/{investigatorId}/pending-deactivation/reconcile";
        if (investigatorId === undefined || investigatorId === null)
            throw new Error("The parameter 'investigatorId' must be defined.");
        url_ = url_.replace("{investigatorId}", encodeURIComponent("" + investigatorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReconcilePendingDeactivation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReconcilePendingDeactivation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingDeactivationReconcileResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingDeactivationReconcileResultDto>;
        }));
    }

    protected processReconcilePendingDeactivation(response: HttpResponseBase): Observable<PendingDeactivationReconcileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PendingDeactivationReconcileResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * M4a: the suspension state of one Investigator, as stored. Enforced application authority only (otherwise
    404); requires current role administration authority. With applicationSuspension off (#4290) it
    still answers, read-only, with enforced: false: the suspension is kept but refuses nothing until
    the flag is switched back on. Suspend and restore stay unavailable (404) while it is off.
     */
    getApplicationSuspension(investigatorId: string): Observable<ApplicationSuspensionDto> {
        let url_ = this.baseUrl + "/api/investigators/{investigatorId}/application-suspension";
        if (investigatorId === undefined || investigatorId === null)
            throw new Error("The parameter 'investigatorId' must be defined.");
        url_ = url_.replace("{investigatorId}", encodeURIComponent("" + investigatorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationSuspension(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationSuspension(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationSuspensionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationSuspensionDto>;
        }));
    }

    protected processGetApplicationSuspension(response: HttpResponseBase): Observable<ApplicationSuspensionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationSuspensionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * M4a: suspend an account's application access (reversible). The last-active-administrator guard admits
    it, the PM denial commits, then native sessions are withdrawn. 200 when the withdrawal is settled;
    202 suspension-committed-withdrawal-pending when the suspension committed but the withdrawal did
    not complete (reconcile with POST …/pending-deactivation/reconcile). See
    docs/how-to/suspend-application-access.md for every response.
     * @param change (optional) 
     */
    suspendApplicationAccess(investigatorId: string, change?: ApplicationSuspensionChangeDto | undefined): Observable<ApplicationSuspensionResultDto> {
        let url_ = this.baseUrl + "/api/investigators/{investigatorId}/application-suspension";
        if (investigatorId === undefined || investigatorId === null)
            throw new Error("The parameter 'investigatorId' must be defined.");
        url_ = url_.replace("{investigatorId}", encodeURIComponent("" + investigatorId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(change);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSuspendApplicationAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSuspendApplicationAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationSuspensionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationSuspensionResultDto>;
        }));
    }

    protected processSuspendApplicationAccess(response: HttpResponseBase): Observable<ApplicationSuspensionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationSuspensionResultDto;
            return _observableOf(result200);
            }));
        } else if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationSuspensionResultDto;
            return _observableOf(result202);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * M4a: restore a suspended account's application access. Only a suspension whose withdrawal has settled,
    never a deleted account. Removes the suspension only: roles stay as they are now, Identity lockouts and
    recovery requirements stand, and withdrawn sessions need a new sign-in.
     * @param change (optional) 
     */
    restoreApplicationAccess(investigatorId: string, change?: ApplicationSuspensionChangeDto | undefined): Observable<ApplicationSuspensionResultDto> {
        let url_ = this.baseUrl + "/api/investigators/{investigatorId}/application-suspension/restore";
        if (investigatorId === undefined || investigatorId === null)
            throw new Error("The parameter 'investigatorId' must be defined.");
        url_ = url_.replace("{investigatorId}", encodeURIComponent("" + investigatorId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(change);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestoreApplicationAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestoreApplicationAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationSuspensionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationSuspensionResultDto>;
        }));
    }

    protected processRestoreApplicationAccess(response: HttpResponseBase): Observable<ApplicationSuspensionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationSuspensionResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface INotificationEmailPreferencesHttpService {
    get(): Observable<NotificationEmailPreferencesDto>;
    put(request: NotificationEmailPreferencesDto): Observable<NotificationEmailPreferencesDto>;
    /**
     * What a daily digest prepared now would send the caller (N5), rendered by the digest's own renderer. Read-only:
    no ledger entry, window, claim or preference write, and nothing is sent. 503 while an authority read is unavailable.
     */
    digestPreview(): Observable<NotificationDigestPreviewDto>;
}

@Injectable({
    providedIn: 'root'
})
export class NotificationEmailPreferencesHttpService implements INotificationEmailPreferencesHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<NotificationEmailPreferencesDto> {
        let url_ = this.baseUrl + "/api/account/notification-email-preferences";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationEmailPreferencesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationEmailPreferencesDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NotificationEmailPreferencesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotificationEmailPreferencesDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    put(request: NotificationEmailPreferencesDto): Observable<NotificationEmailPreferencesDto> {
        let url_ = this.baseUrl + "/api/account/notification-email-preferences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationEmailPreferencesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationEmailPreferencesDto>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<NotificationEmailPreferencesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotificationEmailPreferencesDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * What a daily digest prepared now would send the caller (N5), rendered by the digest's own renderer. Read-only:
    no ledger entry, window, claim or preference write, and nothing is sent. 503 while an authority read is unavailable.
     */
    digestPreview(): Observable<NotificationDigestPreviewDto> {
        let url_ = this.baseUrl + "/api/account/notification-email-preferences/digest-preview";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDigestPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDigestPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationDigestPreviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationDigestPreviewDto>;
        }));
    }

    protected processDigestPreview(response: HttpResponseBase): Observable<NotificationDigestPreviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotificationDigestPreviewDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface INotificationsHttpService {
    /**
     * One page of the caller's inbox, newest first. Omit cursor for the first page; pass the previous
    page's NextCursor for the next. Keyset paging: items saved while the caller
    browses appear on the first page and never repeat or displace items on later pages. The page carries the unread
    count, so a client showing the list needs no separate Count request.
     * @param cursor (optional) 
     * @param limit (optional) 
     * @param status (optional) Which items (the tabs): all (the default: every open item, that is not dismissed, openable, not resolved and
    not an answered workflow), unread (exactly the items the unread count counts: unread, unresolved, not
    dismissed, openable and not an answered workflow), resolved (not dismissed, openable, and resolved or an
    answered workflow) or dismissed (dismissed, plus every item the caller can no longer open, which is
    dismissed automatically at read time). All and Resolved split the open items between them (N4; Chris, 28 October
    2026: answered invitations leave the bell panel and All and live under Resolved). Anything else is 400.

    Openability is decided per item by its kind's resolver, so a page is filled by reading the caller's rows in list
    order and keeping the matching ones: the cursor is the last row examined (so paging never repeats or skips a
    row), and one request examines at most 500 rows (MaxExaminedPerPage), returning fewer items with
    hasMore when it stops early (N3).
     */
    list(cursor?: string | null | undefined, limit?: number | undefined, status?: string | null | undefined): Observable<NotificationPageDto>;
    /**
     * The unread count: unread, unresolved, not dismissed and available to the caller now (C15 v2 "Per-recipient state";
    owner decisions 1 and 2).
     */
    count(): Observable<NotificationCountDto>;
    get(id: string): Observable<NotificationDto>;
    markRead(id: string): Observable<FileResponse>;
    /**
     * Mark as unread (N3): clears the caller's read time on one of their notices. Idempotent (204 when already unread);
    404 when the caller has no such notice. It returns to the unread count only when it is also unresolved, not
    dismissed and available (N2's rule); nothing else changes.
     */
    markUnread(id: string): Observable<FileResponse>;
    /**
     * Mark all as read (N3): marks the notices the caller is shown (1 to MaxClearAll IDs, the client's
    visible items, like Clear all) read. Only the caller's own unread notices change; another person's or an unknown ID
    is ignored (no existence is disclosed). Idempotent. Reading never resolves, dismisses or answers anything.
     */
    markAllRead(request: NotificationMarkAllReadDto): Observable<NotificationMarkAllReadResultDto>;
    /**
     * Dismisses one of the caller's notices (personal, N2): it stays in history (the dismissed list), leaves the
    unread count and the default list, and never changes the related workflow (an invitation stays pending).
    Idempotent: a repeat keeps the first dismissal and answers 204. 404 when the caller has no such notice.
     */
    dismiss(id: string): Observable<FileResponse>;
    /**
     * Restores one of the caller's dismissed notices to the default list (and, if it is still unread, unresolved and
    available, to the unread count). Idempotent: restoring one that is not dismissed answers 204. 404 when the caller
    has no such notice.
     */
    restore(id: string): Observable<FileResponse>;
    /**
     * Clear all: dismisses the notices the caller is shown (1 to MaxClearAll IDs, the client's visible
    items, so a notice that arrived after the client drew its list is never cleared unseen). Only the caller's own,
    not yet dismissed notices change; another person's or an unknown ID is ignored (no existence is disclosed).
    Idempotent. Undo restores the same IDs one by one.
     */
    clearAll(request: NotificationClearAllDto): Observable<NotificationClearAllResultDto>;
}

@Injectable({
    providedIn: 'root'
})
export class NotificationsHttpService implements INotificationsHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * One page of the caller's inbox, newest first. Omit cursor for the first page; pass the previous
    page's NextCursor for the next. Keyset paging: items saved while the caller
    browses appear on the first page and never repeat or displace items on later pages. The page carries the unread
    count, so a client showing the list needs no separate Count request.
     * @param cursor (optional) 
     * @param limit (optional) 
     * @param status (optional) Which items (the tabs): all (the default: every open item, that is not dismissed, openable, not resolved and
    not an answered workflow), unread (exactly the items the unread count counts: unread, unresolved, not
    dismissed, openable and not an answered workflow), resolved (not dismissed, openable, and resolved or an
    answered workflow) or dismissed (dismissed, plus every item the caller can no longer open, which is
    dismissed automatically at read time). All and Resolved split the open items between them (N4; Chris, 28 October
    2026: answered invitations leave the bell panel and All and live under Resolved). Anything else is 400.

    Openability is decided per item by its kind's resolver, so a page is filled by reading the caller's rows in list
    order and keeping the matching ones: the cursor is the last row examined (so paging never repeats or skips a
    row), and one request examines at most 500 rows (MaxExaminedPerPage), returning fewer items with
    hasMore when it stops early (N3).
     */
    list(cursor?: string | null | undefined, limit?: number | undefined, status?: string | null | undefined): Observable<NotificationPageDto> {
        let url_ = this.baseUrl + "/api/account/notifications?";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationPageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationPageDto>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<NotificationPageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotificationPageDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The unread count: unread, unresolved, not dismissed and available to the caller now (C15 v2 "Per-recipient state";
    owner decisions 1 and 2).
     */
    count(): Observable<NotificationCountDto> {
        let url_ = this.baseUrl + "/api/account/notifications/unread-count";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationCountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationCountDto>;
        }));
    }

    protected processCount(response: HttpResponseBase): Observable<NotificationCountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotificationCountDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id: string): Observable<NotificationDto> {
        let url_ = this.baseUrl + "/api/account/notifications/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NotificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotificationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    markRead(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/account/notifications/{id}/read";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMarkRead(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Mark as unread (N3): clears the caller's read time on one of their notices. Idempotent (204 when already unread);
    404 when the caller has no such notice. It returns to the unread count only when it is also unresolved, not
    dismissed and available (N2's rule); nothing else changes.
     */
    markUnread(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/account/notifications/{id}/read";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkUnread(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkUnread(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMarkUnread(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Mark all as read (N3): marks the notices the caller is shown (1 to MaxClearAll IDs, the client's
    visible items, like Clear all) read. Only the caller's own unread notices change; another person's or an unknown ID
    is ignored (no existence is disclosed). Idempotent. Reading never resolves, dismisses or answers anything.
     */
    markAllRead(request: NotificationMarkAllReadDto): Observable<NotificationMarkAllReadResultDto> {
        let url_ = this.baseUrl + "/api/account/notifications/read";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAllRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAllRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationMarkAllReadResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationMarkAllReadResultDto>;
        }));
    }

    protected processMarkAllRead(response: HttpResponseBase): Observable<NotificationMarkAllReadResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotificationMarkAllReadResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Dismisses one of the caller's notices (personal, N2): it stays in history (the dismissed list), leaves the
    unread count and the default list, and never changes the related workflow (an invitation stays pending).
    Idempotent: a repeat keeps the first dismissal and answers 204. 404 when the caller has no such notice.
     */
    dismiss(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/account/notifications/{id}/dismissed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDismiss(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDismiss(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDismiss(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Restores one of the caller's dismissed notices to the default list (and, if it is still unread, unresolved and
    available, to the unread count). Idempotent: restoring one that is not dismissed answers 204. 404 when the caller
    has no such notice.
     */
    restore(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/account/notifications/{id}/dismissed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processRestore(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Clear all: dismisses the notices the caller is shown (1 to MaxClearAll IDs, the client's visible
    items, so a notice that arrived after the client drew its list is never cleared unseen). Only the caller's own,
    not yet dismissed notices change; another person's or an unknown ID is ignored (no existence is disclosed).
    Idempotent. Undo restores the same IDs one by one.
     */
    clearAll(request: NotificationClearAllDto): Observable<NotificationClearAllResultDto> {
        let url_ = this.baseUrl + "/api/account/notifications/dismissed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationClearAllResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationClearAllResultDto>;
        }));
    }

    protected processClearAll(response: HttpResponseBase): Observable<NotificationClearAllResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotificationClearAllResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectHttpService {
    getKeywords(): Observable<{ [key: string]: number; }>;
    createProject(createProjectDto: CreateProjectDto): Observable<ProjectWithRelatedInvestigatorsDto>;
    getAllProjects(): Observable<ProjectsWithRelatedInvestigatorsDto>;
    validateProjectName(title?: string | undefined): Observable<boolean>;
    getProject(projectId: string): Observable<ProjectWithRelatedInvestigatorsDto>;
    updateProject(projectId: string, patchDoc: Operation[]): Observable<ProjectWithRelatedInvestigatorsDto>;
    deleteProject(projectId: string): Observable<ProjectFullDto>;
    setProjectFavourite(projectId: string, isFavourite: boolean): Observable<InvestigatorUsageDto>;
    setStageFavourite(projectId: string, stageId: string, isFavourite: boolean): Observable<InvestigatorUsageDto>;
    recordStageAccess(projectId: string, stageId: string): Observable<InvestigatorUsageDto>;
    updateStudyInclusionInfoForProject(projectId: string, replaceExisting?: boolean | undefined): Observable<InclusionInfoUpdateResults>;
    updateAllStudyInclusionInfoForProjects(replaceExisting?: boolean | undefined): Observable<UpdateResultsByProject>;
    requestToJoin(projectId: string, requestMessage?: string | undefined): Observable<JoinRequestResponseDto>;
    cancelJoinRequest(projectId: string): Observable<JoinRequestResponseDto>;
    approveJoinRequests(projectId: string, acceptJoinRequestsDto: AcceptJoinRequestsDto): Observable<ProjectStandardDto>;
    declineJoinRequests(projectId: string, acceptJoinRequestsDto: DeclineJoinRequestsDto): Observable<ProjectStandardDto>;
    inviteMembers(projectId: string, newInvitationsDto: NewInvitationsDto): Observable<InviteMembersResponseDto>;
    retrieveInvitation(token: string): Observable<ProjectWithInvitationAndRelatedInvestigatorsDto>;
    respondToInvitation(projectId: string, invitationResponseDto: InvitationResponseDto): Observable<ProjectWithRelatedInvestigatorsDto>;
    resendInvitationsBulk(projectId: string, resendInvitationsDto: ResendInvitationsDto): Observable<ProjectStandardDto>;
    revokeInvitationsBulk(projectId: string, inviteeEmailsToRevoke: string[]): Observable<ProjectStandardDto>;
    updateInvitationGroupsBulk(projectId: string, updateInvitationGroupsDto: UpdateInvitationGroupsDto): Observable<void>;
    repositionAnnotationQuestion(projectId: string, questionId: string, questionAtDestinationId: string): Observable<AnnotationQuestionDto[]>;
    upsertQuestion(projectId: string, questionId: string, questionUpdatesDto: UpsertCustomAnnotationQuestionDto): Observable<AnnotationQuestionDto[]>;
    deleteQuestion(projectId: string, questionId: string): Observable<StageDto[]>;
    copyQuestion(projectId: string, questionId: string, recursive?: boolean | undefined): Observable<CopyQuestionSuccessDto>;
    updateAnnotationAnswerTally(projectId: string): Observable<void>;
    addStage(projectId: string, stageDto: CreateStageDto): Observable<StageDto>;
    updateStage(projectId: string, stageId: string, patchDoc: Operation[]): Observable<StageDto>;
    updateStageQuestions(projectId: string, stageId: string, updatedAnnotationQuestionIds: string[]): Observable<void>;
    /**
     * Writes (or clears) the project-level default "Guidance for reviewers" text for one
    annotation category (revision-2 README §6.5). Entity classes and their categories are
    project-level, so this is where guidance is normally defined; a stage may override any
    category through the stage endpoint. Stored on the project's annotation configuration and
    versioned with the rest of the annotation setup through the project schema version. An
    empty or whitespace-only body value removes the default.
     */
    updateProjectCategoryGuidance(projectId: string, update: ProjectCategoryGuidanceUpdateDto): Observable<ProjectCategoryGuidanceDto>;
    /**
     * Replaces the project's screening inclusion and exclusion keyword lists (FEAT-025). The
    lists drive visual highlighting in the integrated PDF viewer only and never affect a
    screening decision. Returns the normalised lists; an invalid pair (a term over 100
    characters, a list over 200 terms, or a term in both lists) is a 400 and changes nothing.
    Not routable while the screeningKeywordHighlighting flag is off.
     */
    updateProjectScreeningKeywords(projectId: string, update: ScreeningKeywordsUpdateDto): Observable<ScreeningKeywordsDto>;
    /**
     * Writes (or clears) the administrator's "Guidance for reviewers" text for one annotation
    category on one stage (revision-2 README §6.5). The guidance is stored per stage on the
    stage's annotation configuration and is versioned with the rest of the annotation setup
    through the project schema version; it has no version of its own. An empty or
    whitespace-only body value removes the entry.
     */
    updateStageCategoryGuidance(projectId: string, stageId: string, update: StageCategoryGuidanceUpdateDto): Observable<StageDto>;
    getInvestigators(projectId: string): Observable<MembershipSummaryDto[]>;
    updateMemberships(projectId: string, updateProjectMembershipsDto: UpdateProjectMembershipsDto): Observable<void>;
    getProjectScreeningStats(projectId: string): Observable<ProjectScreeningStats>;
    getFullStats(projectId?: string | undefined): Observable<FullStats>;
    getInvestigator(projectId: string, investigatorId: string): Observable<MembershipSummaryDto>;
    updateMembership(projectId: string, investigatorId: string, projectGroupIds: string[]): Observable<void>;
    disableMembership(projectId: string, investigatorId: string): Observable<void>;
    enableMembership(projectId: string, investigatorId: string): Observable<void>;
    updateStagePermissions(projectId: string, stageId: string, updateStagePermissionDtos: UpdateStagePermissionDto[]): Observable<StageDto>;
    updateProjectPermissions(projectId: string, updateProjectPermissionDtos: UpdateProjectPermissionDto[]): Observable<ProjectDetailsDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectHttpService implements IProjectHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getKeywords(): Observable<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/api/projects/keywords";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKeywords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKeywords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: number; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: number; }>;
        }));
    }

    protected processGetKeywords(response: HttpResponseBase): Observable<{ [key: string]: number; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: number; };
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createProject(createProjectDto: CreateProjectDto): Observable<ProjectWithRelatedInvestigatorsDto> {
        let url_ = this.baseUrl + "/api/projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createProjectDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectWithRelatedInvestigatorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectWithRelatedInvestigatorsDto>;
        }));
    }

    protected processCreateProject(response: HttpResponseBase): Observable<ProjectWithRelatedInvestigatorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectWithRelatedInvestigatorsDto;
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllProjects(): Observable<ProjectsWithRelatedInvestigatorsDto> {
        let url_ = this.baseUrl + "/api/projects";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectsWithRelatedInvestigatorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectsWithRelatedInvestigatorsDto>;
        }));
    }

    protected processGetAllProjects(response: HttpResponseBase): Observable<ProjectsWithRelatedInvestigatorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectsWithRelatedInvestigatorsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    validateProjectName(title?: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/projects/validateName?";
        if (title === null)
            throw new Error("The parameter 'title' cannot be null.");
        else if (title !== undefined)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateProjectName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateProjectName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processValidateProjectName(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProject(projectId: string): Observable<ProjectWithRelatedInvestigatorsDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectWithRelatedInvestigatorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectWithRelatedInvestigatorsDto>;
        }));
    }

    protected processGetProject(response: HttpResponseBase): Observable<ProjectWithRelatedInvestigatorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectWithRelatedInvestigatorsDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateProject(projectId: string, patchDoc: Operation[]): Observable<ProjectWithRelatedInvestigatorsDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patchDoc);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectWithRelatedInvestigatorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectWithRelatedInvestigatorsDto>;
        }));
    }

    protected processUpdateProject(response: HttpResponseBase): Observable<ProjectWithRelatedInvestigatorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectWithRelatedInvestigatorsDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: any; };
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteProject(projectId: string): Observable<ProjectFullDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectFullDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectFullDto>;
        }));
    }

    protected processDeleteProject(response: HttpResponseBase): Observable<ProjectFullDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectFullDto;
            return _observableOf(result200);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setProjectFavourite(projectId: string, isFavourite: boolean): Observable<InvestigatorUsageDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/favourite";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(isFavourite);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetProjectFavourite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetProjectFavourite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvestigatorUsageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvestigatorUsageDto>;
        }));
    }

    protected processSetProjectFavourite(response: HttpResponseBase): Observable<InvestigatorUsageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InvestigatorUsageDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setStageFavourite(projectId: string, stageId: string, isFavourite: boolean): Observable<InvestigatorUsageDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}/favourite";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(isFavourite);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetStageFavourite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetStageFavourite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvestigatorUsageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvestigatorUsageDto>;
        }));
    }

    protected processSetStageFavourite(response: HttpResponseBase): Observable<InvestigatorUsageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InvestigatorUsageDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    recordStageAccess(projectId: string, stageId: string): Observable<InvestigatorUsageDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}/access";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecordStageAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecordStageAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvestigatorUsageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvestigatorUsageDto>;
        }));
    }

    protected processRecordStageAccess(response: HttpResponseBase): Observable<InvestigatorUsageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InvestigatorUsageDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateStudyInclusionInfoForProject(projectId: string, replaceExisting?: boolean | undefined): Observable<InclusionInfoUpdateResults> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/update-study-inclusion";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(replaceExisting);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStudyInclusionInfoForProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStudyInclusionInfoForProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InclusionInfoUpdateResults>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InclusionInfoUpdateResults>;
        }));
    }

    protected processUpdateStudyInclusionInfoForProject(response: HttpResponseBase): Observable<InclusionInfoUpdateResults> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InclusionInfoUpdateResults;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAllStudyInclusionInfoForProjects(replaceExisting?: boolean | undefined): Observable<UpdateResultsByProject> {
        let url_ = this.baseUrl + "/api/projects/update-all-study-inclusion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(replaceExisting);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllStudyInclusionInfoForProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllStudyInclusionInfoForProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResultsByProject>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResultsByProject>;
        }));
    }

    protected processUpdateAllStudyInclusionInfoForProjects(response: HttpResponseBase): Observable<UpdateResultsByProject> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateResultsByProject;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    requestToJoin(projectId: string, requestMessage?: string | undefined): Observable<JoinRequestResponseDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/join-requests";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestMessage);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestToJoin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestToJoin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JoinRequestResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JoinRequestResponseDto>;
        }));
    }

    protected processRequestToJoin(response: HttpResponseBase): Observable<JoinRequestResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JoinRequestResponseDto;
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JoinRequestResponseDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancelJoinRequest(projectId: string): Observable<JoinRequestResponseDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/join-requests";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelJoinRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelJoinRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JoinRequestResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JoinRequestResponseDto>;
        }));
    }

    protected processCancelJoinRequest(response: HttpResponseBase): Observable<JoinRequestResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JoinRequestResponseDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JoinRequestResponseDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    approveJoinRequests(projectId: string, acceptJoinRequestsDto: AcceptJoinRequestsDto): Observable<ProjectStandardDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/join-requests/approve";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(acceptJoinRequestsDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveJoinRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveJoinRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStandardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStandardDto>;
        }));
    }

    protected processApproveJoinRequests(response: HttpResponseBase): Observable<ProjectStandardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStandardDto;
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    declineJoinRequests(projectId: string, acceptJoinRequestsDto: DeclineJoinRequestsDto): Observable<ProjectStandardDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/join-requests/decline";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(acceptJoinRequestsDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeclineJoinRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeclineJoinRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStandardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStandardDto>;
        }));
    }

    protected processDeclineJoinRequests(response: HttpResponseBase): Observable<ProjectStandardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStandardDto;
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    inviteMembers(projectId: string, newInvitationsDto: NewInvitationsDto): Observable<InviteMembersResponseDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/invitations";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newInvitationsDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInviteMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInviteMembers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InviteMembersResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InviteMembersResponseDto>;
        }));
    }

    protected processInviteMembers(response: HttpResponseBase): Observable<InviteMembersResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InviteMembersResponseDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    retrieveInvitation(token: string): Observable<ProjectWithInvitationAndRelatedInvestigatorsDto> {
        let url_ = this.baseUrl + "/api/projects/invitations/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveInvitation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveInvitation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectWithInvitationAndRelatedInvestigatorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectWithInvitationAndRelatedInvestigatorsDto>;
        }));
    }

    protected processRetrieveInvitation(response: HttpResponseBase): Observable<ProjectWithInvitationAndRelatedInvestigatorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectWithInvitationAndRelatedInvestigatorsDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    respondToInvitation(projectId: string, invitationResponseDto: InvitationResponseDto): Observable<ProjectWithRelatedInvestigatorsDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/invitations/respond";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invitationResponseDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRespondToInvitation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRespondToInvitation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectWithRelatedInvestigatorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectWithRelatedInvestigatorsDto>;
        }));
    }

    protected processRespondToInvitation(response: HttpResponseBase): Observable<ProjectWithRelatedInvestigatorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectWithRelatedInvestigatorsDto;
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resendInvitationsBulk(projectId: string, resendInvitationsDto: ResendInvitationsDto): Observable<ProjectStandardDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/invitations/resend";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resendInvitationsDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendInvitationsBulk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendInvitationsBulk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStandardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStandardDto>;
        }));
    }

    protected processResendInvitationsBulk(response: HttpResponseBase): Observable<ProjectStandardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStandardDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    revokeInvitationsBulk(projectId: string, inviteeEmailsToRevoke: string[]): Observable<ProjectStandardDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/invitations/revoke";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inviteeEmailsToRevoke);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRevokeInvitationsBulk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevokeInvitationsBulk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStandardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStandardDto>;
        }));
    }

    protected processRevokeInvitationsBulk(response: HttpResponseBase): Observable<ProjectStandardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStandardDto;
            return _observableOf(result202);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateInvitationGroupsBulk(projectId: string, updateInvitationGroupsDto: UpdateInvitationGroupsDto): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/invitations/updateGroups";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateInvitationGroupsDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInvitationGroupsBulk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInvitationGroupsBulk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateInvitationGroupsBulk(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    repositionAnnotationQuestion(projectId: string, questionId: string, questionAtDestinationId: string): Observable<AnnotationQuestionDto[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/annotationQuestion/{questionId}/{questionAtDestinationId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        if (questionAtDestinationId === undefined || questionAtDestinationId === null)
            throw new Error("The parameter 'questionAtDestinationId' must be defined.");
        url_ = url_.replace("{questionAtDestinationId}", encodeURIComponent("" + questionAtDestinationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRepositionAnnotationQuestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRepositionAnnotationQuestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AnnotationQuestionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AnnotationQuestionDto[]>;
        }));
    }

    protected processRepositionAnnotationQuestion(response: HttpResponseBase): Observable<AnnotationQuestionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AnnotationQuestionDto[];
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    upsertQuestion(projectId: string, questionId: string, questionUpdatesDto: UpsertCustomAnnotationQuestionDto): Observable<AnnotationQuestionDto[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/annotationQuestion/{questionId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(questionUpdatesDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertQuestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertQuestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AnnotationQuestionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AnnotationQuestionDto[]>;
        }));
    }

    protected processUpsertQuestion(response: HttpResponseBase): Observable<AnnotationQuestionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AnnotationQuestionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteQuestion(projectId: string, questionId: string): Observable<StageDto[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/annotationQuestion/{questionId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteQuestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteQuestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StageDto[]>;
        }));
    }

    protected processDeleteQuestion(response: HttpResponseBase): Observable<StageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StageDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    copyQuestion(projectId: string, questionId: string, recursive?: boolean | undefined): Observable<CopyQuestionSuccessDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/annotationQuestion/{questionId}/copy?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        if (recursive === null)
            throw new Error("The parameter 'recursive' cannot be null.");
        else if (recursive !== undefined)
            url_ += "recursive=" + encodeURIComponent("" + recursive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyQuestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyQuestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CopyQuestionSuccessDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CopyQuestionSuccessDto>;
        }));
    }

    protected processCopyQuestion(response: HttpResponseBase): Observable<CopyQuestionSuccessDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CopyQuestionSuccessDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAnnotationAnswerTally(projectId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/update-annotation-answer-tally";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAnnotationAnswerTally(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAnnotationAnswerTally(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAnnotationAnswerTally(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addStage(projectId: string, stageDto: CreateStageDto): Observable<StageDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stageDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddStage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StageDto>;
        }));
    }

    protected processAddStage(response: HttpResponseBase): Observable<StageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StageDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateStage(projectId: string, stageId: string, patchDoc: Operation[]): Observable<StageDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patchDoc);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StageDto>;
        }));
    }

    protected processUpdateStage(response: HttpResponseBase): Observable<StageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StageDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: any; };
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateStageQuestions(projectId: string, stageId: string, updatedAnnotationQuestionIds: string[]): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}/questions";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatedAnnotationQuestionIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStageQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStageQuestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateStageQuestions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Writes (or clears) the project-level default "Guidance for reviewers" text for one
    annotation category (revision-2 README §6.5). Entity classes and their categories are
    project-level, so this is where guidance is normally defined; a stage may override any
    category through the stage endpoint. Stored on the project's annotation configuration and
    versioned with the rest of the annotation setup through the project schema version. An
    empty or whitespace-only body value removes the default.
     */
    updateProjectCategoryGuidance(projectId: string, update: ProjectCategoryGuidanceUpdateDto): Observable<ProjectCategoryGuidanceDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/category-guidance";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(update);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProjectCategoryGuidance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProjectCategoryGuidance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectCategoryGuidanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectCategoryGuidanceDto>;
        }));
    }

    protected processUpdateProjectCategoryGuidance(response: HttpResponseBase): Observable<ProjectCategoryGuidanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectCategoryGuidanceDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Replaces the project's screening inclusion and exclusion keyword lists (FEAT-025). The
    lists drive visual highlighting in the integrated PDF viewer only and never affect a
    screening decision. Returns the normalised lists; an invalid pair (a term over 100
    characters, a list over 200 terms, or a term in both lists) is a 400 and changes nothing.
    Not routable while the screeningKeywordHighlighting flag is off.
     */
    updateProjectScreeningKeywords(projectId: string, update: ScreeningKeywordsUpdateDto): Observable<ScreeningKeywordsDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/screening-keywords";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(update);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProjectScreeningKeywords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProjectScreeningKeywords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScreeningKeywordsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScreeningKeywordsDto>;
        }));
    }

    protected processUpdateProjectScreeningKeywords(response: HttpResponseBase): Observable<ScreeningKeywordsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScreeningKeywordsDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Writes (or clears) the administrator's "Guidance for reviewers" text for one annotation
    category on one stage (revision-2 README §6.5). The guidance is stored per stage on the
    stage's annotation configuration and is versioned with the rest of the annotation setup
    through the project schema version; it has no version of its own. An empty or
    whitespace-only body value removes the entry.
     */
    updateStageCategoryGuidance(projectId: string, stageId: string, update: StageCategoryGuidanceUpdateDto): Observable<StageDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}/category-guidance";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(update);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStageCategoryGuidance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStageCategoryGuidance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StageDto>;
        }));
    }

    protected processUpdateStageCategoryGuidance(response: HttpResponseBase): Observable<StageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StageDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInvestigators(projectId: string): Observable<MembershipSummaryDto[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/investigators";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvestigators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvestigators(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MembershipSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MembershipSummaryDto[]>;
        }));
    }

    protected processGetInvestigators(response: HttpResponseBase): Observable<MembershipSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MembershipSummaryDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateMemberships(projectId: string, updateProjectMembershipsDto: UpdateProjectMembershipsDto): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/investigators";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateProjectMembershipsDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMemberships(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMemberships(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMemberships(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProjectScreeningStats(projectId: string): Observable<ProjectScreeningStats> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/screening-stats";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectScreeningStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectScreeningStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectScreeningStats>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectScreeningStats>;
        }));
    }

    protected processGetProjectScreeningStats(response: HttpResponseBase): Observable<ProjectScreeningStats> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectScreeningStats;
            return _observableOf(result200);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFullStats(projectId?: string | undefined): Observable<FullStats> {
        let url_ = this.baseUrl + "/api/projects/full-stats?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFullStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFullStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FullStats>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FullStats>;
        }));
    }

    protected processGetFullStats(response: HttpResponseBase): Observable<FullStats> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FullStats;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInvestigator(projectId: string, investigatorId: string): Observable<MembershipSummaryDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/investigators/{investigatorId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (investigatorId === undefined || investigatorId === null)
            throw new Error("The parameter 'investigatorId' must be defined.");
        url_ = url_.replace("{investigatorId}", encodeURIComponent("" + investigatorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvestigator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvestigator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MembershipSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MembershipSummaryDto>;
        }));
    }

    protected processGetInvestigator(response: HttpResponseBase): Observable<MembershipSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MembershipSummaryDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateMembership(projectId: string, investigatorId: string, projectGroupIds: string[]): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/investigators/{investigatorId}/groups";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (investigatorId === undefined || investigatorId === null)
            throw new Error("The parameter 'investigatorId' must be defined.");
        url_ = url_.replace("{investigatorId}", encodeURIComponent("" + investigatorId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(projectGroupIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMembership(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMembership(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMembership(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    disableMembership(projectId: string, investigatorId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/investigators/{investigatorId}/disable";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (investigatorId === undefined || investigatorId === null)
            throw new Error("The parameter 'investigatorId' must be defined.");
        url_ = url_.replace("{investigatorId}", encodeURIComponent("" + investigatorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableMembership(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableMembership(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisableMembership(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    enableMembership(projectId: string, investigatorId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/investigators/{investigatorId}/enable";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (investigatorId === undefined || investigatorId === null)
            throw new Error("The parameter 'investigatorId' must be defined.");
        url_ = url_.replace("{investigatorId}", encodeURIComponent("" + investigatorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableMembership(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableMembership(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnableMembership(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateStagePermissions(projectId: string, stageId: string, updateStagePermissionDtos: UpdateStagePermissionDto[]): Observable<StageDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}/permissions";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateStagePermissionDtos);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStagePermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStagePermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StageDto>;
        }));
    }

    protected processUpdateStagePermissions(response: HttpResponseBase): Observable<StageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StageDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateProjectPermissions(projectId: string, updateProjectPermissionDtos: UpdateProjectPermissionDto[]): Observable<ProjectDetailsDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/permissions";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateProjectPermissionDtos);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProjectPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProjectPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDetailsDto>;
        }));
    }

    protected processUpdateProjectPermissions(response: HttpResponseBase): Observable<ProjectDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectStatisticsAdminHttpService {
    /**
     * Rebuilds every screening scope this project's family declares, skipping any scope whose
    published row already matches the authoritative calculation. Re-running it on a complete
    project is a no-op.
     */
    backfill(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto>;
    /**
     * The same operation, forcing every scope to be recalculated and republished even when its
    published row already matches. Used to repair a projection that is suspected of drift.
     */
    rebuild(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto>;
    /**
     * The membership-screening family's idempotent pass: every scope whose published row already
    matches the authoritative calculation is skipped. This is the ordinary operational trigger —
    the forced variant below replaces the established configuration identity, so it must not be
    the only way to run a reviewer family.
     */
    backfillMembership(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto>;
    rebuildMembership(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto>;
    /**
     * The reviewer-screening family's idempotent pass. See BackfillMembership.
     */
    backfillReviewer(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto>;
    rebuildReviewer(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto>;
    backfillSearchPopulation(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto>;
    rebuildSearchPopulation(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto>;
    /**
     * The stage-annotation family's idempotent pass: one scope per stage, and every
    scope whose published row already matches the authoritative calculation is skipped. This is
    the entry point that lets an operator establish the Fresh baseline the Stage Overview
    annotation pie serves; until it existed the family had a read path and no way to populate it.
     */
    backfillStageAnnotation(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto>;
    /**
     * The same operation forced. See Rebuild.
     */
    rebuildStageAnnotation(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto>;
    /**
     * Builds current annotation counters for each authoritative membership/stage pair.
     */
    backfillMembershipStageAnnotation(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto>;
    /**
     * The same operation forced. See Rebuild.
     */
    rebuildMembershipStageAnnotation(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto>;
    /**
     * Rebuild answered project-question scopes from pinned authoritative data.
     */
    backfillQuestionAnswers(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto>;
    /**
     * The same operation forced. See Rebuild.
     */
    rebuildQuestionAnswers(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto>;
    /**
     * Build the stage-level reconciliation baseline from the authoritative stage calculation.
     */
    backfillDomainReconciliation(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto>;
    /**
     * The same operation forced. See Rebuild.
     */
    rebuildDomainReconciliation(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto>;
    /**
     * Build the reviewer-stage annotation baseline for a project.
     */
    backfillReviewerAnnotation(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto>;
    /**
     * The same operation forced. See Rebuild.
     */
    rebuildReviewerAnnotation(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectStatisticsAdminHttpService implements IProjectStatisticsAdminHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Rebuilds every screening scope this project's family declares, skipping any scope whose
    published row already matches the authoritative calculation. Re-running it on a complete
    project is a no-op.
     */
    backfill(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/backfill";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBackfill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBackfill(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
        }));
    }

    protected processBackfill(response: HttpResponseBase): Observable<ProjectStatisticsBackfillSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsBackfillSummaryDto;
            return _observableOf(result202);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The same operation, forcing every scope to be recalculated and republished even when its
    published row already matches. Used to repair a projection that is suspected of drift.
     */
    rebuild(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/rebuild";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRebuild(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRebuild(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
        }));
    }

    protected processRebuild(response: HttpResponseBase): Observable<ProjectStatisticsBackfillSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsBackfillSummaryDto;
            return _observableOf(result202);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The membership-screening family's idempotent pass: every scope whose published row already
    matches the authoritative calculation is skipped. This is the ordinary operational trigger —
    the forced variant below replaces the established configuration identity, so it must not be
    the only way to run a reviewer family.
     */
    backfillMembership(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/membership-screening/backfill";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBackfillMembership(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBackfillMembership(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
        }));
    }

    protected processBackfillMembership(response: HttpResponseBase): Observable<ProjectStatisticsBackfillSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsBackfillSummaryDto;
            return _observableOf(result202);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rebuildMembership(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/membership-screening/rebuild";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRebuildMembership(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRebuildMembership(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
        }));
    }

    protected processRebuildMembership(response: HttpResponseBase): Observable<ProjectStatisticsBackfillSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsBackfillSummaryDto;
            return _observableOf(result202);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The reviewer-screening family's idempotent pass. See BackfillMembership.
     */
    backfillReviewer(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/reviewer-screening/backfill";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBackfillReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBackfillReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
        }));
    }

    protected processBackfillReviewer(response: HttpResponseBase): Observable<ProjectStatisticsBackfillSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsBackfillSummaryDto;
            return _observableOf(result202);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rebuildReviewer(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/reviewer-screening/rebuild";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRebuildReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRebuildReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
        }));
    }

    protected processRebuildReviewer(response: HttpResponseBase): Observable<ProjectStatisticsBackfillSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsBackfillSummaryDto;
            return _observableOf(result202);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    backfillSearchPopulation(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/search-population/backfill";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBackfillSearchPopulation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBackfillSearchPopulation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
        }));
    }

    protected processBackfillSearchPopulation(response: HttpResponseBase): Observable<ProjectStatisticsBackfillSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsBackfillSummaryDto;
            return _observableOf(result202);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rebuildSearchPopulation(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/search-population/rebuild";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRebuildSearchPopulation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRebuildSearchPopulation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
        }));
    }

    protected processRebuildSearchPopulation(response: HttpResponseBase): Observable<ProjectStatisticsBackfillSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsBackfillSummaryDto;
            return _observableOf(result202);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The stage-annotation family's idempotent pass: one scope per stage, and every
    scope whose published row already matches the authoritative calculation is skipped. This is
    the entry point that lets an operator establish the Fresh baseline the Stage Overview
    annotation pie serves; until it existed the family had a read path and no way to populate it.
     */
    backfillStageAnnotation(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/stage-annotation/backfill";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBackfillStageAnnotation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBackfillStageAnnotation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
        }));
    }

    protected processBackfillStageAnnotation(response: HttpResponseBase): Observable<ProjectStatisticsBackfillSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsBackfillSummaryDto;
            return _observableOf(result202);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The same operation forced. See Rebuild.
     */
    rebuildStageAnnotation(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/stage-annotation/rebuild";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRebuildStageAnnotation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRebuildStageAnnotation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
        }));
    }

    protected processRebuildStageAnnotation(response: HttpResponseBase): Observable<ProjectStatisticsBackfillSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsBackfillSummaryDto;
            return _observableOf(result202);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Builds current annotation counters for each authoritative membership/stage pair.
     */
    backfillMembershipStageAnnotation(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/membership-stage-annotation/backfill";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBackfillMembershipStageAnnotation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBackfillMembershipStageAnnotation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
        }));
    }

    protected processBackfillMembershipStageAnnotation(response: HttpResponseBase): Observable<ProjectStatisticsBackfillSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsBackfillSummaryDto;
            return _observableOf(result202);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The same operation forced. See Rebuild.
     */
    rebuildMembershipStageAnnotation(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/membership-stage-annotation/rebuild";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRebuildMembershipStageAnnotation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRebuildMembershipStageAnnotation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
        }));
    }

    protected processRebuildMembershipStageAnnotation(response: HttpResponseBase): Observable<ProjectStatisticsBackfillSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsBackfillSummaryDto;
            return _observableOf(result202);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Rebuild answered project-question scopes from pinned authoritative data.
     */
    backfillQuestionAnswers(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/question-answers/backfill";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBackfillQuestionAnswers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBackfillQuestionAnswers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
        }));
    }

    protected processBackfillQuestionAnswers(response: HttpResponseBase): Observable<ProjectStatisticsBackfillSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsBackfillSummaryDto;
            return _observableOf(result202);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The same operation forced. See Rebuild.
     */
    rebuildQuestionAnswers(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/question-answers/rebuild";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRebuildQuestionAnswers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRebuildQuestionAnswers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
        }));
    }

    protected processRebuildQuestionAnswers(response: HttpResponseBase): Observable<ProjectStatisticsBackfillSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsBackfillSummaryDto;
            return _observableOf(result202);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Build the stage-level reconciliation baseline from the authoritative stage calculation.
     */
    backfillDomainReconciliation(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/domain-reconciliation/backfill";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBackfillDomainReconciliation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBackfillDomainReconciliation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
        }));
    }

    protected processBackfillDomainReconciliation(response: HttpResponseBase): Observable<ProjectStatisticsBackfillSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsBackfillSummaryDto;
            return _observableOf(result202);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The same operation forced. See Rebuild.
     */
    rebuildDomainReconciliation(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/domain-reconciliation/rebuild";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRebuildDomainReconciliation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRebuildDomainReconciliation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
        }));
    }

    protected processRebuildDomainReconciliation(response: HttpResponseBase): Observable<ProjectStatisticsBackfillSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsBackfillSummaryDto;
            return _observableOf(result202);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Build the reviewer-stage annotation baseline for a project.
     */
    backfillReviewerAnnotation(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/reviewer-annotation/backfill";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBackfillReviewerAnnotation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBackfillReviewerAnnotation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
        }));
    }

    protected processBackfillReviewerAnnotation(response: HttpResponseBase): Observable<ProjectStatisticsBackfillSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsBackfillSummaryDto;
            return _observableOf(result202);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The same operation forced. See Rebuild.
     */
    rebuildReviewerAnnotation(statisticsProjectId: string): Observable<ProjectStatisticsBackfillSummaryDto> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/reviewer-annotation/rebuild";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRebuildReviewerAnnotation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRebuildReviewerAnnotation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsBackfillSummaryDto>;
        }));
    }

    protected processRebuildReviewerAnnotation(response: HttpResponseBase): Observable<ProjectStatisticsBackfillSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsBackfillSummaryDto;
            return _observableOf(result202);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectStatisticsDeltaMaintenanceHttpService {
    run(statisticsProjectId: string): Observable<ProjectStatisticsDeltaMaintenanceResult>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectStatisticsDeltaMaintenanceHttpService implements IProjectStatisticsDeltaMaintenanceHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    run(statisticsProjectId: string): Observable<ProjectStatisticsDeltaMaintenanceResult> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/delta-maintenance";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsDeltaMaintenanceResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsDeltaMaintenanceResult>;
        }));
    }

    protected processRun(response: HttpResponseBase): Observable<ProjectStatisticsDeltaMaintenanceResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsDeltaMaintenanceResult;
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectStatisticsDriftRePersistHttpService {
    /**
     * Re-persists the project's drifted Studies (all of them, or the named ones that are drifted).
     * @param statisticsProjectId The project.
     * @param request (optional) Which Studies, the confirmation and the production override.
     */
    rePersistReviewerScreeningDrift(statisticsProjectId: string, request?: ReviewerScreeningDriftRePersistBody | undefined): Observable<ReviewerScreeningDriftRePersistResult>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectStatisticsDriftRePersistHttpService implements IProjectStatisticsDriftRePersistHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Re-persists the project's drifted Studies (all of them, or the named ones that are drifted).
     * @param statisticsProjectId The project.
     * @param request (optional) Which Studies, the confirmation and the production override.
     */
    rePersistReviewerScreeningDrift(statisticsProjectId: string, request?: ReviewerScreeningDriftRePersistBody | undefined): Observable<ReviewerScreeningDriftRePersistResult> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/reviewer-screening/re-persist";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRePersistReviewerScreeningDrift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRePersistReviewerScreeningDrift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReviewerScreeningDriftRePersistResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReviewerScreeningDriftRePersistResult>;
        }));
    }

    protected processRePersistReviewerScreeningDrift(response: HttpResponseBase): Observable<ReviewerScreeningDriftRePersistResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReviewerScreeningDriftRePersistResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectStatisticsFenceDiagnosticsHttpService {
    /**
     * @param statisticsProjectId The project whose fence to report.
     * @param strandedAfterMinutes (optional) Age after which a fence with a live source job is reported stranded (1 to 10080, default 30).
    A fence with no live source job is reported stranded at any age.
     */
    getInclusionRecalculationFence(statisticsProjectId: string, strandedAfterMinutes?: number | undefined): Observable<ProjectStatisticsInclusionFenceDiagnostic>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectStatisticsFenceDiagnosticsHttpService implements IProjectStatisticsFenceDiagnosticsHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param statisticsProjectId The project whose fence to report.
     * @param strandedAfterMinutes (optional) Age after which a fence with a live source job is reported stranded (1 to 10080, default 30).
    A fence with no live source job is reported stranded at any age.
     */
    getInclusionRecalculationFence(statisticsProjectId: string, strandedAfterMinutes?: number | undefined): Observable<ProjectStatisticsInclusionFenceDiagnostic> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/inclusion-recalculation-fence?";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        if (strandedAfterMinutes === null)
            throw new Error("The parameter 'strandedAfterMinutes' cannot be null.");
        else if (strandedAfterMinutes !== undefined)
            url_ += "strandedAfterMinutes=" + encodeURIComponent("" + strandedAfterMinutes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInclusionRecalculationFence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInclusionRecalculationFence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsInclusionFenceDiagnostic>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsInclusionFenceDiagnostic>;
        }));
    }

    protected processGetInclusionRecalculationFence(response: HttpResponseBase): Observable<ProjectStatisticsInclusionFenceDiagnostic> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsInclusionFenceDiagnostic;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectStatisticsFleetHttpService {
    create(request: ProjectStatisticsFleetCreateRequest): Observable<ProjectStatisticsFleetRun>;
    get(runId: string): Observable<ProjectStatisticsFleetRun>;
    advance(runId: string): Observable<ProjectStatisticsFleetRun>;
    pause(runId: string): Observable<ProjectStatisticsFleetRun>;
    resume(runId: string): Observable<ProjectStatisticsFleetRun>;
    control(): Observable<ProjectStatisticsFleetControl>;
    prune(request: ProjectStatisticsFleetPruneRequest): Observable<ProjectStatisticsFleetPruneAudit>;
    stop(stopped: boolean): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectStatisticsFleetHttpService implements IProjectStatisticsFleetHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    create(request: ProjectStatisticsFleetCreateRequest): Observable<ProjectStatisticsFleetRun> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/fleet/runs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsFleetRun>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsFleetRun>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProjectStatisticsFleetRun> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsFleetRun;
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(runId: string): Observable<ProjectStatisticsFleetRun> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/fleet/runs/{runId}";
        if (runId === undefined || runId === null)
            throw new Error("The parameter 'runId' must be defined.");
        url_ = url_.replace("{runId}", encodeURIComponent("" + runId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsFleetRun>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsFleetRun>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProjectStatisticsFleetRun> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsFleetRun;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    advance(runId: string): Observable<ProjectStatisticsFleetRun> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/fleet/runs/{runId}/advance";
        if (runId === undefined || runId === null)
            throw new Error("The parameter 'runId' must be defined.");
        url_ = url_.replace("{runId}", encodeURIComponent("" + runId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdvance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdvance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsFleetRun>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsFleetRun>;
        }));
    }

    protected processAdvance(response: HttpResponseBase): Observable<ProjectStatisticsFleetRun> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsFleetRun;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    pause(runId: string): Observable<ProjectStatisticsFleetRun> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/fleet/runs/{runId}/pause";
        if (runId === undefined || runId === null)
            throw new Error("The parameter 'runId' must be defined.");
        url_ = url_.replace("{runId}", encodeURIComponent("" + runId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPause(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPause(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsFleetRun>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsFleetRun>;
        }));
    }

    protected processPause(response: HttpResponseBase): Observable<ProjectStatisticsFleetRun> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsFleetRun;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resume(runId: string): Observable<ProjectStatisticsFleetRun> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/fleet/runs/{runId}/resume";
        if (runId === undefined || runId === null)
            throw new Error("The parameter 'runId' must be defined.");
        url_ = url_.replace("{runId}", encodeURIComponent("" + runId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResume(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResume(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsFleetRun>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsFleetRun>;
        }));
    }

    protected processResume(response: HttpResponseBase): Observable<ProjectStatisticsFleetRun> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsFleetRun;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    control(): Observable<ProjectStatisticsFleetControl> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/fleet/control";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processControl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processControl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsFleetControl>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsFleetControl>;
        }));
    }

    protected processControl(response: HttpResponseBase): Observable<ProjectStatisticsFleetControl> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsFleetControl;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    prune(request: ProjectStatisticsFleetPruneRequest): Observable<ProjectStatisticsFleetPruneAudit> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/fleet/runs/prune";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrune(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrune(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsFleetPruneAudit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsFleetPruneAudit>;
        }));
    }

    protected processPrune(response: HttpResponseBase): Observable<ProjectStatisticsFleetPruneAudit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsFleetPruneAudit;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    stop(stopped: boolean): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/fleet/stop";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stopped);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStop(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStop(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectStatisticsFoldIndexHttpService {
    /**
     * Reports whether the pending-statistics index exists and is ready. Read-only.
     */
    getPendingIndex(): Observable<StudyPendingStatisticsIndexStatus>;
    /**
     * Idempotently builds the pending-statistics index: 200 when it is already ready, 202 while a
    build is in progress (started now or earlier), 409 when a different definition holds the name
    or the key pattern.
     */
    buildPendingIndex(): Observable<StudyPendingStatisticsIndexStatus>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectStatisticsFoldIndexHttpService implements IProjectStatisticsFoldIndexHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Reports whether the pending-statistics index exists and is ready. Read-only.
     */
    getPendingIndex(): Observable<StudyPendingStatisticsIndexStatus> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/fold/pending-index";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StudyPendingStatisticsIndexStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StudyPendingStatisticsIndexStatus>;
        }));
    }

    protected processGetPendingIndex(response: HttpResponseBase): Observable<StudyPendingStatisticsIndexStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyPendingStatisticsIndexStatus;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Idempotently builds the pending-statistics index: 200 when it is already ready, 202 while a
    build is in progress (started now or earlier), 409 when a different definition holds the name
    or the key pattern.
     */
    buildPendingIndex(): Observable<StudyPendingStatisticsIndexStatus> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/fold/pending-index";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildPendingIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildPendingIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StudyPendingStatisticsIndexStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StudyPendingStatisticsIndexStatus>;
        }));
    }

    protected processBuildPendingIndex(response: HttpResponseBase): Observable<StudyPendingStatisticsIndexStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyPendingStatisticsIndexStatus;
            return _observableOf(result200);
            }));
        } else if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyPendingStatisticsIndexStatus;
            return _observableOf(result202);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectStatisticsFoldModeHttpService {
    /**
     * The project's fold state. Read-only.
     */
    getFoldStatus(projectId: string): Observable<ProjectStatisticsFoldStatus>;
    /**
     * Enables fold mode: stamps the protocol tripwire, stales every fold family and advances the
    clocks in one transaction. Ordinary backfills then republish the families with the subtraction rule.
     */
    enableFold(projectId: string, request: ProjectStatisticsFoldEnableRequest): Observable<ProjectStatisticsFoldTransitionResult>;
    /**
     * Sets Disabling; saves take today's path from then on and the worker finalizes Disabled.
     */
    disableFold(projectId: string): Observable<ProjectStatisticsFoldTransitionResult>;
    /**
     * The guard-exit and recovery operation: re-stamps the tripwire at this binary's protocol (in fold
    mode) and stales every materialized family, SearchPopulation included.
     */
    resetFold(projectId: string): Observable<ProjectStatisticsFoldTransitionResult>;
    /**
     * Advances this project's fold-protocol stamp from the previous protocol to this binary's, exactly as the
    project-management consumer does on the fold sweep's schedule: the operator's
    ProjectStatistics:Fold:StampAdvanceAllowed, every live member declaring the protocol, a live
    fold-worker heartbeat for it and no pending entry below the previous protocol, then a compare-and-set.
    At the production baseline there is no previous protocol and the answer is NothingToAdvance.
     */
    advanceFoldStamp(projectId: string): Observable<ProjectStatisticsFoldStampAdvanceResult>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectStatisticsFoldModeHttpService implements IProjectStatisticsFoldModeHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * The project's fold state. Read-only.
     */
    getFoldStatus(projectId: string): Observable<ProjectStatisticsFoldStatus> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{projectId}/fold/status";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFoldStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFoldStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsFoldStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsFoldStatus>;
        }));
    }

    protected processGetFoldStatus(response: HttpResponseBase): Observable<ProjectStatisticsFoldStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsFoldStatus;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Enables fold mode: stamps the protocol tripwire, stales every fold family and advances the
    clocks in one transaction. Ordinary backfills then republish the families with the subtraction rule.
     */
    enableFold(projectId: string, request: ProjectStatisticsFoldEnableRequest): Observable<ProjectStatisticsFoldTransitionResult> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{projectId}/fold/enable";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableFold(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableFold(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsFoldTransitionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsFoldTransitionResult>;
        }));
    }

    protected processEnableFold(response: HttpResponseBase): Observable<ProjectStatisticsFoldTransitionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsFoldTransitionResult;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sets Disabling; saves take today's path from then on and the worker finalizes Disabled.
     */
    disableFold(projectId: string): Observable<ProjectStatisticsFoldTransitionResult> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{projectId}/fold/disable";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableFold(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableFold(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsFoldTransitionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsFoldTransitionResult>;
        }));
    }

    protected processDisableFold(response: HttpResponseBase): Observable<ProjectStatisticsFoldTransitionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsFoldTransitionResult;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The guard-exit and recovery operation: re-stamps the tripwire at this binary's protocol (in fold
    mode) and stales every materialized family, SearchPopulation included.
     */
    resetFold(projectId: string): Observable<ProjectStatisticsFoldTransitionResult> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{projectId}/fold/reset";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetFold(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetFold(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsFoldTransitionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsFoldTransitionResult>;
        }));
    }

    protected processResetFold(response: HttpResponseBase): Observable<ProjectStatisticsFoldTransitionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsFoldTransitionResult;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Advances this project's fold-protocol stamp from the previous protocol to this binary's, exactly as the
    project-management consumer does on the fold sweep's schedule: the operator's
    ProjectStatistics:Fold:StampAdvanceAllowed, every live member declaring the protocol, a live
    fold-worker heartbeat for it and no pending entry below the previous protocol, then a compare-and-set.
    At the production baseline there is no previous protocol and the answer is NothingToAdvance.
     */
    advanceFoldStamp(projectId: string): Observable<ProjectStatisticsFoldStampAdvanceResult> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{projectId}/fold/advance-stamp";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdvanceFoldStamp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdvanceFoldStamp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsFoldStampAdvanceResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsFoldStampAdvanceResult>;
        }));
    }

    protected processAdvanceFoldStamp(response: HttpResponseBase): Observable<ProjectStatisticsFoldStampAdvanceResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsFoldStampAdvanceResult;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectStatisticsHistoryHttpService {
    getScreeningHistory(projectId: string, limit?: number | null | undefined, after?: string | null | undefined): Observable<ScreeningHistoryPage>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectStatisticsHistoryHttpService implements IProjectStatisticsHistoryHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getScreeningHistory(projectId: string, limit?: number | null | undefined, after?: string | null | undefined): Observable<ScreeningHistoryPage> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/screening-history?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (after !== undefined && after !== null)
            url_ += "after=" + encodeURIComponent("" + after) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScreeningHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScreeningHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScreeningHistoryPage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScreeningHistoryPage>;
        }));
    }

    protected processGetScreeningHistory(response: HttpResponseBase): Observable<ScreeningHistoryPage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScreeningHistoryPage;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectStatisticsHistoryMaintenanceHttpService {
    run(statisticsProjectId: string, request: ProjectStatisticsHistoryMaintenanceRequest): Observable<ProjectStatisticsHistoryMaintenanceResult>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectStatisticsHistoryMaintenanceHttpService implements IProjectStatisticsHistoryMaintenanceHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    run(statisticsProjectId: string, request: ProjectStatisticsHistoryMaintenanceRequest): Observable<ProjectStatisticsHistoryMaintenanceResult> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/history-maintenance";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsHistoryMaintenanceResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsHistoryMaintenanceResult>;
        }));
    }

    protected processRun(response: HttpResponseBase): Observable<ProjectStatisticsHistoryMaintenanceResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsHistoryMaintenanceResult;
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectStatisticsInclusionDriftHttpService {
    /**
     * @param statisticsProjectId The project to check.
     */
    getReviewerScreeningInclusionDrift(statisticsProjectId: string): Observable<ReviewerScreeningInclusionDrift>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectStatisticsInclusionDriftHttpService implements IProjectStatisticsInclusionDriftHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param statisticsProjectId The project to check.
     */
    getReviewerScreeningInclusionDrift(statisticsProjectId: string): Observable<ReviewerScreeningInclusionDrift> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/reviewer-screening/inclusion-status-drift";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerScreeningInclusionDrift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerScreeningInclusionDrift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReviewerScreeningInclusionDrift>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReviewerScreeningInclusionDrift>;
        }));
    }

    protected processGetReviewerScreeningInclusionDrift(response: HttpResponseBase): Observable<ReviewerScreeningInclusionDrift> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReviewerScreeningInclusionDrift;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectStatisticsModeAdminHttpService {
    /**
     * Moves the fleet-wide durable gate one legal stage toward the requested mode and, on an
    enable, declares the catalogue/storage/source versions this deployment's writers produce,
    creating the singleton fleet control when it does not exist.
     */
    transitionFleetMode(request: ProjectStatisticsFleetModeRequestDto): Observable<ProjectStatisticsModeTransitionDto>;
    /**
     * Opens or closes one project's narrow serving gate, one legal stage per call. Opening a gate
    that has previously been disabled rebuilds every scope its routed families declare first and
    presents the resulting proof to the transition.
     */
    transitionNarrowGate(statisticsProjectId: string, request: ProjectStatisticsNarrowGateRequestDto): Observable<ProjectStatisticsModeTransitionDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectStatisticsModeAdminHttpService implements IProjectStatisticsModeAdminHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Moves the fleet-wide durable gate one legal stage toward the requested mode and, on an
    enable, declares the catalogue/storage/source versions this deployment's writers produce,
    creating the singleton fleet control when it does not exist.
     */
    transitionFleetMode(request: ProjectStatisticsFleetModeRequestDto): Observable<ProjectStatisticsModeTransitionDto> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/fleet/mode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransitionFleetMode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransitionFleetMode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsModeTransitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsModeTransitionDto>;
        }));
    }

    protected processTransitionFleetMode(response: HttpResponseBase): Observable<ProjectStatisticsModeTransitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsModeTransitionDto;
            return _observableOf(result202);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsModeTransitionDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Opens or closes one project's narrow serving gate, one legal stage per call. Opening a gate
    that has previously been disabled rebuilds every scope its routed families declare first and
    presents the resulting proof to the transition.
     */
    transitionNarrowGate(statisticsProjectId: string, request: ProjectStatisticsNarrowGateRequestDto): Observable<ProjectStatisticsModeTransitionDto> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/narrow-gate";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransitionNarrowGate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransitionNarrowGate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsModeTransitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsModeTransitionDto>;
        }));
    }

    protected processTransitionNarrowGate(response: HttpResponseBase): Observable<ProjectStatisticsModeTransitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsModeTransitionDto;
            return _observableOf(result202);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsModeTransitionDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectStatisticsParityAdminHttpService {
    /**
     * Compares every scope of one materialized metric family (project screening by default) with the
    family's authoritative calculation and reports both sides, scope by scope and metric by metric.
     * @param statisticsProjectId The allowlisted pilot project.
     * @param family (optional) The family's catalogue key; absent means project-screening. Any other value is a
    400 with type urn:syrf:project-statistics:unknown-family.
     */
    getParity(statisticsProjectId: string, family?: string | null | undefined): Observable<ProjectStatisticsParityReportDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectStatisticsParityAdminHttpService implements IProjectStatisticsParityAdminHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Compares every scope of one materialized metric family (project screening by default) with the
    family's authoritative calculation and reports both sides, scope by scope and metric by metric.
     * @param statisticsProjectId The allowlisted pilot project.
     * @param family (optional) The family's catalogue key; absent means project-screening. Any other value is a
    400 with type urn:syrf:project-statistics:unknown-family.
     */
    getParity(statisticsProjectId: string, family?: string | null | undefined): Observable<ProjectStatisticsParityReportDto> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/parity?";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        if (family !== undefined && family !== null)
            url_ += "family=" + encodeURIComponent("" + family) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsParityReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsParityReportDto>;
        }));
    }

    protected processGetParity(response: HttpResponseBase): Observable<ProjectStatisticsParityReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsParityReportDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectStatisticsPilotAdminHttpService {
    getPilotStatus(): Observable<ProjectStatisticsPilotStatusDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectStatisticsPilotAdminHttpService implements IProjectStatisticsPilotAdminHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getPilotStatus(): Observable<ProjectStatisticsPilotStatusDto> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/pilot-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPilotStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPilotStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsPilotStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsPilotStatusDto>;
        }));
    }

    protected processGetPilotStatus(response: HttpResponseBase): Observable<ProjectStatisticsPilotStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsPilotStatusDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectStatisticsProjectionReadAdminHttpService {
    /**
     * Performs the consumer reads of family for the project and reports where each
    answer came from.
     * @param statisticsProjectId The project.
     * @param family (optional) The metric family name, e.g. ProjectScreening or ReviewerAnnotation.
     * @param scope (optional) Project screening only: its one scope, project.
     * @param stageId (optional) A stage of the project (stage-grained families).
     * @param investigatorId (optional) A project member, by investigator id or reviewer- pseudonym (reviewer-grained families).
     * @param questionId (optional) An annotation question of the project (question answers).
     * @param searchId (optional) A systematic search linked to the project (search population).
     */
    getProjectionRead(statisticsProjectId: string, family?: string | null | undefined, scope?: string | null | undefined, stageId?: string | null | undefined, investigatorId?: string | null | undefined, questionId?: string | null | undefined, searchId?: string | null | undefined): Observable<ProjectStatisticsProjectionReadDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectStatisticsProjectionReadAdminHttpService implements IProjectStatisticsProjectionReadAdminHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Performs the consumer reads of family for the project and reports where each
    answer came from.
     * @param statisticsProjectId The project.
     * @param family (optional) The metric family name, e.g. ProjectScreening or ReviewerAnnotation.
     * @param scope (optional) Project screening only: its one scope, project.
     * @param stageId (optional) A stage of the project (stage-grained families).
     * @param investigatorId (optional) A project member, by investigator id or reviewer- pseudonym (reviewer-grained families).
     * @param questionId (optional) An annotation question of the project (question answers).
     * @param searchId (optional) A systematic search linked to the project (search population).
     */
    getProjectionRead(statisticsProjectId: string, family?: string | null | undefined, scope?: string | null | undefined, stageId?: string | null | undefined, investigatorId?: string | null | undefined, questionId?: string | null | undefined, searchId?: string | null | undefined): Observable<ProjectStatisticsProjectionReadDto> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/projection-read?";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        if (family !== undefined && family !== null)
            url_ += "family=" + encodeURIComponent("" + family) + "&";
        if (scope !== undefined && scope !== null)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&";
        if (stageId !== undefined && stageId !== null)
            url_ += "stageId=" + encodeURIComponent("" + stageId) + "&";
        if (investigatorId !== undefined && investigatorId !== null)
            url_ += "investigatorId=" + encodeURIComponent("" + investigatorId) + "&";
        if (questionId !== undefined && questionId !== null)
            url_ += "questionId=" + encodeURIComponent("" + questionId) + "&";
        if (searchId !== undefined && searchId !== null)
            url_ += "searchId=" + encodeURIComponent("" + searchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectionRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectionRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsProjectionReadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsProjectionReadDto>;
        }));
    }

    protected processGetProjectionRead(response: HttpResponseBase): Observable<ProjectStatisticsProjectionReadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsProjectionReadDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 413) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result413: any = null;
            result413 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result413);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectStatisticsReceiptMaintenanceHttpService {
    run(statisticsProjectId: string): Observable<ProjectStatisticsReceiptMaintenanceResult>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectStatisticsReceiptMaintenanceHttpService implements IProjectStatisticsReceiptMaintenanceHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    run(statisticsProjectId: string): Observable<ProjectStatisticsReceiptMaintenanceResult> {
        let url_ = this.baseUrl + "/api/admin/project-statistics/{statisticsProjectId}/receipt-maintenance";
        if (statisticsProjectId === undefined || statisticsProjectId === null)
            throw new Error("The parameter 'statisticsProjectId' must be defined.");
        url_ = url_.replace("{statisticsProjectId}", encodeURIComponent("" + statisticsProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStatisticsReceiptMaintenanceResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStatisticsReceiptMaintenanceResult>;
        }));
    }

    protected processRun(response: HttpResponseBase): Observable<ProjectStatisticsReceiptMaintenanceResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectStatisticsReceiptMaintenanceResult;
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IQuestionCountsHttpService {
    getQuestionAnswerCounts(projectId: string): Observable<QuestionAnswerCountsResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class QuestionCountsHttpService implements IQuestionCountsHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getQuestionAnswerCounts(projectId: string): Observable<QuestionAnswerCountsResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/question-answer-counts";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuestionAnswerCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestionAnswerCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionAnswerCountsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionAnswerCountsResponse>;
        }));
    }

    protected processGetQuestionAnswerCounts(response: HttpResponseBase): Observable<QuestionAnswerCountsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuestionAnswerCountsResponse;
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 413) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result413: any = null;
            result413 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result413);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewHttpService {
    removeSession(projectId: string, stageId: string, studyId: string, sessionId: string): Observable<void>;
    submitSession(projectId: string, stageId: string, studyId: string, sessionId: string, sessionSubmissionWebDto: SessionSubmissionWebDto): Observable<SavedSessionResponseDto>;
    submitScreeningAndGetNextStudyForReview(projectId: string, stageId: string, studyId: string, screeningDecision: ScreeningDecision, getSavedSession?: boolean | undefined): Observable<NextStudyResponseDto>;
    getStudyForReview(projectId: string, stageId: string, studyId: string): Observable<NextStudyResponseDto>;
    /**
     * Revision-2 §4.3: Include/Exclude must be able to record a screening decision without
    consuming a next-study allocation, because some outcomes keep the reviewer on the same
    study. Calling SubmitScreeningAndGetNextStudyForReview and discarding its
    response would still reserve a study the reviewer never opens, corrupting in-progress
    session counts and proportional allocation. This action only saves the decision.
     */
    submitScreeningWithoutAdvancing(projectId: string, stageId: string, studyId: string, screeningDecision: ScreeningDecision): Observable<void>;
    submitScreeningAndGetNextStudyForReconciliation(projectId: string, stageId: string, studyId: string, screeningDecision: ScreeningDecision, getSavedSession?: boolean | undefined): Observable<NextStudyResponseDto>;
    getStudyForReconciliation(projectId: string, stageId: string, studyId: string): Observable<NextStudyResponseDto>;
    getNextStudyForReview(projectId: string, stageId: string, restrictToSavedSessions?: boolean | undefined): Observable<NextStudyResponseDto>;
    getNextStudyForReconciliation(projectId: string, stageId: string, restrictToSavedSessions?: boolean | undefined): Observable<NextStudyResponseDto>;
    getFullStats(projectId: string): Observable<FullStats>;
    getInProgress(projectId: string, stageId: string, reconciliation?: boolean | undefined): Observable<StudySummaryDto[]>;
    getReviewerStatsForStage(projectId: string, stageId: string): Observable<StageReviewerStats>;
    getReviewerStatsForProject(projectId: string): Observable<ProjectReviewerStats>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewHttpService implements IReviewHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    removeSession(projectId: string, stageId: string, studyId: string, sessionId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}/studies/{studyId}/session/{sessionId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveSession(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    submitSession(projectId: string, stageId: string, studyId: string, sessionId: string, sessionSubmissionWebDto: SessionSubmissionWebDto): Observable<SavedSessionResponseDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}/studies/{studyId}/session/{sessionId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sessionSubmissionWebDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SavedSessionResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SavedSessionResponseDto>;
        }));
    }

    protected processSubmitSession(response: HttpResponseBase): Observable<SavedSessionResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SavedSessionResponseDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AnnotationSubmissionConflictDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    submitScreeningAndGetNextStudyForReview(projectId: string, stageId: string, studyId: string, screeningDecision: ScreeningDecision, getSavedSession?: boolean | undefined): Observable<NextStudyResponseDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}/studies/{studyId}/review?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (getSavedSession === null)
            throw new Error("The parameter 'getSavedSession' cannot be null.");
        else if (getSavedSession !== undefined)
            url_ += "getSavedSession=" + encodeURIComponent("" + getSavedSession) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(screeningDecision);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitScreeningAndGetNextStudyForReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitScreeningAndGetNextStudyForReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NextStudyResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NextStudyResponseDto>;
        }));
    }

    protected processSubmitScreeningAndGetNextStudyForReview(response: HttpResponseBase): Observable<NextStudyResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NextStudyResponseDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStudyForReview(projectId: string, stageId: string, studyId: string): Observable<NextStudyResponseDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}/studies/{studyId}/review";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStudyForReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStudyForReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NextStudyResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NextStudyResponseDto>;
        }));
    }

    protected processGetStudyForReview(response: HttpResponseBase): Observable<NextStudyResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NextStudyResponseDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Revision-2 §4.3: Include/Exclude must be able to record a screening decision without
    consuming a next-study allocation, because some outcomes keep the reviewer on the same
    study. Calling SubmitScreeningAndGetNextStudyForReview and discarding its
    response would still reserve a study the reviewer never opens, corrupting in-progress
    session counts and proportional allocation. This action only saves the decision.
     */
    submitScreeningWithoutAdvancing(projectId: string, stageId: string, studyId: string, screeningDecision: ScreeningDecision): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}/studies/{studyId}/screening";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(screeningDecision);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitScreeningWithoutAdvancing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitScreeningWithoutAdvancing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSubmitScreeningWithoutAdvancing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    submitScreeningAndGetNextStudyForReconciliation(projectId: string, stageId: string, studyId: string, screeningDecision: ScreeningDecision, getSavedSession?: boolean | undefined): Observable<NextStudyResponseDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}/studies/{studyId}/reconcile?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (getSavedSession === null)
            throw new Error("The parameter 'getSavedSession' cannot be null.");
        else if (getSavedSession !== undefined)
            url_ += "getSavedSession=" + encodeURIComponent("" + getSavedSession) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(screeningDecision);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitScreeningAndGetNextStudyForReconciliation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitScreeningAndGetNextStudyForReconciliation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NextStudyResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NextStudyResponseDto>;
        }));
    }

    protected processSubmitScreeningAndGetNextStudyForReconciliation(response: HttpResponseBase): Observable<NextStudyResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NextStudyResponseDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStudyForReconciliation(projectId: string, stageId: string, studyId: string): Observable<NextStudyResponseDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}/studies/{studyId}/reconcile";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStudyForReconciliation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStudyForReconciliation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NextStudyResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NextStudyResponseDto>;
        }));
    }

    protected processGetStudyForReconciliation(response: HttpResponseBase): Observable<NextStudyResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NextStudyResponseDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNextStudyForReview(projectId: string, stageId: string, restrictToSavedSessions?: boolean | undefined): Observable<NextStudyResponseDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}/review?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        if (restrictToSavedSessions === null)
            throw new Error("The parameter 'restrictToSavedSessions' cannot be null.");
        else if (restrictToSavedSessions !== undefined)
            url_ += "restrictToSavedSessions=" + encodeURIComponent("" + restrictToSavedSessions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextStudyForReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextStudyForReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NextStudyResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NextStudyResponseDto>;
        }));
    }

    protected processGetNextStudyForReview(response: HttpResponseBase): Observable<NextStudyResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NextStudyResponseDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNextStudyForReconciliation(projectId: string, stageId: string, restrictToSavedSessions?: boolean | undefined): Observable<NextStudyResponseDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}/reconcile?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        if (restrictToSavedSessions === null)
            throw new Error("The parameter 'restrictToSavedSessions' cannot be null.");
        else if (restrictToSavedSessions !== undefined)
            url_ += "restrictToSavedSessions=" + encodeURIComponent("" + restrictToSavedSessions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextStudyForReconciliation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextStudyForReconciliation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NextStudyResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NextStudyResponseDto>;
        }));
    }

    protected processGetNextStudyForReconciliation(response: HttpResponseBase): Observable<NextStudyResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NextStudyResponseDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFullStats(projectId: string): Observable<FullStats> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/full-stats";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFullStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFullStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FullStats>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FullStats>;
        }));
    }

    protected processGetFullStats(response: HttpResponseBase): Observable<FullStats> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FullStats;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInProgress(projectId: string, stageId: string, reconciliation?: boolean | undefined): Observable<StudySummaryDto[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}/in-progress?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        if (reconciliation === null)
            throw new Error("The parameter 'reconciliation' cannot be null.");
        else if (reconciliation !== undefined)
            url_ += "reconciliation=" + encodeURIComponent("" + reconciliation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInProgress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInProgress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StudySummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StudySummaryDto[]>;
        }));
    }

    protected processGetInProgress(response: HttpResponseBase): Observable<StudySummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudySummaryDto[];
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReviewerStatsForStage(projectId: string, stageId: string): Observable<StageReviewerStats> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}/reviewer-stats";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerStatsForStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerStatsForStage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StageReviewerStats>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StageReviewerStats>;
        }));
    }

    protected processGetReviewerStatsForStage(response: HttpResponseBase): Observable<StageReviewerStats> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StageReviewerStats;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReviewerStatsForProject(projectId: string): Observable<ProjectReviewerStats> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/reviewer-stats";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerStatsForProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerStatsForProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectReviewerStats>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectReviewerStats>;
        }));
    }

    protected processGetReviewerStatsForProject(response: HttpResponseBase): Observable<ProjectReviewerStats> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectReviewerStats;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 413) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result413: any = null;
            result413 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result413);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewerAnnotationHistoryHttpService {
    getReviewerAnnotationHistory(projectId: string, stageId: string, investigatorId: string, limit?: number | null | undefined, after?: string | null | undefined): Observable<ReviewerAnnotationHistoryPage>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerAnnotationHistoryHttpService implements IReviewerAnnotationHistoryHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getReviewerAnnotationHistory(projectId: string, stageId: string, investigatorId: string, limit?: number | null | undefined, after?: string | null | undefined): Observable<ReviewerAnnotationHistoryPage> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}/reviewers/{investigatorId}/annotation-history?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        if (investigatorId === undefined || investigatorId === null)
            throw new Error("The parameter 'investigatorId' must be defined.");
        url_ = url_.replace("{investigatorId}", encodeURIComponent("" + investigatorId));
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (after !== undefined && after !== null)
            url_ += "after=" + encodeURIComponent("" + after) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerAnnotationHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerAnnotationHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReviewerAnnotationHistoryPage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReviewerAnnotationHistoryPage>;
        }));
    }

    protected processGetReviewerAnnotationHistory(response: HttpResponseBase): Observable<ReviewerAnnotationHistoryPage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReviewerAnnotationHistoryPage;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewerScreeningHistoryHttpService {
    getReviewerScreeningHistory(projectId: string, investigatorId: string, limit?: number | null | undefined, after?: string | null | undefined): Observable<ReviewerScreeningHistoryPage>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerScreeningHistoryHttpService implements IReviewerScreeningHistoryHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getReviewerScreeningHistory(projectId: string, investigatorId: string, limit?: number | null | undefined, after?: string | null | undefined): Observable<ReviewerScreeningHistoryPage> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/reviewers/{investigatorId}/screening-history?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (investigatorId === undefined || investigatorId === null)
            throw new Error("The parameter 'investigatorId' must be defined.");
        url_ = url_.replace("{investigatorId}", encodeURIComponent("" + investigatorId));
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (after !== undefined && after !== null)
            url_ += "after=" + encodeURIComponent("" + after) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewerScreeningHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewerScreeningHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReviewerScreeningHistoryPage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReviewerScreeningHistoryPage>;
        }));
    }

    protected processGetReviewerScreeningHistory(response: HttpResponseBase): Observable<ReviewerScreeningHistoryPage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReviewerScreeningHistoryPage;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewPreferencesHttpService {
    get(): Observable<ReviewPreferences>;
    /**
     * Saves the reviewer's preferences. The body is ReviewPreferencesUpdate, not the read record:
    preferences added after the original contract are optional, and an omitted or null one keeps its stored
    value, so a web bundle cached before a field existed cannot reset it. The response is the full stored set.
     */
    put(request: ReviewPreferencesUpdate): Observable<ReviewPreferences>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewPreferencesHttpService implements IReviewPreferencesHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<ReviewPreferences> {
        let url_ = this.baseUrl + "/api/account/review-preferences";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReviewPreferences>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReviewPreferences>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ReviewPreferences> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReviewPreferences;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Saves the reviewer's preferences. The body is ReviewPreferencesUpdate, not the read record:
    preferences added after the original contract are optional, and an omitted or null one keeps its stored
    value, so a web bundle cached before a field existed cannot reset it. The response is the full stored set.
     */
    put(request: ReviewPreferencesUpdate): Observable<ReviewPreferences> {
        let url_ = this.baseUrl + "/api/account/review-preferences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReviewPreferences>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReviewPreferences>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<ReviewPreferences> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReviewPreferences;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReviewWorkspaceLayoutsHttpService {
    get(): Observable<ReviewWorkspaceLayoutsDto>;
    /**
     * Resets every saved panel layout for this reviewer, for all capabilities, which is what
    revision-2 §5's "Saved panel layout" RESET does. Preferences live on the same document and
    are deliberately preserved: resetting a layout is not a request to forget how the reviewer
    likes to work.
     */
    resetLayouts(): Observable<void>;
    put(capability: string, request: ReviewWorkspaceLayout): Observable<ReviewWorkspaceLayout>;
}

@Injectable({
    providedIn: 'root'
})
export class ReviewWorkspaceLayoutsHttpService implements IReviewWorkspaceLayoutsHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<ReviewWorkspaceLayoutsDto> {
        let url_ = this.baseUrl + "/api/account/review-layouts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReviewWorkspaceLayoutsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReviewWorkspaceLayoutsDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ReviewWorkspaceLayoutsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReviewWorkspaceLayoutsDto;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Resets every saved panel layout for this reviewer, for all capabilities, which is what
    revision-2 §5's "Saved panel layout" RESET does. Preferences live on the same document and
    are deliberately preserved: resetting a layout is not a request to forget how the reviewer
    likes to work.
     */
    resetLayouts(): Observable<void> {
        let url_ = this.baseUrl + "/api/account/review-layouts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetLayouts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetLayouts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetLayouts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    put(capability: string, request: ReviewWorkspaceLayout): Observable<ReviewWorkspaceLayout> {
        let url_ = this.baseUrl + "/api/account/review-layouts/{capability}";
        if (capability === undefined || capability === null)
            throw new Error("The parameter 'capability' must be defined.");
        url_ = url_.replace("{capability}", encodeURIComponent("" + capability));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReviewWorkspaceLayout>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReviewWorkspaceLayout>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<ReviewWorkspaceLayout> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReviewWorkspaceLayout;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRuntimeFeatureFlagsHttpService {
    get(): Observable<RuntimeFeatureFlagSnapshot>;
    getProviderStatus(): Observable<RuntimeFeatureFlagProviderStatus>;
    /**
     * Authenticated local authority observation; it does not assert fleet convergence.
     */
    getAuthorityStatus(): Observable<RuntimePolicyAuthorityStatus>;
    /**
     * Inspect one reviewed consumer using the local bounded authority; no fleet admission is implied.
     */
    getAuthorityEvaluation(key: string): Observable<RuntimePolicyEvaluationStatus>;
    /**
     * Inspect policy adoption by expected API/PM hosts; unknown evidence never confirms adoption.
     */
    getFleet(key: string): Observable<RuntimePolicyFleetStatus>;
    /**
     * Resolve a mutation receipt. Unknown does not prove abort; retry the unchanged original request.
     */
    getMutationOutcome(mutationId: string): Observable<RuntimePolicyMutationOutcome>;
    previewPolicy(key: string, request: RuntimePolicyChangeRequest): Observable<RuntimePolicyPreview>;
    /**
     * Commit a reviewed bound policy; the acknowledgement does not assert fleet adoption.
     */
    commitPolicy(key: string, request: RuntimePolicyChangeRequest): Observable<RuntimePolicyCommitStatus>;
    /**
     * One key's stored targeting rules as the policy in force holds them (6F W2, the admin Targeting page): the identity they
    were read at, the key's grain, its rules by kind and the owning feature's consent. Read-only. Behind
    RuntimeFeatureTargeting:Enabled (off: a plain 404 before any capability check or read), then
    ChangeRuntimeFeaturePolicy or InspectRuntimeFeaturePolicy, then Shared mode. Project names come back only
    for a caller who may change the policy (the targeting preview already returns names under that capability); an
    inspector sees project IDs. A pure GET. The two 404s differ: the switch off is a plain 404, an unknown key a problem
    whose code is UnknownTargetingKeyCode (#4563), so the page can say which.
     */
    getTargeting(key: string): Observable<RuntimeTargetingState>;
    /**
     * Commit a previewed targeting replacement for one key (spec 6F.2) through the policy writer: receipt chain, replay by
    mutation ID, preview digest, deployment constraint and schema-2 admission. Behind RuntimeFeatureTargeting:Enabled.
     */
    commitTargeting(key: string, request: RuntimeTargetingCommitRequest): Observable<RuntimePolicyCommitStatus>;
    /**
     * The rule editor's project lookup (6F W2 owner feedback on #4519): a project ID matches that project exactly, archived
    or not; other text matches active project names (prefix first, then substring), at most 20. Each match carries the
    context that tells similar names apart: ID, name, whether the project is active, its owner (ID and name), active
    members, stages, studies (null when the count is unavailable) and creation time; deleted projects never match. Behind
    RuntimeFeatureTargeting:Enabled (off: a plain 404 before any capability check or read), then
    ChangeRuntimeFeaturePolicy (the editor's audience, and the capability under which the targeting read and
    preview already return project names). A query shorter than 2 or longer than 100 characters is a 400 with no read.
    A pure GET.
     * @param query (optional) 
     */
    searchTargetingProjects(query?: string | null | undefined): Observable<RuntimeTargetingProjectMatch[]>;
    /**
     * Read-only preview of replacing one key's targeting rules (spec 6F.2): rules before and after, the projects that gain
    or lose the key, dependency notes and policy-schema admission. Behind RuntimeFeatureTargeting:Enabled: off, it
    answers 404 before any capability check or read. Not marked read-only safe for impersonation (spec 6F.2-10).
     */
    previewTargeting(key: string, request: RuntimeTargetingPreviewRequest): Observable<RuntimeTargetingPreview>;
    /**
     * "Preview and check" (spec 6F.5): why one project or person gets a decision, and what a draft would change. Read-only:
    it grants and writes nothing, and the named project and person are subjects of the simulation, never the caller.
    Behind RuntimeFeatureTargeting:Enabled (off: a plain 404 before any capability check or read), then
    InspectRuntimeFeaturePolicy or ChangeRuntimeFeaturePolicy. A POST that only reads, so it is marked
    read-only safe for impersonation, as PreviewPolicy is. After those checks, a project that does not exist
    or is deleted answers 422 runtime_targeting_refused with reason unknownProject ("No project with that
    ID. …"), and on a Personal key a person who does not exist or whose account was deleted answers reason
    unknownPerson ("No person with that ID. …"; owner decision D59 = B: the administrators who may simulate can
    already list every project and person).
     */
    simulateTargeting(key: string, request: RuntimeTargetingSimulationRequest): Observable<RuntimeTargetingSimulationResult>;
    /**
     * Read-only preview of one registry feature's environment setting (spec 6F.7, owner decision D30 = A): a consent stricter
    than the code's, or null to clear it and return to the code's setting. Shows the code's, the environment's and the
    effective consent before and after, whether the code setting changed after the environment's was saved, and
    policy-schema admission. Behind RuntimeFeatureTargeting:Enabled (off: a plain 404 before any capability check
    or read), then ChangeRuntimeFeaturePolicy and Shared mode, like the targeting preview. A change for impersonation.
     */
    previewFeatureSettings(featureId: string, request: RuntimeFeatureSettingsPreviewRequest): Observable<RuntimeFeatureSettingsPreview>;
    /**
     * Commit a previewed environment feature setting (spec 6F.7) through the policy writer: receipt chain, replay by mutation
    ID, preview digest, deployment constraint and schema-2 admission. A setting not stricter than the code's refuses
    consentNotStricter: loosening needs a code change. Behind RuntimeFeatureTargeting:Enabled.
     */
    commitFeatureSettings(featureId: string, request: RuntimeFeatureSettingsCommitRequest): Observable<RuntimePolicyCommitStatus>;
    /**
     * "Choices projects have made" (spec 6F.7): how many subjects of a feature's subject type have joined and left in this
    binding. Counts only, never IDs or names, read by one anchored _id range. Behind
    RuntimeFeatureTargeting:Enabled (off: a plain 404 before any capability check or read), then
    InspectRuntimeFeaturePolicy and Shared mode. A feature that is unknown or cannot take consent answers 404.
     */
    getFeatureChoices(featureId: string): Observable<RuntimeFeatureConsentCounts>;
    previewRelease(featureId: string, request: RuntimeReleasePreparationRequest): Observable<RuntimeReleaseIntentPreview>;
    prepareRelease(featureId: string, request: RuntimeReleasePreparationRequest): Observable<RuntimePreparedRelease>;
    getPreparedRelease(releaseId: string): Observable<RuntimePreparedRelease>;
    /**
     * The admin Releases list (6G.11): this binding's releases, newest first, at most 50 a page; before is the
    previous page's nextBefore. Read-only, behind RuntimeFeatureReleases:Enabled (404 while off).
     * @param featureId (optional) 
     * @param status (optional) 
     * @param before (optional) 
     */
    listReleases(featureId?: string | null | undefined, status?: string | null | undefined, before?: string | null | undefined): Observable<RuntimeReleaseListPage>;
    /**
     * A release's event timeline (6G.11), in recorded order and bounded; 404 for a release outside this binding.
     */
    getReleaseEvents(releaseId: string): Observable<RuntimeReleaseEventsPage>;
    /**
     * The admin content preview's feature list (6G.13): the registry features with a What's New entry or article in the current
    verified server bundle, or a walkthrough. Read-only, InspectRuntimeFeaturePolicy or ManageFeatureReleases,
    behind RuntimeFeatureReleases:Enabled (404 while off). Reads only the registry and the cached bundle.
     */
    getContentPreviewIndex(): Observable<FeatureContentIndex>;
    /**
     * What one audience (reviewer, projectAdministrator or signedOut) would get for one feature
    (6G.13): its What's New entries, help articles and walkthrough under the disclosure rules (FeatureContentPreview).
    400 for another audience, 404 for a feature the registry does not have. Same gate and switch as the list.
     * @param audience (optional) 
     */
    getContentPreview(featureId: string, audience?: string | null | undefined): Observable<FeatureContentPreviewResponse>;
    /**
     * The admin "Ready to settle" list (6G.12, D21, D43 = B): every Release-type feature that is not Settled or Withdrawn, with
    when it went live for everyone here from its release record and from the flag history (the later date is used), its
    settle period, the date it is ready on and its status. Read-only, behind RuntimeFeatureReleases:Enabled (404 while
    off); this environment's records only.
     */
    getReadyToSettle(): Observable<RuntimeReadyToSettlePage>;
    /**
     * Side-effect-free Apply plan against current policy: digest, identities, admission and queued announcements.
     */
    previewReleaseApply(releaseId: string, request: RuntimeReleaseApplyRequest): Observable<RuntimeReleaseApplyPreview>;
    /**
     * Apply a Prepared release: one transaction commits its policy, record, event and queued announcements.
     */
    applyRelease(releaseId: string, request: RuntimeReleaseApplyRequest): Observable<RuntimeAppliedRelease>;
    /**
     * Commit a safe-state stop; this response does not assert fleet adoption.
     */
    emergencyStop(key: string, request: RuntimePolicyEmergencyStopRequest): Observable<RuntimePolicyCommitStatus>;
    /**
     * Administrator recovery only; does not assert deployment completion or fleet readiness.
     */
    breakGlassRelease(rolloutId: string, request: RuntimeDeploymentBreakGlassRequest): Observable<RuntimeCoordinatorReceipt>;
    put(key: string, mutation: RuntimeFeatureFlagMutation): Observable<RuntimeFeatureFlagSnapshot>;
    putGroup(key: string, mutation: RuntimeFeatureFlagMutation): Observable<RuntimeFeatureFlagSnapshot>;
}

@Injectable({
    providedIn: 'root'
})
export class RuntimeFeatureFlagsHttpService implements IRuntimeFeatureFlagsHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<RuntimeFeatureFlagSnapshot> {
        let url_ = this.baseUrl + "/api/runtime-feature-flags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimeFeatureFlagSnapshot>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimeFeatureFlagSnapshot>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RuntimeFeatureFlagSnapshot> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeFeatureFlagSnapshot;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProviderStatus(): Observable<RuntimeFeatureFlagProviderStatus> {
        let url_ = this.baseUrl + "/api/runtime-feature-flags/provider-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProviderStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProviderStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimeFeatureFlagProviderStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimeFeatureFlagProviderStatus>;
        }));
    }

    protected processGetProviderStatus(response: HttpResponseBase): Observable<RuntimeFeatureFlagProviderStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeFeatureFlagProviderStatus;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Authenticated local authority observation; it does not assert fleet convergence.
     */
    getAuthorityStatus(): Observable<RuntimePolicyAuthorityStatus> {
        let url_ = this.baseUrl + "/api/runtime-feature-flags/authority-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthorityStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthorityStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimePolicyAuthorityStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimePolicyAuthorityStatus>;
        }));
    }

    protected processGetAuthorityStatus(response: HttpResponseBase): Observable<RuntimePolicyAuthorityStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimePolicyAuthorityStatus;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Inspect one reviewed consumer using the local bounded authority; no fleet admission is implied.
     */
    getAuthorityEvaluation(key: string): Observable<RuntimePolicyEvaluationStatus> {
        let url_ = this.baseUrl + "/api/runtime-feature-flags/authority-evaluation/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthorityEvaluation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthorityEvaluation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimePolicyEvaluationStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimePolicyEvaluationStatus>;
        }));
    }

    protected processGetAuthorityEvaluation(response: HttpResponseBase): Observable<RuntimePolicyEvaluationStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimePolicyEvaluationStatus;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Inspect policy adoption by expected API/PM hosts; unknown evidence never confirms adoption.
     */
    getFleet(key: string): Observable<RuntimePolicyFleetStatus> {
        let url_ = this.baseUrl + "/api/runtime-feature-flags/{key}/fleet";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFleet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFleet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimePolicyFleetStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimePolicyFleetStatus>;
        }));
    }

    protected processGetFleet(response: HttpResponseBase): Observable<RuntimePolicyFleetStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimePolicyFleetStatus;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Resolve a mutation receipt. Unknown does not prove abort; retry the unchanged original request.
     */
    getMutationOutcome(mutationId: string): Observable<RuntimePolicyMutationOutcome> {
        let url_ = this.baseUrl + "/api/runtime-feature-flags/mutations/{mutationId}";
        if (mutationId === undefined || mutationId === null)
            throw new Error("The parameter 'mutationId' must be defined.");
        url_ = url_.replace("{mutationId}", encodeURIComponent("" + mutationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMutationOutcome(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMutationOutcome(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimePolicyMutationOutcome>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimePolicyMutationOutcome>;
        }));
    }

    protected processGetMutationOutcome(response: HttpResponseBase): Observable<RuntimePolicyMutationOutcome> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimePolicyMutationOutcome;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    previewPolicy(key: string, request: RuntimePolicyChangeRequest): Observable<RuntimePolicyPreview> {
        let url_ = this.baseUrl + "/api/runtime-feature-flags/{key}/preview";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreviewPolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreviewPolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimePolicyPreview>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimePolicyPreview>;
        }));
    }

    protected processPreviewPolicy(response: HttpResponseBase): Observable<RuntimePolicyPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimePolicyPreview;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Commit a reviewed bound policy; the acknowledgement does not assert fleet adoption.
     */
    commitPolicy(key: string, request: RuntimePolicyChangeRequest): Observable<RuntimePolicyCommitStatus> {
        let url_ = this.baseUrl + "/api/runtime-feature-flags/{key}/policy";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommitPolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommitPolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimePolicyCommitStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimePolicyCommitStatus>;
        }));
    }

    protected processCommitPolicy(response: HttpResponseBase): Observable<RuntimePolicyCommitStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimePolicyCommitStatus;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * One key's stored targeting rules as the policy in force holds them (6F W2, the admin Targeting page): the identity they
    were read at, the key's grain, its rules by kind and the owning feature's consent. Read-only. Behind
    RuntimeFeatureTargeting:Enabled (off: a plain 404 before any capability check or read), then
    ChangeRuntimeFeaturePolicy or InspectRuntimeFeaturePolicy, then Shared mode. Project names come back only
    for a caller who may change the policy (the targeting preview already returns names under that capability); an
    inspector sees project IDs. A pure GET. The two 404s differ: the switch off is a plain 404, an unknown key a problem
    whose code is UnknownTargetingKeyCode (#4563), so the page can say which.
     */
    getTargeting(key: string): Observable<RuntimeTargetingState> {
        let url_ = this.baseUrl + "/api/runtime-feature-flags/{key}/targeting";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTargeting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTargeting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimeTargetingState>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimeTargetingState>;
        }));
    }

    protected processGetTargeting(response: HttpResponseBase): Observable<RuntimeTargetingState> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeTargetingState;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Commit a previewed targeting replacement for one key (spec 6F.2) through the policy writer: receipt chain, replay by
    mutation ID, preview digest, deployment constraint and schema-2 admission. Behind RuntimeFeatureTargeting:Enabled.
     */
    commitTargeting(key: string, request: RuntimeTargetingCommitRequest): Observable<RuntimePolicyCommitStatus> {
        let url_ = this.baseUrl + "/api/runtime-feature-flags/{key}/targeting";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommitTargeting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommitTargeting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimePolicyCommitStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimePolicyCommitStatus>;
        }));
    }

    protected processCommitTargeting(response: HttpResponseBase): Observable<RuntimePolicyCommitStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimePolicyCommitStatus;
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeTargetingRefusal;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The rule editor's project lookup (6F W2 owner feedback on #4519): a project ID matches that project exactly, archived
    or not; other text matches active project names (prefix first, then substring), at most 20. Each match carries the
    context that tells similar names apart: ID, name, whether the project is active, its owner (ID and name), active
    members, stages, studies (null when the count is unavailable) and creation time; deleted projects never match. Behind
    RuntimeFeatureTargeting:Enabled (off: a plain 404 before any capability check or read), then
    ChangeRuntimeFeaturePolicy (the editor's audience, and the capability under which the targeting read and
    preview already return project names). A query shorter than 2 or longer than 100 characters is a 400 with no read.
    A pure GET.
     * @param query (optional) 
     */
    searchTargetingProjects(query?: string | null | undefined): Observable<RuntimeTargetingProjectMatch[]> {
        let url_ = this.baseUrl + "/api/runtime-feature-flags/targeting/projects?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchTargetingProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchTargetingProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimeTargetingProjectMatch[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimeTargetingProjectMatch[]>;
        }));
    }

    protected processSearchTargetingProjects(response: HttpResponseBase): Observable<RuntimeTargetingProjectMatch[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeTargetingProjectMatch[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Read-only preview of replacing one key's targeting rules (spec 6F.2): rules before and after, the projects that gain
    or lose the key, dependency notes and policy-schema admission. Behind RuntimeFeatureTargeting:Enabled: off, it
    answers 404 before any capability check or read. Not marked read-only safe for impersonation (spec 6F.2-10).
     */
    previewTargeting(key: string, request: RuntimeTargetingPreviewRequest): Observable<RuntimeTargetingPreview> {
        let url_ = this.baseUrl + "/api/runtime-feature-flags/{key}/targeting/preview";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreviewTargeting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreviewTargeting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimeTargetingPreview>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimeTargetingPreview>;
        }));
    }

    protected processPreviewTargeting(response: HttpResponseBase): Observable<RuntimeTargetingPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeTargetingPreview;
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeTargetingRefusal;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * "Preview and check" (spec 6F.5): why one project or person gets a decision, and what a draft would change. Read-only:
    it grants and writes nothing, and the named project and person are subjects of the simulation, never the caller.
    Behind RuntimeFeatureTargeting:Enabled (off: a plain 404 before any capability check or read), then
    InspectRuntimeFeaturePolicy or ChangeRuntimeFeaturePolicy. A POST that only reads, so it is marked
    read-only safe for impersonation, as PreviewPolicy is. After those checks, a project that does not exist
    or is deleted answers 422 runtime_targeting_refused with reason unknownProject ("No project with that
    ID. …"), and on a Personal key a person who does not exist or whose account was deleted answers reason
    unknownPerson ("No person with that ID. …"; owner decision D59 = B: the administrators who may simulate can
    already list every project and person).
     */
    simulateTargeting(key: string, request: RuntimeTargetingSimulationRequest): Observable<RuntimeTargetingSimulationResult> {
        let url_ = this.baseUrl + "/api/runtime-feature-flags/{key}/simulate";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSimulateTargeting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSimulateTargeting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimeTargetingSimulationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimeTargetingSimulationResult>;
        }));
    }

    protected processSimulateTargeting(response: HttpResponseBase): Observable<RuntimeTargetingSimulationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeTargetingSimulationResult;
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeTargetingRefusal;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Read-only preview of one registry feature's environment setting (spec 6F.7, owner decision D30 = A): a consent stricter
    than the code's, or null to clear it and return to the code's setting. Shows the code's, the environment's and the
    effective consent before and after, whether the code setting changed after the environment's was saved, and
    policy-schema admission. Behind RuntimeFeatureTargeting:Enabled (off: a plain 404 before any capability check
    or read), then ChangeRuntimeFeaturePolicy and Shared mode, like the targeting preview. A change for impersonation.
     */
    previewFeatureSettings(featureId: string, request: RuntimeFeatureSettingsPreviewRequest): Observable<RuntimeFeatureSettingsPreview> {
        let url_ = this.baseUrl + "/api/runtime-feature-flags/features/{featureId}/settings/preview";
        if (featureId === undefined || featureId === null)
            throw new Error("The parameter 'featureId' must be defined.");
        url_ = url_.replace("{featureId}", encodeURIComponent("" + featureId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreviewFeatureSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreviewFeatureSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimeFeatureSettingsPreview>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimeFeatureSettingsPreview>;
        }));
    }

    protected processPreviewFeatureSettings(response: HttpResponseBase): Observable<RuntimeFeatureSettingsPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeFeatureSettingsPreview;
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeTargetingRefusal;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Commit a previewed environment feature setting (spec 6F.7) through the policy writer: receipt chain, replay by mutation
    ID, preview digest, deployment constraint and schema-2 admission. A setting not stricter than the code's refuses
    consentNotStricter: loosening needs a code change. Behind RuntimeFeatureTargeting:Enabled.
     */
    commitFeatureSettings(featureId: string, request: RuntimeFeatureSettingsCommitRequest): Observable<RuntimePolicyCommitStatus> {
        let url_ = this.baseUrl + "/api/runtime-feature-flags/features/{featureId}/settings";
        if (featureId === undefined || featureId === null)
            throw new Error("The parameter 'featureId' must be defined.");
        url_ = url_.replace("{featureId}", encodeURIComponent("" + featureId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommitFeatureSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommitFeatureSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimePolicyCommitStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimePolicyCommitStatus>;
        }));
    }

    protected processCommitFeatureSettings(response: HttpResponseBase): Observable<RuntimePolicyCommitStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimePolicyCommitStatus;
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeTargetingRefusal;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * "Choices projects have made" (spec 6F.7): how many subjects of a feature's subject type have joined and left in this
    binding. Counts only, never IDs or names, read by one anchored _id range. Behind
    RuntimeFeatureTargeting:Enabled (off: a plain 404 before any capability check or read), then
    InspectRuntimeFeaturePolicy and Shared mode. A feature that is unknown or cannot take consent answers 404.
     */
    getFeatureChoices(featureId: string): Observable<RuntimeFeatureConsentCounts> {
        let url_ = this.baseUrl + "/api/runtime-feature-flags/features/{featureId}/choices";
        if (featureId === undefined || featureId === null)
            throw new Error("The parameter 'featureId' must be defined.");
        url_ = url_.replace("{featureId}", encodeURIComponent("" + featureId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeatureChoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeatureChoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimeFeatureConsentCounts>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimeFeatureConsentCounts>;
        }));
    }

    protected processGetFeatureChoices(response: HttpResponseBase): Observable<RuntimeFeatureConsentCounts> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeFeatureConsentCounts;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    previewRelease(featureId: string, request: RuntimeReleasePreparationRequest): Observable<RuntimeReleaseIntentPreview> {
        let url_ = this.baseUrl + "/api/feature-releases/{featureId}/preview";
        if (featureId === undefined || featureId === null)
            throw new Error("The parameter 'featureId' must be defined.");
        url_ = url_.replace("{featureId}", encodeURIComponent("" + featureId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreviewRelease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreviewRelease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimeReleaseIntentPreview>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimeReleaseIntentPreview>;
        }));
    }

    protected processPreviewRelease(response: HttpResponseBase): Observable<RuntimeReleaseIntentPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeReleaseIntentPreview;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    prepareRelease(featureId: string, request: RuntimeReleasePreparationRequest): Observable<RuntimePreparedRelease> {
        let url_ = this.baseUrl + "/api/feature-releases/{featureId}/prepare";
        if (featureId === undefined || featureId === null)
            throw new Error("The parameter 'featureId' must be defined.");
        url_ = url_.replace("{featureId}", encodeURIComponent("" + featureId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrepareRelease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrepareRelease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimePreparedRelease>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimePreparedRelease>;
        }));
    }

    protected processPrepareRelease(response: HttpResponseBase): Observable<RuntimePreparedRelease> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimePreparedRelease;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPreparedRelease(releaseId: string): Observable<RuntimePreparedRelease> {
        let url_ = this.baseUrl + "/api/feature-releases/{releaseId}";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreparedRelease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreparedRelease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimePreparedRelease>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimePreparedRelease>;
        }));
    }

    protected processGetPreparedRelease(response: HttpResponseBase): Observable<RuntimePreparedRelease> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimePreparedRelease;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The admin Releases list (6G.11): this binding's releases, newest first, at most 50 a page; before is the
    previous page's nextBefore. Read-only, behind RuntimeFeatureReleases:Enabled (404 while off).
     * @param featureId (optional) 
     * @param status (optional) 
     * @param before (optional) 
     */
    listReleases(featureId?: string | null | undefined, status?: string | null | undefined, before?: string | null | undefined): Observable<RuntimeReleaseListPage> {
        let url_ = this.baseUrl + "/api/feature-releases?";
        if (featureId !== undefined && featureId !== null)
            url_ += "featureId=" + encodeURIComponent("" + featureId) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (before !== undefined && before !== null)
            url_ += "before=" + encodeURIComponent("" + before) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListReleases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListReleases(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimeReleaseListPage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimeReleaseListPage>;
        }));
    }

    protected processListReleases(response: HttpResponseBase): Observable<RuntimeReleaseListPage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeReleaseListPage;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * A release's event timeline (6G.11), in recorded order and bounded; 404 for a release outside this binding.
     */
    getReleaseEvents(releaseId: string): Observable<RuntimeReleaseEventsPage> {
        let url_ = this.baseUrl + "/api/feature-releases/{releaseId}/events";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReleaseEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReleaseEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimeReleaseEventsPage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimeReleaseEventsPage>;
        }));
    }

    protected processGetReleaseEvents(response: HttpResponseBase): Observable<RuntimeReleaseEventsPage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeReleaseEventsPage;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The admin content preview's feature list (6G.13): the registry features with a What's New entry or article in the current
    verified server bundle, or a walkthrough. Read-only, InspectRuntimeFeaturePolicy or ManageFeatureReleases,
    behind RuntimeFeatureReleases:Enabled (404 while off). Reads only the registry and the cached bundle.
     */
    getContentPreviewIndex(): Observable<FeatureContentIndex> {
        let url_ = this.baseUrl + "/api/feature-releases/content-preview";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContentPreviewIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContentPreviewIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeatureContentIndex>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeatureContentIndex>;
        }));
    }

    protected processGetContentPreviewIndex(response: HttpResponseBase): Observable<FeatureContentIndex> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeatureContentIndex;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * What one audience (reviewer, projectAdministrator or signedOut) would get for one feature
    (6G.13): its What's New entries, help articles and walkthrough under the disclosure rules (FeatureContentPreview).
    400 for another audience, 404 for a feature the registry does not have. Same gate and switch as the list.
     * @param audience (optional) 
     */
    getContentPreview(featureId: string, audience?: string | null | undefined): Observable<FeatureContentPreviewResponse> {
        let url_ = this.baseUrl + "/api/feature-releases/content-preview/{featureId}?";
        if (featureId === undefined || featureId === null)
            throw new Error("The parameter 'featureId' must be defined.");
        url_ = url_.replace("{featureId}", encodeURIComponent("" + featureId));
        if (audience !== undefined && audience !== null)
            url_ += "audience=" + encodeURIComponent("" + audience) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContentPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContentPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeatureContentPreviewResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeatureContentPreviewResponse>;
        }));
    }

    protected processGetContentPreview(response: HttpResponseBase): Observable<FeatureContentPreviewResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeatureContentPreviewResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The admin "Ready to settle" list (6G.12, D21, D43 = B): every Release-type feature that is not Settled or Withdrawn, with
    when it went live for everyone here from its release record and from the flag history (the later date is used), its
    settle period, the date it is ready on and its status. Read-only, behind RuntimeFeatureReleases:Enabled (404 while
    off); this environment's records only.
     */
    getReadyToSettle(): Observable<RuntimeReadyToSettlePage> {
        let url_ = this.baseUrl + "/api/feature-releases/ready-to-settle";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReadyToSettle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReadyToSettle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimeReadyToSettlePage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimeReadyToSettlePage>;
        }));
    }

    protected processGetReadyToSettle(response: HttpResponseBase): Observable<RuntimeReadyToSettlePage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeReadyToSettlePage;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Side-effect-free Apply plan against current policy: digest, identities, admission and queued announcements.
     */
    previewReleaseApply(releaseId: string, request: RuntimeReleaseApplyRequest): Observable<RuntimeReleaseApplyPreview> {
        let url_ = this.baseUrl + "/api/feature-releases/{releaseId}/apply/preview";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreviewReleaseApply(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreviewReleaseApply(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimeReleaseApplyPreview>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimeReleaseApplyPreview>;
        }));
    }

    protected processPreviewReleaseApply(response: HttpResponseBase): Observable<RuntimeReleaseApplyPreview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeReleaseApplyPreview;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Apply a Prepared release: one transaction commits its policy, record, event and queued announcements.
     */
    applyRelease(releaseId: string, request: RuntimeReleaseApplyRequest): Observable<RuntimeAppliedRelease> {
        let url_ = this.baseUrl + "/api/feature-releases/{releaseId}/apply";
        if (releaseId === undefined || releaseId === null)
            throw new Error("The parameter 'releaseId' must be defined.");
        url_ = url_.replace("{releaseId}", encodeURIComponent("" + releaseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplyRelease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplyRelease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimeAppliedRelease>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimeAppliedRelease>;
        }));
    }

    protected processApplyRelease(response: HttpResponseBase): Observable<RuntimeAppliedRelease> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeAppliedRelease;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Commit a safe-state stop; this response does not assert fleet adoption.
     */
    emergencyStop(key: string, request: RuntimePolicyEmergencyStopRequest): Observable<RuntimePolicyCommitStatus> {
        let url_ = this.baseUrl + "/api/runtime-feature-flags/{key}/emergency-stop";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmergencyStop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmergencyStop(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimePolicyCommitStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimePolicyCommitStatus>;
        }));
    }

    protected processEmergencyStop(response: HttpResponseBase): Observable<RuntimePolicyCommitStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimePolicyCommitStatus;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Administrator recovery only; does not assert deployment completion or fleet readiness.
     */
    breakGlassRelease(rolloutId: string, request: RuntimeDeploymentBreakGlassRequest): Observable<RuntimeCoordinatorReceipt> {
        let url_ = this.baseUrl + "/api/environment/deployment-constraints/{rolloutId}/break-glass-release";
        if (rolloutId === undefined || rolloutId === null)
            throw new Error("The parameter 'rolloutId' must be defined.");
        url_ = url_.replace("{rolloutId}", encodeURIComponent("" + rolloutId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBreakGlassRelease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBreakGlassRelease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimeCoordinatorReceipt>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimeCoordinatorReceipt>;
        }));
    }

    protected processBreakGlassRelease(response: HttpResponseBase): Observable<RuntimeCoordinatorReceipt> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeCoordinatorReceipt;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    put(key: string, mutation: RuntimeFeatureFlagMutation): Observable<RuntimeFeatureFlagSnapshot> {
        let url_ = this.baseUrl + "/api/runtime-feature-flags/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mutation);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimeFeatureFlagSnapshot>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimeFeatureFlagSnapshot>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<RuntimeFeatureFlagSnapshot> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeFeatureFlagSnapshot;
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeFeatureFlagDependencyProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    putGroup(key: string, mutation: RuntimeFeatureFlagMutation): Observable<RuntimeFeatureFlagSnapshot> {
        let url_ = this.baseUrl + "/api/runtime-feature-flags/groups/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mutation);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuntimeFeatureFlagSnapshot>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuntimeFeatureFlagSnapshot>;
        }));
    }

    protected processPutGroup(response: HttpResponseBase): Observable<RuntimeFeatureFlagSnapshot> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeFeatureFlagSnapshot;
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RuntimeFeatureFlagDependencyProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IScreeningHttpService {
    postScreeningSettings(projectId: string, screeningAgreementMode: AgreementMode): Observable<ProjectFullDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ScreeningHttpService implements IScreeningHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    postScreeningSettings(projectId: string, screeningAgreementMode: AgreementMode): Observable<ProjectFullDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/screening/settings";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(screeningAgreementMode);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostScreeningSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostScreeningSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectFullDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectFullDto>;
        }));
    }

    protected processPostScreeningSettings(response: HttpResponseBase): Observable<ProjectFullDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectFullDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IScreeningOverviewStatisticsHttpService {
    getScreeningOverviewStatistics(projectId: string): Observable<ScreeningOverviewStatistics>;
}

@Injectable({
    providedIn: 'root'
})
export class ScreeningOverviewStatisticsHttpService implements IScreeningOverviewStatisticsHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getScreeningOverviewStatistics(projectId: string): Observable<ScreeningOverviewStatistics> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/screening-overview-statistics";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScreeningOverviewStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScreeningOverviewStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScreeningOverviewStatistics>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScreeningOverviewStatistics>;
        }));
    }

    protected processGetScreeningOverviewStatistics(response: HttpResponseBase): Observable<ScreeningOverviewStatistics> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScreeningOverviewStatistics;
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IStageAllocationReadHttpService {
    getMyStudies(projectId: string, stageId: string, offset?: number | undefined, limit?: number | undefined): Observable<MyAllocatedStudiesDto>;
    getProgress(projectId: string, stageId: string): Observable<StageAllocationProgressDto>;
}

@Injectable({
    providedIn: 'root'
})
export class StageAllocationReadHttpService implements IStageAllocationReadHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getMyStudies(projectId: string, stageId: string, offset?: number | undefined, limit?: number | undefined): Observable<MyAllocatedStudiesDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}/workload-shares/my-studies?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyStudies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyStudies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyAllocatedStudiesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyAllocatedStudiesDto>;
        }));
    }

    protected processGetMyStudies(response: HttpResponseBase): Observable<MyAllocatedStudiesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MyAllocatedStudiesDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProgress(projectId: string, stageId: string): Observable<StageAllocationProgressDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}/workload-shares/progress";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StageAllocationProgressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StageAllocationProgressDto>;
        }));
    }

    protected processGetProgress(response: HttpResponseBase): Observable<StageAllocationProgressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StageAllocationProgressDto;
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IStageOverviewStatisticsHttpService {
    getStageOverviewStatistics(projectId: string, stageId: string): Observable<StageOverviewStatistics>;
}

@Injectable({
    providedIn: 'root'
})
export class StageOverviewStatisticsHttpService implements IStageOverviewStatisticsHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getStageOverviewStatistics(projectId: string, stageId: string): Observable<StageOverviewStatistics> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}/overview-statistics";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStageOverviewStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStageOverviewStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StageOverviewStatistics>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StageOverviewStatistics>;
        }));
    }

    protected processGetStageOverviewStatistics(response: HttpResponseBase): Observable<StageOverviewStatistics> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StageOverviewStatistics;
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IStageReviewSettingsHttpService {
    get(projectId: string, stageId: string): Observable<ReviewSettingsReadResponse>;
    put(projectId: string, stageId: string, request: ReviewSettingsSaveRequest): Observable<ReviewSettingsSaveResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class StageReviewSettingsHttpService implements IStageReviewSettingsHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(projectId: string, stageId: string): Observable<ReviewSettingsReadResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}/review-settings";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReviewSettingsReadResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReviewSettingsReadResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ReviewSettingsReadResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReviewSettingsReadResponse;
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    put(projectId: string, stageId: string, request: ReviewSettingsSaveRequest): Observable<ReviewSettingsSaveResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}/review-settings";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReviewSettingsSaveResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReviewSettingsSaveResponse>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<ReviewSettingsSaveResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReviewSettingsSaveResponse;
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReviewSettingsSaveResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IStageStatisticsHttpService {
    /**
     * One stage's current annotation session distribution — the numbers the Stage Overview
    annotation pie renders.
     */
    getStageAnnotationStats(projectId: string, stageId: string): Observable<StageAnnotationStats>;
}

@Injectable({
    providedIn: 'root'
})
export class StageStatisticsHttpService implements IStageStatisticsHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * One stage's current annotation session distribution — the numbers the Stage Overview
    annotation pie renders.
     */
    getStageAnnotationStats(projectId: string, stageId: string): Observable<StageAnnotationStats> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}/annotation-stats";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStageAnnotationStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStageAnnotationStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StageAnnotationStats>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StageAnnotationStats>;
        }));
    }

    protected processGetStageAnnotationStats(response: HttpResponseBase): Observable<StageAnnotationStats> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StageAnnotationStats;
            return _observableOf(result200);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IStageStatisticsHistoryHttpService {
    getStageAnnotationHistory(projectId: string, stageId: string, limit?: number | null | undefined, after?: string | null | undefined): Observable<StageAnnotationHistoryPage>;
}

@Injectable({
    providedIn: 'root'
})
export class StageStatisticsHistoryHttpService implements IStageStatisticsHistoryHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getStageAnnotationHistory(projectId: string, stageId: string, limit?: number | null | undefined, after?: string | null | undefined): Observable<StageAnnotationHistoryPage> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}/annotation-history?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (after !== undefined && after !== null)
            url_ += "after=" + encodeURIComponent("" + after) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStageAnnotationHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStageAnnotationHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StageAnnotationHistoryPage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StageAnnotationHistoryPage>;
        }));
    }

    protected processGetStageAnnotationHistory(response: HttpResponseBase): Observable<StageAnnotationHistoryPage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StageAnnotationHistoryPage;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IStageWorkloadSharesHttpService {
    get(projectId: string, stageId: string): Observable<StageWorkloadSharesDto>;
    put(projectId: string, stageId: string, request: UpdateStageWorkloadSharesDto): Observable<StageWorkloadSharesDto>;
}

@Injectable({
    providedIn: 'root'
})
export class StageWorkloadSharesHttpService implements IStageWorkloadSharesHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(projectId: string, stageId: string): Observable<StageWorkloadSharesDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}/workload-shares";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StageWorkloadSharesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StageWorkloadSharesDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StageWorkloadSharesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StageWorkloadSharesDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    put(projectId: string, stageId: string, request: UpdateStageWorkloadSharesDto): Observable<StageWorkloadSharesDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/stages/{stageId}/workload-shares";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StageWorkloadSharesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StageWorkloadSharesDto>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<StageWorkloadSharesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StageWorkloadSharesDto;
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IStudyHttpService {
    getTableData(projectId: string, incomingTableParams: IncomingTableParamsDtoOfStudyFilters): Observable<PagedDataDtoOfStudyDetailsDto>;
    getPdfUploadSignature(projectId: string, studyId: string, pdfUploadSignatureRequestDto: PdfUploadSignatureRequestDto): Observable<FileUploadSignature>;
    submitStudyCorrection(projectId: string, studyId: string, studyPdfCorrectionDto: StudyCorrectionDto): Observable<void>;
    approveCorrection(projectId: string, studyId: string, correctionId: string): Observable<StudyDetailsDto>;
    rejectCorrection(projectId: string, studyId: string, correctionId: string): Observable<StudyDetailsDto>;
    get(projectId: string, studyId: string): Observable<StudySummaryDto>;
    getRobStudies(projectId: string): Observable<StudyROBOutputDto[]>;
    addRoBtoStudy(projectId: string, studyRiskOfBiasInputDto: StudyRiskOfBiasInputDto): Observable<string>;
    addRoBtoStudies(projectId: string, studyInputDtos: StudyRiskOfBiasInputDto[]): Observable<string>;
    getBulkStudyUpdateS3RequestSignature(projectId: string, requestInfo: SearchUpdateSignatureRequestDto): Observable<FileUploadSignature>;
    /**
     * Records that the browser's direct S3 PUT for a bulk study update failed.
            
    GetBulkStudyUpdateS3RequestSignature persists the job as
    UploadingToS3 before the browser uploads anything, and the server never observes that
    PUT, so before this endpoint existed a failed upload read as a permanently uploading job
    after a refresh. The report is authorised exactly as the signature it closes.
            
    It is idempotent: a repeated report on an already-failed job returns the job unchanged, and
    a report that arrives after the server has seen the object is refused with 409 rather than
    overwriting authoritative progress.
     */
    reportBulkStudyUpdateUploadFailure(projectId: string, updateFileId: string): Observable<BulkStudyUpdateJobDto>;
}

@Injectable({
    providedIn: 'root'
})
export class StudyHttpService implements IStudyHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getTableData(projectId: string, incomingTableParams: IncomingTableParamsDtoOfStudyFilters): Observable<PagedDataDtoOfStudyDetailsDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/studies";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(incomingTableParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTableData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTableData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedDataDtoOfStudyDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedDataDtoOfStudyDetailsDto>;
        }));
    }

    protected processGetTableData(response: HttpResponseBase): Observable<PagedDataDtoOfStudyDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedDataDtoOfStudyDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPdfUploadSignature(projectId: string, studyId: string, pdfUploadSignatureRequestDto: PdfUploadSignatureRequestDto): Observable<FileUploadSignature> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/studies/{studyId}/UploadSignature";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pdfUploadSignatureRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdfUploadSignature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdfUploadSignature(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadSignature>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadSignature>;
        }));
    }

    protected processGetPdfUploadSignature(response: HttpResponseBase): Observable<FileUploadSignature> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileUploadSignature;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    submitStudyCorrection(projectId: string, studyId: string, studyPdfCorrectionDto: StudyCorrectionDto): Observable<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/studies/{studyId}/Pdf/Correction";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(studyPdfCorrectionDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitStudyCorrection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitStudyCorrection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSubmitStudyCorrection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    approveCorrection(projectId: string, studyId: string, correctionId: string): Observable<StudyDetailsDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/studies/{studyId}/Pdf/Correction/{correctionId}/Approve";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (correctionId === undefined || correctionId === null)
            throw new Error("The parameter 'correctionId' must be defined.");
        url_ = url_.replace("{correctionId}", encodeURIComponent("" + correctionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveCorrection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveCorrection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StudyDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StudyDetailsDto>;
        }));
    }

    protected processApproveCorrection(response: HttpResponseBase): Observable<StudyDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rejectCorrection(projectId: string, studyId: string, correctionId: string): Observable<StudyDetailsDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/studies/{studyId}/Pdf/Correction/{correctionId}/Reject";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (correctionId === undefined || correctionId === null)
            throw new Error("The parameter 'correctionId' must be defined.");
        url_ = url_.replace("{correctionId}", encodeURIComponent("" + correctionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectCorrection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectCorrection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StudyDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StudyDetailsDto>;
        }));
    }

    protected processRejectCorrection(response: HttpResponseBase): Observable<StudyDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(projectId: string, studyId: string): Observable<StudySummaryDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/studies/{studyId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StudySummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StudySummaryDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StudySummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudySummaryDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRobStudies(projectId: string): Observable<StudyROBOutputDto[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/studies/getRobStudies";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRobStudies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRobStudies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StudyROBOutputDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StudyROBOutputDto[]>;
        }));
    }

    protected processGetRobStudies(response: HttpResponseBase): Observable<StudyROBOutputDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyROBOutputDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addRoBtoStudy(projectId: string, studyRiskOfBiasInputDto: StudyRiskOfBiasInputDto): Observable<string> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/studies/addRob";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(studyRiskOfBiasInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRoBtoStudy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRoBtoStudy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddRoBtoStudy(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addRoBtoStudies(projectId: string, studyInputDtos: StudyRiskOfBiasInputDto[]): Observable<string> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/studies/addRobs";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(studyInputDtos);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRoBtoStudies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRoBtoStudies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddRoBtoStudies(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBulkStudyUpdateS3RequestSignature(projectId: string, requestInfo: SearchUpdateSignatureRequestDto): Observable<FileUploadSignature> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/studies/getSignatureForBulkStudyUpdate";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestInfo);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBulkStudyUpdateS3RequestSignature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBulkStudyUpdateS3RequestSignature(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadSignature>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadSignature>;
        }));
    }

    protected processGetBulkStudyUpdateS3RequestSignature(response: HttpResponseBase): Observable<FileUploadSignature> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileUploadSignature;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Records that the browser's direct S3 PUT for a bulk study update failed.
            
    GetBulkStudyUpdateS3RequestSignature persists the job as
    UploadingToS3 before the browser uploads anything, and the server never observes that
    PUT, so before this endpoint existed a failed upload read as a permanently uploading job
    after a refresh. The report is authorised exactly as the signature it closes.
            
    It is idempotent: a repeated report on an already-failed job returns the job unchanged, and
    a report that arrives after the server has seen the object is refused with 409 rather than
    overwriting authoritative progress.
     */
    reportBulkStudyUpdateUploadFailure(projectId: string, updateFileId: string): Observable<BulkStudyUpdateJobDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/studies/bulkStudyUpdate/{updateFileId}/reportUploadFailure";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (updateFileId === undefined || updateFileId === null)
            throw new Error("The parameter 'updateFileId' must be defined.");
        url_ = url_.replace("{updateFileId}", encodeURIComponent("" + updateFileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportBulkStudyUpdateUploadFailure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportBulkStudyUpdateUploadFailure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkStudyUpdateJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkStudyUpdateJobDto>;
        }));
    }

    protected processReportBulkStudyUpdateUploadFailure(response: HttpResponseBase): Observable<BulkStudyUpdateJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkStudyUpdateJobDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IStudyConversationsHttpService {
    candidates(projectId?: string | undefined, studyId?: string | undefined, stageId?: string | undefined): Observable<ConversationCandidateDto[]>;
    create(request: ConversationQuestionRequest): Observable<StudyConversationDto>;
    list(projectId?: string | undefined, studyId?: string | undefined, stageId?: string | undefined): Observable<ConversationSummaryDto[]>;
    get(id: string): Observable<StudyConversationDto>;
    reply(id: string, request: ConversationReplyRequest): Observable<StudyConversationDto>;
}

@Injectable({
    providedIn: 'root'
})
export class StudyConversationsHttpService implements IStudyConversationsHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    candidates(projectId?: string | undefined, studyId?: string | undefined, stageId?: string | undefined): Observable<ConversationCandidateDto[]> {
        let url_ = this.baseUrl + "/api/study-conversations/candidates?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (studyId === null)
            throw new Error("The parameter 'studyId' cannot be null.");
        else if (studyId !== undefined)
            url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
        if (stageId === null)
            throw new Error("The parameter 'stageId' cannot be null.");
        else if (stageId !== undefined)
            url_ += "stageId=" + encodeURIComponent("" + stageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCandidates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCandidates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConversationCandidateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConversationCandidateDto[]>;
        }));
    }

    protected processCandidates(response: HttpResponseBase): Observable<ConversationCandidateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConversationCandidateDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(request: ConversationQuestionRequest): Observable<StudyConversationDto> {
        let url_ = this.baseUrl + "/api/study-conversations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StudyConversationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StudyConversationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<StudyConversationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyConversationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    list(projectId?: string | undefined, studyId?: string | undefined, stageId?: string | undefined): Observable<ConversationSummaryDto[]> {
        let url_ = this.baseUrl + "/api/study-conversations?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (studyId === null)
            throw new Error("The parameter 'studyId' cannot be null.");
        else if (studyId !== undefined)
            url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
        if (stageId === null)
            throw new Error("The parameter 'stageId' cannot be null.");
        else if (stageId !== undefined)
            url_ += "stageId=" + encodeURIComponent("" + stageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConversationSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConversationSummaryDto[]>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ConversationSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConversationSummaryDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id: string): Observable<StudyConversationDto> {
        let url_ = this.baseUrl + "/api/study-conversations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StudyConversationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StudyConversationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StudyConversationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyConversationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reply(id: string, request: ConversationReplyRequest): Observable<StudyConversationDto> {
        let url_ = this.baseUrl + "/api/study-conversations/{id}/replies";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReply(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReply(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StudyConversationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StudyConversationDto>;
        }));
    }

    protected processReply(response: HttpResponseBase): Observable<StudyConversationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StudyConversationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISupportImpersonationHttpService {
    /**
     * The people an impersonation can be started for, for the Admin Console picker. Requires the caller's
    current ImpersonateUsers (not ListUsers: a support holder need not be an administrator), and
    returns only names, email and whether the account is deactivated. Refused while impersonating.
     */
    getCandidates(): Observable<SupportImpersonationCandidateDto[]>;
    /**
     * The current impersonation mode for this tab (read-only unless its edit context is valid).
     */
    getSession(): Observable<SupportImpersonationSessionDto>;
    /**
     * Deliberately enter edit mode for the current target (S4). Returns a new handle, valid for at most the
    maximum lifetime and never extended; the audit records the actor and the target.
     */
    openEditContext(): Observable<SupportImpersonationEditContextDto>;
    /**
     * End every open edit context of the signed-in user (S5/S6): a deliberate switch to read-only, the end of
    impersonation, a target change or a reload. Needs no capability (ending is always safe) and no target.
     * @param reason (optional) 
     */
    endEditContexts(reason?: string | null | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class SupportImpersonationHttpService implements ISupportImpersonationHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * The people an impersonation can be started for, for the Admin Console picker. Requires the caller's
    current ImpersonateUsers (not ListUsers: a support holder need not be an administrator), and
    returns only names, email and whether the account is deactivated. Refused while impersonating.
     */
    getCandidates(): Observable<SupportImpersonationCandidateDto[]> {
        let url_ = this.baseUrl + "/api/impersonation/candidates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupportImpersonationCandidateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupportImpersonationCandidateDto[]>;
        }));
    }

    protected processGetCandidates(response: HttpResponseBase): Observable<SupportImpersonationCandidateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SupportImpersonationCandidateDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The current impersonation mode for this tab (read-only unless its edit context is valid).
     */
    getSession(): Observable<SupportImpersonationSessionDto> {
        let url_ = this.baseUrl + "/api/impersonation/session";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupportImpersonationSessionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupportImpersonationSessionDto>;
        }));
    }

    protected processGetSession(response: HttpResponseBase): Observable<SupportImpersonationSessionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SupportImpersonationSessionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deliberately enter edit mode for the current target (S4). Returns a new handle, valid for at most the
    maximum lifetime and never extended; the audit records the actor and the target.
     */
    openEditContext(): Observable<SupportImpersonationEditContextDto> {
        let url_ = this.baseUrl + "/api/impersonation/edit-context";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpenEditContext(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpenEditContext(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupportImpersonationEditContextDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupportImpersonationEditContextDto>;
        }));
    }

    protected processOpenEditContext(response: HttpResponseBase): Observable<SupportImpersonationEditContextDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SupportImpersonationEditContextDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * End every open edit context of the signed-in user (S5/S6): a deliberate switch to read-only, the end of
    impersonation, a target change or a reload. Needs no capability (ending is always safe) and no target.
     * @param reason (optional) 
     */
    endEditContexts(reason?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/impersonation/edit-context?";
        if (reason !== undefined && reason !== null)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEndEditContexts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEndEditContexts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEndEditContexts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBffAuthHttpService {
    /**
     * Initiates the OIDC auth code + PKCE flow.
    Generates PKCE verifier, stores it in a temp cookie, and redirects to the IdP.
    Pass screen_hint=signup to direct the IdP to show the signup page (Auth0 Universal Login).
    Pass prompt=none (the only accepted prompt value) for a silent sign-in attempt: the IdP
    either issues a code from its existing session or answers with an OIDC error, which the
    callback turns into a local redirect carrying the silent-failure marker.
    Add mode=frame (the only accepted mode, honoured only with prompt=none) when the attempt
    runs in a hidden iframe: every outcome then ends on SilentCompletePath,
    which reports it to the parent window, instead of navigating to returnUrl.
     * @param returnUrl (optional) 
     * @param screenHint (optional) 
     * @param prompt (optional) 
     * @param mode (optional) 
     */
    login(returnUrl?: string | null | undefined, screenHint?: string | null | undefined, prompt?: string | null | undefined, mode?: string | null | undefined): Observable<FileResponse>;
    /**
     * Convenience endpoint for signup — redirects to the IdP's signup page.
    Equivalent to GET /api/auth/login?screen_hint=signup.
     * @param returnUrl (optional) 
     */
    signup(returnUrl?: string | null | undefined): Observable<FileResponse>;
    /**
     * OIDC callback — exchanges the auth code for tokens, creates a session, sets cookie.
    An authorization error response (?error=…, no code) returns the browser to
    the app with a sanitised error indicator instead of failing model validation.
     * @param code (optional) 
     * @param state (optional) 
     * @param error (optional) 
     * @param errorDescription (optional) 
     */
    callback(code?: string | null | undefined, state?: string | null | undefined, error?: string | null | undefined, errorDescription?: string | null | undefined): Observable<FileResponse>;
    /**
     * Hands the browser over to one native Identity account page so My Account
    can manage sign-in methods when the web app authenticates through the BFF:
    external-logins (link/remove a social sign-in), passkeys or
    two-factor (account portal slices 1 and 2).
     * @param returnTo (optional) 
     * @param theme (optional) 
     */
    accountPage(page: string, returnTo?: string | null | undefined, theme?: string | null | undefined): Observable<FileResponse>;
    /**
     * Returns the current user's profile, or 401 if not authenticated.
     */
    me(): Observable<FileResponse>;
    /**
     * Logs out: removes server session, clears cookie, and returns IdP logout URL if available.
    The client should redirect to the IdP logout URL to terminate the IdP session.
     */
    logout(): Observable<FileResponse>;
    /**
     * Refreshes the access token using the stored refresh token.
    Updates the session with new tokens.
     */
    refresh(): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class BffAuthHttpService implements IBffAuthHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Initiates the OIDC auth code + PKCE flow.
    Generates PKCE verifier, stores it in a temp cookie, and redirects to the IdP.
    Pass screen_hint=signup to direct the IdP to show the signup page (Auth0 Universal Login).
    Pass prompt=none (the only accepted prompt value) for a silent sign-in attempt: the IdP
    either issues a code from its existing session or answers with an OIDC error, which the
    callback turns into a local redirect carrying the silent-failure marker.
    Add mode=frame (the only accepted mode, honoured only with prompt=none) when the attempt
    runs in a hidden iframe: every outcome then ends on SilentCompletePath,
    which reports it to the parent window, instead of navigating to returnUrl.
     * @param returnUrl (optional) 
     * @param screenHint (optional) 
     * @param prompt (optional) 
     * @param mode (optional) 
     */
    login(returnUrl?: string | null | undefined, screenHint?: string | null | undefined, prompt?: string | null | undefined, mode?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/auth/login?";
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        if (screenHint !== undefined && screenHint !== null)
            url_ += "screen_hint=" + encodeURIComponent("" + screenHint) + "&";
        if (prompt !== undefined && prompt !== null)
            url_ += "prompt=" + encodeURIComponent("" + prompt) + "&";
        if (mode !== undefined && mode !== null)
            url_ += "mode=" + encodeURIComponent("" + mode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Convenience endpoint for signup — redirects to the IdP's signup page.
    Equivalent to GET /api/auth/login?screen_hint=signup.
     * @param returnUrl (optional) 
     */
    signup(returnUrl?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/auth/signup?";
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSignup(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * OIDC callback — exchanges the auth code for tokens, creates a session, sets cookie.
    An authorization error response (?error=…, no code) returns the browser to
    the app with a sanitised error indicator instead of failing model validation.
     * @param code (optional) 
     * @param state (optional) 
     * @param error (optional) 
     * @param errorDescription (optional) 
     */
    callback(code?: string | null | undefined, state?: string | null | undefined, error?: string | null | undefined, errorDescription?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/auth/callback?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (error !== undefined && error !== null)
            url_ += "error=" + encodeURIComponent("" + error) + "&";
        if (errorDescription !== undefined && errorDescription !== null)
            url_ += "error_description=" + encodeURIComponent("" + errorDescription) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCallback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCallback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCallback(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Hands the browser over to one native Identity account page so My Account
    can manage sign-in methods when the web app authenticates through the BFF:
    external-logins (link/remove a social sign-in), passkeys or
    two-factor (account portal slices 1 and 2).
     * @param returnTo (optional) 
     * @param theme (optional) 
     */
    accountPage(page: string, returnTo?: string | null | undefined, theme?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/auth/account/{page}?";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (returnTo !== undefined && returnTo !== null)
            url_ += "returnTo=" + encodeURIComponent("" + returnTo) + "&";
        if (theme !== undefined && theme !== null)
            url_ += "theme=" + encodeURIComponent("" + theme) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountPage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAccountPage(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns the current user's profile, or 401 if not authenticated.
     */
    me(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/auth/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMe(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Logs out: removes server session, clears cookie, and returns IdP logout URL if available.
    The client should redirect to the IdP logout URL to terminate the IdP session.
     */
    logout(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/auth/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Refreshes the access token using the stored refresh token.
    Updates the session with new tokens.
     */
    refresh(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/auth/refresh";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefresh(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefresh(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processRefresh(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDevAuthHttpService {
    /**
     * Returns a list of investigators the developer can log in as.
     * @param returnUrl (optional) 
     */
    getInvestigators(returnUrl?: string | null | undefined): Observable<FileResponse>;
    /**
     * Creates a BFF session for the selected investigator.
     */
    loginAs(request: DevLoginRequest): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class DevAuthHttpService implements IDevAuthHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns a list of investigators the developer can log in as.
     * @param returnUrl (optional) 
     */
    getInvestigators(returnUrl?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/dev-auth/login?";
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvestigators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvestigators(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetInvestigators(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a BFF session for the selected investigator.
     */
    loginAs(request: DevLoginRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/dev-auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginAs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginAs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processLoginAs(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IE2EAuthHttpService {
    /**
     * Creates a BFF session directly from the provided user data.
    No OIDC flow — session is created immediately.
     */
    login(request: E2ELoginRequest): Observable<FileResponse>;
    /**
     * Destroys the current E2E session.
     */
    logout(): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class E2EAuthHttpService implements IE2EAuthHttpService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Creates a BFF session directly from the provided user data.
    No OIDC flow — session is created immediately.
     */
    login(request: E2ELoginRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/e2e-auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Destroys the current E2E session.
     */
    logout(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/e2e-auth/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface EntityDtoOfGuid {
    id: string;
}

export interface AggregateRootDtoOfGuid extends EntityDtoOfGuid {
    audit: AuditDto | null;
}

export interface SearchDto extends AggregateRootDtoOfGuid {
    name: string;
    /** Null in project details for a member who holds none of viewSearches, importSearch or removeSearch. */
    description: string | null;
    projectId: string;
    livingSearchId: string | null;
    fromLivingSearch: boolean;
    syrfReferenceFiles: StudyReferenceFileDto[];
    numberOfStudies: number;
    completeness: EntityCompleteness;
}

export interface StudyReferenceFileDto {
    id: string;
    libraryType: LibraryFileType;
    url: string;
    numberOfStudies: number;
}

export enum LibraryFileType {
    EndnoteXml = 0,
    LivingSearchJson = 1,
    TsvLibrary = 2,
    CsvLibrary = 3,
    PubmedXml = 4,
    Ris = 5,
    PubmedNbib = 6,
    ZoteroRdf = 7,
}

export enum EntityCompleteness {
    Summary = 0,
    Standard = 1,
    Full = 2,
}

export interface AuditDto {
    created: string;
    createdBy: string | null;
    lastModified: string | null;
    lastModifiedBy: string | null;
    version: number;
    schemaVersion: number;
    lastAppVersion: string | null;
    retrievedAt: string;
}

export interface ProblemDetails {
    type: string | null;
    title: string | null;
    status: number | null;
    detail: string | null;
    instance: string | null;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export interface ProjectDbBaseDto extends AggregateRootDtoOfGuid {
    name: string;
    protocolLink: string;
    keywords: string[];
    completionDate: string | null;
    contactEmail: string;
    isPublic: boolean;
    ownerId: string;
    hasPendingJoinRequest: boolean;
    hasPendingInvitation: boolean;
    isMember: boolean | null;
    membershipDate: string | null;
    archived: boolean;
    description: string;
    autoApproveJoinRequests: boolean;
    screeningMachineLearningEnabled: boolean;
    inclusionCriteria: string | null;
    exclusionCriteria: string | null;
    schemaVersion: number;
    supportsMultiOptionConditionalParentAnswers: boolean;
    livingSearches: LivingSearchDto[];
    joinRequest: JoinRequestDto | null;
    invitation: InvitationFullDto | null;
    isAdmin: boolean | null;
    isOwner: boolean | null;
    isDisabled: boolean | null;
    membershipCount: number;
    /** Project-level default "Guidance for reviewers" text, keyed by annotation-question
category (revision-2 README §6.5). Entity classes and their categories are project-level,
so this is where guidance is normally defined; a stage may override any category. Empty —
never null — when none is written. Written by
PUT api/projects/{projectId}/category-guidance. */
    categoryGuidance: { [key: string]: string; };
    /** Screening inclusion keywords highlighted for reviewers in the integrated PDF viewer
(FEAT-025). Empty — never null — when none are written. Written by
PUT api/projects/{projectId}/screening-keywords. */
    screeningInclusionKeywords: string[];
    /** Screening exclusion keywords (FEAT-025); empty when none are written. */
    screeningExclusionKeywords: string[];
}

export interface ProjectStandardDto extends ProjectDbBaseDto {
    details: ProjectDetailsDto;
    secureDetails: string;
    completeness: EntityCompleteness;
}

export interface ProjectDetailsDto {
    id: string;
    creator: FullName;
    permissionReport: PermissionReport;
    agreementMode: AgreementMode;
    agreementThreshold: ProjectAgreementThreshold;
    calculatingInclusionInfo: boolean;
    groups: ProjectGroupDto[];
    searches: SearchDto[];
    annotationQuestions: AnnotationQuestionDto[];
    stages: StageDto[];
    searchImportJobs: SearchImportJobDto[];
    bulkStudyUpdateJobs: BulkStudyUpdateJobDto[];
    riskOfBiasJobs: RiskOfBiasJobDto[];
    /** Bulk PDF upload jobs for the project. Must stay declared here: AutoMapper drops unmapped
properties, and this collection is what carries upload progress to the browser over the
project SignalR stream (decision B3). */
    bulkPdfUploadJobs: BulkPdfUploadJobDto[];
    membership: MembershipSummaryDto | null;
    projectId: string;
}

export interface ValueObjectOfFullName {
}

export interface FullName extends ValueObjectOfFullName {
    first: string;
    surname: string;
    preferred: string | null;
}

export interface PermissionReport {
    project: { [key: string]: boolean; };
    stages: { [key: string]: { [key: string]: boolean; }; };
}

export enum AgreementMode {
    Custom = 0,
    AutomatedDualScreening = 1,
    ManualDualScreening = 2,
    SingleScreening = 3,
}

export interface ValueObjectOfAgreementMeasure {
}

export interface AgreementMeasure extends ValueObjectOfAgreementMeasure {
    absoluteAgreementRatio: number | null;
    numberScreened: number;
}

export interface ProjectAgreementThreshold extends AgreementMeasure {
}

export interface ProjectGroupDto {
    id: string;
    name: string;
    system: boolean;
    projectId: string;
}

export interface AnnotationQuestionDto {
    id: string;
    target: TargetDto | null;
    question: string;
    description: string | null;
    optional: boolean;
    multiple: boolean;
    labelQuestion: boolean;
    root: boolean;
    system: boolean;
    annotationLookup: boolean;
    category: string;
    notes: boolean;
    questionType: string;
    emptyLookupText: string | null;
    controlType: string;
    subquestionIds: string[];
    options: QuestionOptionDto[] | null;
    projectId: string;
    answerArray: boolean;
    /** Singular noun naming one repeatable answer instance, e.g. "experimental
protocol". Null means the client derives a label from the question text. */
    answerLabel: string | null;
    /** True when AnswerLabel follows the generated heuristic;
false when authored. Null is legacy/unknown and must be treated as
authored by later writer behaviour. */
    answerLabelGenerated: boolean | null;
    defaultCheckboxStatus: CheckboxStatus | null;
    hidden: boolean;
    answeredAnnotationCount: AnnotationAnswerTally | null;
}

export interface TargetDto {
    parentId: string;
    conditionalParentAnswers: OptionConditionalTargetParentOptionsDto | BooleanConditionalTargetParentOptionsDto | null;
}

export interface ConditionalTargetParentOptionsDto {

    [key: string]: any;
}

export interface OptionConditionalTargetParentOptionsDto {
    conditionType: OptionConditionalTargetParentOptionsDtoConditionType;
    targetParentOptions: string[];
}

export interface BooleanConditionalTargetParentOptionsDto {
    conditionType: BooleanConditionalTargetParentOptionsDtoConditionType;
    targetParentBoolean: boolean;
}

export interface QuestionOptionDto {
    description: string | null;
    value: string;
    parentFilter: ParentFilterDto | null;
}

export interface ParentFilterDto {
}

export enum CheckboxStatus {
    Unchecked = 0,
    Checked = 1,
    Indeterminate = 2,
}

export interface AnnotationAnswerTally {
    studies: number;
    annotations: number;
}

export interface StageDto {
    id: string;
    name: string;
    active: boolean;
    projectId: string;
    annotationQuestions: string[];
    reviewMode: ReviewMode;
    studySelectionMode: StudySelectionMode;
    additionalScreeningPolicy: AdditionalScreeningPolicy | null;
    extraction: boolean;
    description: string;
    sessionCountTarget: number;
    maxInProgress: number | null;
    excludedSessionStatsGrouping: ExcludedSessionStatsGrouping;
    systematicSearchFilter: string[] | null;
    hideExcludedStudiesFromReviewers: boolean;
    partitionFilter: string[] | null;
    enforceAnnotationTarget: boolean;
    idleSessionTimeoutMinutes: number | null;
    /** The administrator guidance reviewers actually see in this stage, keyed by
annotation-question category (revision-2 README §6.5): the stage's own override where it
has one, otherwise the project-level default. Empty — never null — when neither is
written. Convenience for API consumers: the browser re-derives the same rule from
CategoryGuidanceOverride and the live project, because an administrator can
change a project default without the stage payload being refetched. */
    categoryGuidance: { [key: string]: string; };
    /** Only this stage's overrides, without the project defaults folded in, so the stage admin
screen can show which categories the stage overrides and which inherit. Written by
PUT api/projects/{projectId}/stages/{stageId}/category-guidance, one category at a time. */
    categoryGuidanceOverride: { [key: string]: string; };
    /** The project-level defaults this stage inherits, so the stage admin screen can show the
inherited text under an empty override without a second lookup. Written by
PUT api/projects/{projectId}/category-guidance. */
    projectCategoryGuidance: { [key: string]: string; };
    /** True while an enabled workload-share configuration owns this stage's reviewer split. The
domain refuses review-mode and reviews-per-study changes in that state, so the browser must
disable those inputs rather than let the user submit a request that can only fail. */
    workloadSharesEnabled: boolean;
}

export enum ReviewMode {
    Screening = 1,
    Annotation = 2,
    ScreeningAndAnnotation = 3,
}

export enum StudySelectionMode {
    Screening = 1,
    Annotation = 2,
    ScreeningAndAnnotation = 3,
}

export enum AdditionalScreeningPolicy {
    Allow = 1,
    Stop = 2,
}

export enum ExcludedSessionStatsGrouping {
    WithUnexcluded = 0,
    Separate = 1,
    Unavailable = 2,
}

/** DTO for SearchImportJob. Simplified to support only 1 reference file per search import job. Previously had a collection of ReferenceFileParseJobDto, now flattened. */
export interface SearchImportJobDto {
    id: string;
    name: string;
    description: string;
    projectId: string;
    livingSearchId: string | null;
    fromLivingSearch: boolean;
    status: SearchImportJobStatus;
    errors: string[];
    hasError: boolean;
    originalFileUrl: string;
    libraryType: LibraryFileType;
    screeningImportSettings: ScreeningImportSettings | null;
    hasScreeningDecisions: boolean;
    syrfReferenceFileUrl: string | null;
    totalNumberOfStudies: number | null;
    numberOfParsedStudies: number;
    numberOfSavedStudies: number;
    parseErrors: ParseError[];
    parseWarnings: ParseWarning[];
    /** Uncapped aggregate of the parse warnings: one group per field and cause with affected-record
counts. Null for jobs imported before it existed and for parsers that do not build one; clients
then fall back to ParseWarnings. */
    importDiagnostics: ImportDiagnostics | null;
    lastModified: string;
    /** Authoritative monotonic revision of the job's persisted state, projected from
StateRevision. Clients must reject a payload whose revision
is not greater than the one they already hold rather than comparing
LastModified, which is wall-clock time from whichever process wrote it.
0 means the stored job predates the field. */
    stateRevision: number;
    isParseComplete: boolean;
    isSavingComplete: boolean;
    hasTotalCount: boolean;
    hasSyrfReferenceFile: boolean;
    hasParseError: boolean;
}

export enum SearchImportJobStatus {
    Uploading = 0,
    Parsing = 1,
    Complete = 2,
    Error = 3,
    Received = 4,
    Saving = 5,
}

export interface ValueObjectOfScreeningImportSettings {
}

export interface ScreeningImportSettings extends ValueObjectOfScreeningImportSettings {
    stageId: string;
    userColumnMap: { [key: string]: string; };
}

export interface ParseError {
    errorCode: FileParseErrorCode;
    message: string;
    recordIndex: number | null;
    exception: Exception | null;
}

export enum FileParseErrorCode {
    MissingHeader = 0,
    UnrecognisedHeader = 1,
    MissingXmlElements = 2,
    MalformedRecord = 3,
    NoMatchingScreener = 4,
    UnsupportedFileType = 5,
    UnknownError = 6,
    CancelledEarly = 7,
    MissingRequiredField = 8,
    ResourceLimitExceeded = 9,
    UnsupportedEncoding = 10,
    ScreeningStageUnavailable = 11,
}

export interface Exception {
    Message: string;
    InnerException: Exception | null;
    Source: string | null;
    StackTrace: string | null;
}

/** One sanitised parser warning. Field names the source field (for RIS, its tag) and Cause says why; both are optional so existing call sites keep working. Two-step rollout. The previous build reads ParseWarning with a strict class map, so a pod still running it during a deploy would throw on a stored warning carrying elements it does not know. Step one (this release) therefore keeps Field and Cause in memory only ([BsonIgnore]): they reach the API straight after a parse, are null after a reload, and the durable copy of field and cause lives in ImportDiagnostics, which SearchImportJob's extra-element capture already makes safe for old readers. It also ignores extra elements, so step two, a later release that persists them, can still be read by this one. Step two may drop the [BsonIgnore] once no pod older than this release can be running. */
export interface ParseWarning {
    warningCode: FileParseWarningCode;
    message: string;
    recordIndex: number | null;
    field: string | null;
    cause: ImportDiagnosticCause | null;
}

export enum FileParseWarningCode {
    UnsupportedFieldOmitted = 0,
    InvalidOptionalFieldOmitted = 1,
    DiagnosticsTruncated = 2,
}

/** Why a parse warning was raised, in terms a user can act on. Persisted as its numeric value on ParseWarning and ImportDiagnosticGroup, so it is append-only: never renumber or reuse a value (guarded by FileParseErrorCodeCompatibilityTests). */
export enum ImportDiagnosticCause {
    FieldNotImported = 0,
    InvalidValueOmitted = 1,
    ValueNormalised = 2,
    AttachmentNotPdf = 3,
    AttachmentAdditionalNotAttached = 4,
    AttachmentLocalPathRefused = 5,
    AttachmentRemoteRefused = 6,
    AttachmentTraversalRefused = 7,
    AttachmentUnsupported = 8,
}

/** The aggregate of every warning a parse produced, kept apart from the capped SearchImportJob.ParseWarnings sample so a large library reports "LA not imported, 723 records" rather than 99 unnamed messages. Persisted on the search import job. */
export interface ImportDiagnostics {
    /** Every warning added, including those whose group overflowed the group cap. */
    totalWarnings: number;
    /** Distinct records named by any group's warnings. Warnings whose key overflowed the group cap
(see GroupsTruncated) are not counted here, though they are in
TotalWarnings. */
    recordsWithWarnings: number;
    groups: ImportDiagnosticGroup[];
    /** True when more distinct (code, field, cause) keys arrived than the group cap allows. */
    groupsTruncated: boolean;
    /** True when the capped warning sample does not contain every warning. */
    sampleTruncated: boolean;
}

/** The warnings sharing one (code, field, cause) key. Record indexes use the same base as RecordIndex. */
export interface ImportDiagnosticGroup {
    code: FileParseWarningCode;
    field: string | null;
    /** A human label for Field, such as "Language (LA)". */
    fieldLabel: string | null;
    cause: ImportDiagnosticCause | null;
    /** The first message added for this key. */
    message: string;
    /** Every warning added for this key. */
    occurrences: number;
    /** Distinct non-null record indexes among this key's warnings. */
    affectedRecords: number;
    /** The lowest distinct record indexes, ascending, at most the builder's example cap. */
    exampleRecordIndexes: number[];
}

/** Projection of BulkStudyUpdateJob. It backs ProjectDetailsDto, so it reaches the browser over the project SignalR stream as well as the project-details response.            The mapping is explicit rather than convention-based because two of its members cannot be derived by name: the domain calls its ordering timestamp LastModified while this contract calls it DateTimeLastModified (a silent AutoMapper miss that emitted year one and broke every sort), and both timestamps are nullable here so an unknown time is transmitted as "not available" instead of a fabricated year-one date. */
export interface BulkStudyUpdateJobDto {
    id: string;
    name: string;
    updateFileId: string;
    studiesUpdateFileUrl: string;
    screeningImportSettings: ScreeningImportSettings | null;
    totalNumberOfStudies: number | null;
    numberOfParsedStudies: number;
    numberOfValidatedStudies: number;
    errors: ParseError[];
    status: BulkStudyUpdateJobStatus;
    /** Null when the job carries no usable last-modified time. Never year one. */
    dateTimeLastModified: string | null;
    /** Null when the job carries no usable creation time. Never year one. */
    dateTimeCreated: string | null;
    archived: boolean;
    startedByInvestigatorId: string;
    projectId: string;
    /** The raw parse result. Prefer ResultSummary for reporting outcomes: this
record's row tallies are not a count of studies updated. */
    parseResult: StudyUpdateParseResult | null;
    /** Matched/modified/unmatched truth for a completed run. Null means "not available" -- a job
that has not finished parsing -- and must not be rendered as a run that changed nothing. */
    resultSummary: BulkStudyUpdateJobResultSummary | null;
    /** Authoritative monotonic update sequence. Clients reject a payload whose revision is not
greater than the revision already held for this job. 0 means unknown (a job persisted
before the field existed), not "oldest". */
    stateRevision: number;
    /** When this job's upload signature window ends; null once it is no longer uploading. */
    uploadWindowExpiresAt: string | null;
    /** True when the job still reports UploadingToS3 after its signature window elapsed, so
the upload can no longer succeed. Derived at read time; the persisted status is unchanged. */
    uploadWindowExpired: boolean;
}

export enum BulkStudyUpdateJobStatus {
    UploadingToS3 = 0,
    ErrorUploadingToS3 = 1,
    ValidatingOnServer = 2,
    ErrorValidatingOnServer = 3,
    Parsing = 4,
    CompletedParsing = 5,
    ErrorParsing = 6,
}

export interface StudyUpdateParseResult {
    totalRowsInFile: number;
    errorRowSample: RowParseErrors[];
    nonScreeningRowsUpdated: number;
    nonScreeningRowsMatched: number;
    screeningRowsUpdated: number;
    screeningRowsMatched: number;
    errorRows: number;
    refusedScreeningRows: number;
    refusedScreeningRowSample: RefusedScreeningRow[] | null;
}

export interface RowParseErrors {
    rowIndex: number;
    errors: ParseError[];
}

/** A refused row: its row number and every reason that applied. */
export interface RefusedScreeningRow {
    rowNumber: number;
    reasons: AdministrativeScreeningRefusal[];
}

/** Why an administrative (imported) screening row was refused. Codes only: no row data is reported. */
export enum AdministrativeScreeningRefusal {
    StageNotFound = 0,
    StageDisabled = 1,
    ActivityUnavailable = 2,
    NotActiveMember = 3,
    ExistingDecision = 4,
    StudyNotFound = 5,
}

/** The truthful completion tally for a bulk study update, derived from StudyUpdateParseResult.            It exists because the parsed-row count is not an "updated" count: a file whose every row parses cleanly can still match nothing, and a file that matches every study can still modify none of them (a no-op re-upload). Reporting NumberOfParsedStudies as "studies updated" is therefore a lie in both directions, and it is the lie this record removes.            Screening and non-screening rows are disjoint partitions of the successfully parsed rows in StudyReferenceFileParser.ParseBulkStudyUpdateAsync, so their tallies add. */
export interface BulkStudyUpdateJobResultSummary {
    /** Rows the file contained, excluding the header. */
    totalRows: number;
    /** Rows that resolved to an existing study in this project. */
    matchedStudies: number;
    /** Rows that actually changed a study. Zero is a real, representable outcome (a no-op run), never a
synonym for "unknown". */
    modifiedStudies: number;
    /** Rows that parsed but resolved to no study in this project. */
    unmatchedRows: number;
    /** Rows that failed to parse. */
    errorRows: number;
    refusedRows: number;
}

export interface RiskOfBiasJobDto {
    id: string;
    jobId: string;
    projectId: string;
    attempt: number;
    systematicSearchId: string;
    numberOfStudiesInSearch: number;
    numberOfStudiesWithPdfPath: number;
    numberOfStudiesWithPdfRetrieved: number;
    numberOfStudiesProcessed: number;
    numberOfStudyResultsParsed: number;
    numberOfSuccessfulStudies: number;
    status: RiskOfBiasJobStatus;
    createdOn: string;
    lastUpdated: string;
    studyResultsParseErrors: ParseError[] | null;
    errorMessages: string[];
    completedOn: string | null;
    /** Authoritative monotonic revision of the job's persisted state, projected from
StateRevision. Clients must reject a payload whose revision is
not greater than the one they already hold rather than comparing
LastUpdated, which is supplied by the reporting worker. 0 means the
stored job predates the field. */
    stateRevision: number;
    isInTerminalState: boolean;
    isInErrorState: boolean;
}

export enum RiskOfBiasJobStatus {
    NotStarted = 0,
    ConvertingPdfsToText = 1,
    NoPdfsFound = 2,
    TextFilesGenerated = 3,
    ConvertingPdfsToTextError = 4,
    InputCsvFileCreationError = 5,
    ModelProcessing = 6,
    ModelProcessingError = 7,
    ParsingOutput = 8,
    OutputParsingError = 9,
    StudyResultsParsed = 10,
    Completed = 11,
    GeneralError = 12,
    TimedOut = 13,
    Cancelled = 14,
}

/** DTO for BulkPdfUploadJob, on the SearchImportJobDto precedent.            This is the single projection of a bulk upload job: it backs both the history endpoint and ProjectDetailsDto.BulkPdfUploadJobs, so job state reaches the browser over the existing project SignalR stream with no extra plumbing (decision B3). AutoMapper drops unmapped properties, so the collection must be declared on ProjectDetailsDto explicitly — without it the progress UI silently stays dark.            ReportFileKey is deliberately not exposed: clients ask for the report by upload id and the storage key stays server-side. It surfaces only as HasReport. */
export interface BulkPdfUploadJobDto {
    id: string;
    projectId: string;
    systematicSearchId: string;
    status: BulkPdfUploadJobStatus;
    conflictPolicy: BulkPdfConflictPolicy;
    availability: BulkPdfAvailability | null;
    counts: BulkPdfUploadCountsDto;
    infectedFiles: string[];
    /** The authoritative count behind the bounded InfectedFiles list. Null is a
legacy unknown, not a claim that no paths were omitted. */
    infectedFileCount: number | null;
    /** Whether the retained infected-file names omit one or more reported paths. */
    infectedFilesTruncated: boolean | null;
    failureReason: string | null;
    hasReport: boolean;
    createdAt: string;
    completedAt: string | null;
    /** When the job's persisted state last changed (see UpdatedAt):
every accepted status, progress, lease or cleanup mutation moves it. Null for a job
persisted before the field existed; clients render that as "not available" rather than
substituting CreatedAt or CompletedAt, which would understate
how recently a legacy row changed. */
    updatedAt: string | null;
    createdBy: string;
    stateRevision: number;
    expectedSizeBytes: number;
    expectedSha256: string | null;
    /** Opaque binding to the exact Study PDF-path snapshot accepted when this session was
initiated. Null identifies a legacy job created before snapshot binding existed. */
    studyPdfPathSetProtocolVersion: string | null;
    studyPdfPathSetFingerprint: string | null;
    /** The file count the client declared and validated at session creation -- NOT
Counts.Total, which is what the agent actually found once it processed the archive.
The two can legitimately disagree; if they do once the job finishes, trust
Counts.Total (the discrepancy is already visible through Invalid/Unmatched). This
field exists so the declared count can still be rendered after a page refresh mid-upload
or on a history row, before Counts.Total is known.
            
0 means "not available", not "zero files": pre-multipart Queued jobs never
collect this value, and any multipart session persisted before this field existed
deserializes it as 0. Render 0 the same way the UI rendered this field's
absence before it shipped -- never as a literal "0 files". */
    expectedFileCount: number;
    partSizeBytes: number;
    partCount: number;
    verifiedPartCount: number;
    leaseExpiresAt: string | null;
    lastHeartbeatAt: string | null;
    retryOfUploadId: string | null;
    /** Whether this upload can still be retried right now. Retry authority is one-shot
AND time-bounded, so this is a snapshot: a client holding an old projection may offer a
retry the server now refuses with the usual 409. RetryAuthorityExpiresAt
carries the boundary so a client can present it. */
    canRetry: boolean;
    /** When this upload's retry authority lapses. Null when the job never held retry authority
(it is not in a retriable terminal status). */
    retryAuthorityExpiresAt: string | null;
    /** Authoritative server capacity decision. Clients must not infer this from Status
because an Expired session remains capacity-active until storage cleanup is proved, except
for an explicitly retired rootless legacy session that no deployment may adopt. */
    consumesActiveCapacity: boolean;
    heartbeatIntervalSeconds: number;
    uploadPartUrlValiditySeconds: number;
    uploadPartRequestTimeoutSeconds: number;
}

/** Lifecycle of a bulk PDF upload. Numeric values are persisted in MongoDB and must never be reordered. Upload-session states were appended so older documents remain readable. */
export enum BulkPdfUploadJobStatus {
    Queued = 0,
    Uploaded = 1,
    Scanning = 2,
    Copying = 3,
    Finalizing = 4,
    Complete = 5,
    Failed = 6,
    Infected = 7,
    Expired = 8,
    Uploading = 9,
    Completing = 10,
    Aborting = 11,
    Abandoned = 12,
    Cancelled = 13,
}

/** How the agent treats a file that already exists at the destination path. */
export enum BulkPdfConflictPolicy {
    SkipExisting = 0,
    ReplaceAlways = 1,
    ReplaceIfDiffers = 2,
}

/** Retrieval results for unique matched, delivered files; never counts study duplicates. */
export interface BulkPdfAvailability {
    available: number;
    unavailable: number;
    unverified: number;
    checkedAt: string;
}

/** Absolute snapshot counts for one upload. Missing is null until finalize. */
export interface BulkPdfUploadCountsDto {
    total: number;
    copied: number;
    skipped: number;
    replaced: number;
    unmatched: number;
    missing: number | null;
    invalid: number;
}

export interface MembershipSummaryDto {
    id: string;
    investigatorId: string;
    projectId: string;
    groups: string[];
    dateTimeCreated: string;
    isDisabled: boolean;
    status: MembershipStatus;
    statusHistory: MembershipStatusChangeDto[];
}

export enum MembershipStatus {
    Active = 0,
    Disabled = 1,
}

export interface MembershipStatusChangeDto {
    status: MembershipStatus;
    changedById: string;
    changedAt: string;
}

export interface LivingSearchDto {
    id: string;
    isActive: boolean;
    searchTerm: string;
    searchEngine: string;
    prefix: string;
    projectId: string;
}

export interface JoinRequestDto {
    id: string;
    requestedById: string;
    resolvedById: string | null;
    message: string;
    automaticallyApproved: boolean;
    status: RequestStatus;
    conclusionDateTime: string | null;
    dateTimeCreated: string;
    projectId: string;
}

export enum RequestStatus {
    Pending = 0,
    Cancelled = 1,
    Declined = 2,
    Accepted = 3,
}

export interface InvitationBaseDto extends EntityDtoOfGuid {
    id: string;
    invitedById: string;
    inviteeId: string | null;
    revokedById: string | null;
    inviteeEmail: string;
    message: string;
    preventFurther: boolean;
    linkedDateTime: string | null;
    conclusionStatus: InvitationConclusionType | null;
    lastEmailSent: InvitationEmailSendRequestedEvent | null;
    status: InvitationStatus;
    resolutionDateTime: string | null;
    dateTimeCreated: string;
    groups: string[];
    projectId: string;
}

export interface InvitationFullDto extends InvitationBaseDto {
    secureDetails: InvitationSecureDetailsDto;
    completeness: EntityCompleteness;
}

export interface InvitationSecureDetailsDto {
    id: string;
    token: string;
    projectId: string;
}

export enum InvitationConclusionType {
    Accepted = 0,
    Declined = 1,
    Revoked = 2,
}

export interface InvitationEmailSendRequestedEvent {
    initialEmail: boolean;
    projectId: string;
    sentById: string;
    inviteeId: string | null;
    token: string;
    invitationId: string;
    inviteeEmail: string;
    message: string;
    dateTimeEventOccurred: string;
}

export enum InvitationStatus {
    Pending = 0,
    Declined = 1,
    Accepted = 2,
    Revoked = 3,
}

/** A reversible deletion, as the DELETE routes answer it with 202 Accepted when the deletionLifecycle flag is on (deletion lifecycle slice S4a; docs/planning/deletion-lifecycle/rollout.md §2). The deletion proceeds by itself in project-management: the item stays visible while in-flight work is handled (State Requested, with BlockedReason when it waits), then leaves its list. Scope, state and blocked reason are strings, as stored, so a client never depends on enum numbering and a value a newer build adds still reads. */
export interface DeletionOperationDto {
    operationId: string;
    /** Search or Project. */
    scope: string;
    /** Requested, Deleting, Deleted, Restoring or Restored. */
    state: string;
    projectId: string;
    searchId: string | null;
    requestedBy: string;
    requestedAtUtc: string;
    /** The optional reason the requester gave (trimmed; null when none). */
    reason: string | null;
    /** Why the deletion is waiting, for example WaitingForInFlightWork; null when it is not. */
    blockedReason: string | null;
    /** "Can be restored until": known once the deletion has completed; null before. */
    restoreWindowEndsAtUtc: string | null;
}

/** The optional body of a search DELETE when the deletionLifecycle flag is on. */
export interface SearchDeletionRequestDto {
    /** Why the search is being deleted (optional; at most 500 characters after trimming; blank means none). Kept on
the deletion and shown in Recently deleted; never written to the audit ledger. Ignored when the flag is off. */
    reason: string | null;
}

export interface FileUploadSignature {
    uploadHeaders: { [key: string]: string; };
    signature: string;
    uploadUrl: string;
}

export interface SearchUploadSignatureRequestDto {
    searchId: string;
    searchName: string;
    uploadInfo: SearchUploadS3RequestInfoDto;
    screeningImportSettings: ScreeningImportSettings | null;
}

export interface SearchUploadS3RequestInfoDto {
    payloadHash: string;
    libraryFileType: LibraryFileType;
    description: string;
    /** The file's size in bytes. The search-upload signing endpoint refuses a negative size or one over the
format's limit, and signs it as the upload's Content-Length, so S3 refuses a body of any other length.
Optional for now (#4657): web and API deploy separately, so a request without it signs as before and the
parser's pass-1 limit is the only server bound. The web always sends it; a later release makes it required
once every web client does. The single-PDF endpoint also signs this size, with a 500 MiB PDF limit. */
    contentLength: number | null;
}

export interface CreateLivingSearchDto {
    isActive: boolean;
    searchString: string;
    searchEngine: string;
}

/** The 404 body while RuntimeFeatureReleases:Enabled is false. */
export interface FeatureAvailabilityDisabled {
    code: string;
}

/** The PUT body: the announcement revision the caller saw, and what they did. A flag sent false never clears a stored one (there is no un-dismiss). */
export interface AnnouncementStateRequest {
    revision: number;
    seen: boolean;
    dismissed: boolean;
}

/** The PUT body: { "choice": "joined" } or { "choice": "left" }. */
export interface FeatureConsentRequest {
    choice: string | null;
}

/** Which released features this caller may use here (spec 6E.2). RT-60: no policy structure, store epoch, digest, flag key or targeting. Features the caller may not use are omitted, never reported with a reason, so the body is identical to one from a registry without them. ContextId is an equality token over the environment and binding, the user, the project and every other field except CheckedAtUtc; the browser compares it, never recomputes it. Rehearsal is retired and always false: OD-19 set it outside production so What's New labelled entries "Rehearsal", and D60 A (26 Oct 2026) made every environment deliver announcements as production does. The field stays so the response shape, and production's bytes and context IDs, are unchanged; removing it is a later clean-up. */
export interface FeatureAvailabilityResponse {
    contextId: string;
    policyVersion: string | null;
    rehearsal: boolean;
    freshness: FeatureAvailabilityFreshness;
    features: FeatureAvailabilityEntry[];
}

/** State is Current, or Degraded when a reported decision, the release read, the announcement (outbox) read, the discovery state read (6E.3) or a needed What's New bundle read (6G.2) failed. */
export interface FeatureAvailabilityFreshness {
    checkedAtUtc: string;
    state: string;
}

/** One permitted feature. Availability is available, unavailable or unknown; Reason is null when available, else notReleased, stopped, staleAuthority, policyUnavailable, or (where targeting is in force, 6F.4) excluded, prerequisiteMissing, (6F.8) rolloutPending, (6F.F2) rolloutPaused or (6F.7) consentRequired and optedOut. Release is null without a released record in this binding; Announcement is null for a quiet or imported release, and for one that queued no announcement. WhatsNew (6G.2) is non-null only when the feature is available, its release is announced with a What's New row that the outbox completed, and the current verified bundle has an entry for the release's stage. enabled (spec 6F.4) is present only where targeting is in force for the response (Mode=Shared and the policy stores targeting rules for a permitted Project or Personal feature, whether RuntimeFeatureTargeting:Enabled is on or off), and absent otherwise, so the body is then exactly as before 6F. It says whether the capability is on for this caller here and not stopped: the browser's gate for a Project or Personal feature, separate from availability, which still needs a confirmed release (a project pilot creates none). consent and title (spec 6F.7) are present only for a feature whose effective consent is not none (W4 lists exactly these): its consent and choice here (FeatureAvailabilityConsent) and the beta's name (the title of its release content). Absent means no consent, so a response without one is exactly as before 6F.7. Under consent the reasons add consentRequired ("Open to join": required consent not given) and optedOut ("Rejoin": the subject left). */
export interface FeatureAvailabilityEntry {
    featureId: string;
    availability: string;
    reason: string | null;
    release: FeatureAvailabilityRelease | null;
    announcement: FeatureAvailabilityAnnouncement | null;
    whatsNew: FeatureAvailabilityWhatsNew | null;
    enabled: boolean | null;
    consent: FeatureAvailabilityConsent | null;
    title: string | null;
}

/** The latest released record: Stage LimitedRelease or GeneralRelease; ReleasedAtUtc null for an imported release of Unknown precision; Precision Instant, Date, Month or Unknown. */
export interface FeatureAvailabilityRelease {
    stage: string;
    releasedAtUtc: string | null;
    precision: string;
}

/** The release's announcement ({releaseId}:{stage}, revision 1). Delivered (6G.2) is true only when the release's in-app notice was completed by a production (non-test) handler and the feature notifies its release audience; a cancelled notice never becomes delivered (D14), and staging, previews and local stacks never deliver one. Seen and Dismissed come from the caller's own discovery state (6E.3, PUT api/account/announcements/{id}/state): true only when the caller recorded them at a revision at least Revision. */
export interface FeatureAvailabilityAnnouncement {
    id: string;
    revision: number;
    delivered: boolean;
    seen: boolean;
    dismissed: boolean;
}

/** The release's runtime What's New entry from the current verified bundle (6G.2): Markdown Body that the browser renders only through its untrusted Markdown mode, the guide TopicId and its public GuidePath (page and section; null while the topic has no public article). Revision is sha256: and the entry's hash: only the current bundle's revision is ever served, and no route takes one. */
export interface FeatureAvailabilityWhatsNew {
    id: string;
    revision: string;
    title: string;
    body: string;
    topicId: string;
    guidePath: string | null;
}

/** A beta's consent for this caller here (spec 6F.7): Mode is the effective consent, offered or required (the stricter of code and environment); Choice is the subject's stored choice, joined, left or null (none yet). The subject is the routed project for a Project feature and the caller for a Personal one. CanChange is whether this caller may make the choice here: the caller themselves for a Personal feature (under support impersonation, on the impersonated person's behalf; read-only impersonation still has the PUT refused), and a project administrator (ProjectEditPolicy) for a Project one, never under support impersonation. */
export interface FeatureAvailabilityConsent {
    mode: string;
    choice: string | null;
    canChange: boolean;
}

/** GET /api/whats-new/public (spec 6G.6). Rehearsal is retired and always false: OD-19 set it outside production so the browser labelled runtime entries "Rehearsal", and D60 A (26 Oct 2026) made every environment deliver announcements as production does. The field stays so the response shape and production's bytes are unchanged; removing it is a later clean-up. A failed binding capture answers no entries. Entries are newest first. No clock, policy revision or feature that is not published appears, so two answers over the same published entries are byte-identical. */
export interface PublicWhatsNewResponse {
    rehearsal: boolean;
    entries: PublicWhatsNewEntry[];
}

/** One published runtime What's New entry: the current bundle's text for the feature's general release (Id, Revision sha256:…, Markdown Body that the browser renders only in its untrusted mode, the guide TopicId and its public GuidePath), the announcement it belongs to (AnnouncementId, {releaseId}:GeneralRelease, the key the browser deduplicates against the signed-in availability answer) and the GeneralRelease milestone (ReleasedAtUtc, Precision). Audience is who the feature is for (the registry audience, camelCase; null when it has none), so the browser can say an entry applies to project administrators (D57 = B). It is a label only, never an access decision. */
export interface PublicWhatsNewEntry {
    id: string;
    revision: string;
    title: string;
    body: string;
    topicId: string;
    guidePath: string;
    announcementId: string;
    releasedAtUtc: string;
    precision: string;
    audience: string | null;
}

/** Authenticated account-management projection for the current user. Provider access tokens and other credentials must never be included. */
export interface AccountManagementDto {
    /** Linked sign-in methods, in provider order. */
    linkedIdentities: LinkedIdentityDto[];
    /** The sign-in security summary the web app's Security page shows (account portal
slice 2). Present only when the native Identity service (OpenIddict) answers;
null for Auth0 and the local no-op service, which tells the web app the
status is unavailable on this provider. */
    security: AccountSecuritySummaryDto | null;
}

export interface LinkedIdentityDto {
    provider: string;
    externalAccountId: string | null;
    linkedAt: string | null;
    pictureUrl: string | null;
    /** The provider account's email, masked by the Identity service (for example
al•••@gmail.com) and passed through unchanged. The unmasked email never
reaches the API. null when the provider supplied none, and always
null for Auth0. */
    maskedEmail: string | null;
}

/** How the current user can sign in, as the Security page shows it. */
export interface AccountSecuritySummaryDto {
    hasPassword: boolean;
    twoFactorEnabled: boolean;
    passkeys: PasskeySummaryDto[];
}

/** A passkey as its owner sees it: the name they chose and when it was added. No credential material. */
export interface PasskeySummaryDto {
    name: string;
    createdAt: string;
}

export interface CapabilitiesDto {
    policyVersion: string;
    capabilities: CapabilityDto[];
}

/** One capability decision about the caller themself (GET /api/account/capabilities). */
export interface CapabilityDto {
    /** camelCase capability name, e.g. listUsers, manageApplicationRoles. */
    capability: string;
    allowed: boolean;
    /** A safe reason code about the caller's own access, e.g. allowed, role-not-held. */
    reason: string;
}

export interface AccountCheckResponse {
    investigatorIds: string[];
    identityUserExists: boolean;
}

export interface EmailLookupDto {
    email: string;
    provider: string;
}

export interface AccountCheckCountResponse {
    pConflict: boolean;
    a0: number;
    i: number;
}

export interface AccountLinkInformDto {
    provider: string;
}

export interface ProfileUpdatedDto {
    auth0User: Auth0UserUpdatedDto;
    investigator: InvestigatorFullDto;
}

export interface Auth0UserUpdatedDto {
    id: string;
    email: string;
    pictureUrl: string;
    fullname: FullName;
    sub: string;
}

export interface InvestigatorDbBaseDto extends AggregateRootDtoOfGuid {
    fullName: FullName;
    pictureUrl: string;
    dateTimeCreated: string;
}

export interface InvestigatorFullDto extends InvestigatorDbBaseDto {
    secureDetails: InvestigatorSecureDetailsDto;
    completeness: EntityCompleteness;
}

export interface InvestigatorSecureDetailsDto {
    id: string;
    primaryEmail: string;
    emails: string[];
    newEmailVerifiers: NewEmailVerifierDto[];
}

export interface NewEmailVerifierDto {
    newEmail: string;
    expirationTime: string;
    hasUnexpiredCode: boolean;
}

export interface ProfileNameUpdateDto {
    firstName: string | null;
    surname: string | null;
    preferredName: string | null;
}

export interface ProfileEmailUpdateDto {
    email: string;
}

export interface UpdateEmailErrorResponse {
    changeEmailError: ChangeEmailError;
}

export enum ChangeEmailError {
    EmailAlreadyInUse = 0,
    InvalidEmail = 1,
    UnknownEmailSendError = 2,
}

export interface VerificationErrorResponse {
    verificationErrorCode: CodeVerificationError;
}

export enum CodeVerificationError {
    Invalid = 0,
    Expired = 1,
}

export interface ProfileEmailConfirmDto {
    email: string;
    code: number;
}

export interface ProfileImageUpdateDto {
    image: string;
}

export interface NewUserCreatedDto {
    email: string;
    userId: string | null;
    identityUserId: string | null;
    claimPending: boolean;
}

export interface CreateUserDto {
    firstName: string;
    lastName: string;
    preferredName: string;
    email: string;
    password: string;
}

export interface InvestigatorInitialInfoDto {
    investigatorUsage: InvestigatorUsageDto;
    projects: ProjectDbSummaryDto[];
    stages: StageDto[];
    investigator: InvestigatorFullDto;
}

export interface InvestigatorUsageDto extends AggregateRootDtoOfGuid {
    lastSignedIn: string | null;
    projectUsages: ProjectUsageDto[];
    completeness: EntityCompleteness;
}

export interface ProjectUsageDto {
    id: string;
    lastAccessed: string | null;
    favourite: boolean;
    recentStageUsages: StageUsageDto[];
}

export interface StageUsageDto {
    id: string;
    lastAccessed: string | null;
    favourite: boolean;
}

export interface ProjectDbSummaryDto extends ProjectDbBaseDto {
    details: string;
    secureDetails: string;
    completeness: EntityCompleteness;
}

export interface ProtocolDto {
    title: string | null;
    date: string | null;
    contact: string | null;
    funding: boolean | null;
}

export interface LibraryDto {
    title: string | null;
    year: string | null;
    author: string | null;
    journal: string | null;
}

export interface FaqsDto {
    section: string | null;
    question: string | null;
    answer: string | null;
    dateAdded: string | null;
}

/** Application information for environment awareness in the frontend. Used by the environment UI indicator to display warnings and version info. */
export interface ApplicationInfoDto {
    /** Runtime environment name (Production, Staging, Preview, Development, Local). */
    environment: string;
    /** MongoDB database name being used by this instance. */
    databaseName: string;
    /** Where the database is hosted (e.g., "MongoDB Atlas", "Local", "Remote").
Derived server-side from the cluster address — never exposes raw connection details. */
    databaseLocation: string;
    /** Unambiguous classification of the database: "production", "staging", "preview", or "development".
Derived server-side from both database name AND cluster address, so a local copy of
"syrftest" correctly returns "development" rather than "production". */
    databaseType: string;
    /** PR number for preview environments (e.g., "2234"). Null for other environments. */
    prNumber: string | null;
    /** True if this is the production environment. */
    isProduction: boolean;
    /** API service semantic version (e.g., "8.21.0"). */
    apiVersion: string;
    /** API service full semantic version including pre-release info (e.g., "8.21.0-beta.1"). */
    apiFullVersion: string;
    /** Short git commit SHA from the monorepo. */
    monorepoSha: string;
    /** S3 Notifier Lambda function version (e.g., "0.2.0"). Null if not configured. */
    s3NotifierVersion: string | null;
}

export interface EmailSendResult {
    email: string;
    statusCode: HttpStatusCode;
}

export enum HttpStatusCode {
    Continue = 100,
    SwitchingProtocols = 101,
    Processing = 102,
    EarlyHints = 103,
    OK = 200,
    Created = 201,
    Accepted = 202,
    NonAuthoritativeInformation = 203,
    NoContent = 204,
    ResetContent = 205,
    PartialContent = 206,
    MultiStatus = 207,
    AlreadyReported = 208,
    IMUsed = 226,
    MultipleChoices = 300,
    Ambiguous = 300,
    MovedPermanently = 301,
    Moved = 301,
    Found = 302,
    Redirect = 302,
    SeeOther = 303,
    RedirectMethod = 303,
    NotModified = 304,
    UseProxy = 305,
    Unused = 306,
    TemporaryRedirect = 307,
    RedirectKeepVerb = 307,
    PermanentRedirect = 308,
    BadRequest = 400,
    Unauthorized = 401,
    PaymentRequired = 402,
    Forbidden = 403,
    NotFound = 404,
    MethodNotAllowed = 405,
    NotAcceptable = 406,
    ProxyAuthenticationRequired = 407,
    RequestTimeout = 408,
    Conflict = 409,
    Gone = 410,
    LengthRequired = 411,
    PreconditionFailed = 412,
    RequestEntityTooLarge = 413,
    RequestUriTooLong = 414,
    UnsupportedMediaType = 415,
    RequestedRangeNotSatisfiable = 416,
    ExpectationFailed = 417,
    MisdirectedRequest = 421,
    UnprocessableEntity = 422,
    UnprocessableContent = 422,
    Locked = 423,
    FailedDependency = 424,
    UpgradeRequired = 426,
    PreconditionRequired = 428,
    TooManyRequests = 429,
    RequestHeaderFieldsTooLarge = 431,
    UnavailableForLegalReasons = 451,
    InternalServerError = 500,
    NotImplemented = 501,
    BadGateway = 502,
    ServiceUnavailable = 503,
    GatewayTimeout = 504,
    HttpVersionNotSupported = 505,
    VariantAlsoNegotiates = 506,
    InsufficientStorage = 507,
    LoopDetected = 508,
    NotExtended = 510,
    NetworkAuthenticationRequired = 511,
}

export interface GeneralInquiryFormDto {
    name: string;
    email: string;
    message: string;
    subject: string;
}

export interface SupportFormDto {
    name: string;
    email: string;
    message: string;
    subject: string;
    projectId: string;
    projectName: string;
    os: string;
    browser: string;
    dateTimeOfIssue: string;
    otherOS: string | null;
    otherBrowser: string | null;
}

export interface Aggregates {
    summaryProjectUpdateNotification: EntityUpdateNotificationOfProjectDbSummaryDto;
    standardProjectUpdateNotification: EntityUpdateNotificationOfProjectStandardDto;
    fullProjectUpdateNotification: EntityUpdateNotificationOfProjectFullDto;
    fullStatsUpdateNotification: EntityUpdateNotificationOfFullStats;
    dataExportJobUpdateNotification: EntityUpdateNotificationOfDataExportJobDto;
    dataExportJobDeleteNotification: EntityDeleteNotificationOfDataExportJobDto;
    projectWithRelatedInvestigatorsUpdateNotification: EntityUpdateNotificationOfProjectWithRelatedInvestigatorsDto;
    projectFullDto: ProjectFullDto;
    projectDeleteNotification: EntityDeleteNotificationOfProjectWithRelatedInvestigatorsDto;
    fileFormat: FileFormat;
}

export interface EntityNotificationOfProjectDbSummaryDto {
    dbTime: string;
    id: string;
}

export interface EntityUpdateNotificationOfProjectDbSummaryDto extends EntityNotificationOfProjectDbSummaryDto {
    type: NotificationType;
    entity: ProjectDbSummaryDto | null;
}

export enum NotificationType {
    Update = 0,
    Delete = 1,
}

export interface EntityNotificationOfProjectStandardDto {
    dbTime: string;
    id: string;
}

export interface EntityUpdateNotificationOfProjectStandardDto extends EntityNotificationOfProjectStandardDto {
    type: NotificationType;
    entity: ProjectStandardDto | null;
}

export interface EntityNotificationOfProjectFullDto {
    dbTime: string;
    id: string;
}

export interface EntityUpdateNotificationOfProjectFullDto extends EntityNotificationOfProjectFullDto {
    type: NotificationType;
    entity: ProjectFullDto | null;
}

export interface ProjectFullDto extends ProjectDbBaseDto {
    details: ProjectDetailsDto;
    secureDetails: ProjectSecureDetailsDto;
    completeness: EntityCompleteness;
}

export interface ProjectSecureDetailsDto {
    id: string;
    memberships: MembershipSummaryDto[];
    pendingInvitations: InvitationSummaryDto[];
    pendingJoinRequests: JoinRequestDto[];
    projectPermissionSet: ProjectPermissionSetDto;
    stagePermissionSets: StagePermissionSetDto[];
    projectId: string;
}

export interface InvitationSummaryDto extends InvitationBaseDto {
    secureDetails: string;
    completeness: EntityCompleteness;
}

export interface ProjectPermissionSetDto {
    id: string;
    projectId: string;
    permissions: ProjectPermissionDto[];
}

export interface ProjectPermissionDto {
    activityEnum: ProjectActivity;
    activity: string;
    allowAllProjectMembers: boolean;
    allowProjectOwner: boolean;
    allowedProjectGroupIds: string[];
}

export enum ProjectActivity {
    Design = 0,
    ChangeOwner = 1,
    AssignPermissions = 2,
    SubmitPdfCorrections = 3,
    ApprovePdfCorrections = 4,
    Edit = 5,
    Delete = 6,
    View = 7,
    ViewStudies = 8,
    RequestToJoin = 9,
    Leave = 10,
    Invite = 11,
    SetMembersStatus = 12,
    BulkUpdateStudies = 13,
    ImportSearch = 14,
    ViewSearches = 15,
    RemoveSearch = 16,
    EditMemberships = 17,
    ViewMemberships = 18,
    DeleteMemberships = 19,
    ViewScreeningProgressGraph = 20,
    ViewScreeningProgressGraphDecisions = 21,
    ExportData = 22,
    BulkPdfUpload = 23,
    CalculateRob = 24,
}

export interface StagePermissionSetDto {
    id: string;
    permissions: StagePermissionDto[];
    stageId: string;
    projectId: string;
}

export interface StagePermissionDto {
    activityEnum: StageActivity;
    activity: string;
    allowAllProjectMembers: boolean;
    allowAllApplicationUsers: boolean;
    allowedMemberIds: string[];
    allowedProjectGroupIds: string[];
}

export enum StageActivity {
    Design = 0,
    Reconcile = 1,
    Review = 2,
    ViewAnnotationProgressGraph = 3,
}

export interface EntityNotificationOfFullStats {
    dbTime: string;
    id: string;
}

export interface EntityUpdateNotificationOfFullStats extends EntityNotificationOfFullStats {
    type: NotificationType;
    entity: FullStats | null;
}

export interface ValueObjectOfFullStats {
}

export interface FullStats extends ValueObjectOfFullStats {
    membershipIds: string[];
    stageIds: string[];
    projectScreening: ProjectScreeningStats;
    stageAnnotation: StageAnnotationStats[];
    membershipAnnotation: MembershipStageAnnotationStatsMap[];
    membershipScreening: MembershipScreeningStats[];
}

export interface ProjectScreeningStats {
    id: string;
    projectId: string;
    count: number;
    sufficientlyScreened: number;
    insufficientlyScreened: number;
    sufficientlyIncluded: number;
    sufficientlyExcluded: number;
    startedScreening: number;
    overscreened: number;
    overscreenedYetInsufficientlyScreened: number;
    overscreenedAndSufficientlyIncluded: number;
    overscreenedAndSufficientlyExcluded: number;
    screeningTallyCounts: { [key: string]: { [key: string]: number; }; };
}

export interface StageAnnotationStats {
    id: string;
    stageId: string;
    unexcludedSessionStats: AnnotationSessionStats;
    excludedSessionStats: AnnotationSessionStats;
    projectId: string;
}

export interface AnnotationSessionStats {
    totalCount: number;
    candidateSessionsCountLookup: { [key: string]: { [key: string]: number; }; };
    startedReconciliationCount: number;
    completedReconciliationCount: number;
}

export interface MembershipStageAnnotationStatsMap {
    id: string;
    investigatorId: string;
    stageAnnotationStatsMap: { [key: string]: MembershipStageStats; };
    projectId: string;
}

export interface MembershipStageStats {
    membershipId: string;
    investigatorId: string;
    stageId: string;
    total: number;
    incompleteThreshold: number | null;
    unexcludedMembershipSessionStats: MembershipAnnotationSessionStats;
    excludedMembershipSessionStats: MembershipAnnotationSessionStats;
    mergedMembershipAnnotationStats: MergedMembershipAnnotationStats;
    hasReachedMaxInProgress: boolean;
    hasReachedMaxInProgressReconciliation: boolean;
}

export interface MembershipAnnotationSessionStats {
    available: number;
    inProgress: number;
    completed: number;
    unavailable: number;
    total: number;
    candidateAnnotationSessionsGloballyCompleted: number;
    reconcileAvailable: number;
    reconcileInProgress: number;
    reconcileCompleted: number;
    reconcileUnavailable: number;
    insufficientlyCompletedCandidateSessions: number;
    selfReconciliationEnabled: boolean;
    percentAvailable: number;
    percentInProgress: number;
    percentCompleted: number;
    percentUnavailable: number;
    percentReconcileAvailable: number;
    percentReconcileInProgress: number;
    percentReconcileCompleted: number;
    percentReconcileUnavailable: number;
}

export interface MergedMembershipAnnotationStats extends MembershipAnnotationSessionStats {
    seperatedExcludedMembershipAnnotationStats: SeperatedExcludedMembershipAnnotationStats | null;
}

export interface SeperatedExcludedMembershipAnnotationStats {
    excludedInProgress: number;
    excludedCompleted: number;
    excludedInProgressReconciliation: number;
    excludedCompletedReconciliation: number;
    percentExcludedInProgress: number;
    percentExcludedCompleted: number;
    percentExcludedInProgressReconciliation: number;
    percentExcludedCompletedReconciliation: number;
}

export interface MembershipScreeningStats {
    id: string;
    /** The reviewer this row belongs to, or null when the caller may see the counts but not who
produced them. Never populated on an anonymised row. */
    investigatorId: string | null;
    membershipId: string;
    /** The label a client shows in place of a reviewer name on an anonymised row ("Reviewer A").
Null when the caller may see real names, in which case the client resolves the name from
InvestigatorId. Assigned per request in a random order, so it is neither stable
across requests nor derivable from any identifier. */
    displayLabel: string | null;
    /** True when this row is the requesting caller's own row. */
    isSelf: boolean;
    screened: number;
    included: number;
    excluded: number;
    sufficientlyIncluded: number;
    sufficientlyExcluded: number;
    available: number;
    unavailable: number;
    sufficientlyIncludedAndAgree: number;
    sufficientlyExcludedAndAgree: number;
    sufficientlyIncludedAndDisagree: number;
    sufficientlyExcludedAndDisagree: number;
    sufficientlyScreened: number;
    insufficientlyScreened: number;
    overscreened: number;
    overscreenedYetInsufficientlyScreened: number;
    overscreenedAndSufficientlyIncluded: number;
    overscreenedAndSufficientlyExcluded: number;
    totalNumberStudies: number;
    percentIncluded: number;
    percentExcluded: number;
    percentScreened: number;
    percentAvailable: number;
    percentUnavailable: number;
    numberVerification: boolean;
    projectId: string;
}

export interface EntityNotificationOfDataExportJobDto {
    dbTime: string;
    id: string;
}

export interface EntityUpdateNotificationOfDataExportJobDto extends EntityNotificationOfDataExportJobDto {
    type: NotificationType;
    entity: DataExportJobDto | null;
}

export interface DataExportJobDto extends AggregateRootDtoOfGuid {
    projectId: string;
    correlationId: string;
    status: DataExportJobStatus;
    totalStudyCount: number | null;
    processedCount: number | null;
    completedAt: string | null;
    dataFormat: ExportDataFormat;
    category: Category | null;
    blindingLevel: BlindingLevel;
    splitBySession: boolean | null;
    bibliographic: boolean;
    includeComments: boolean;
    wideFormatHeaderType: WideFormatHeaderType | null;
    onlyCompleted: boolean | null;
    stageIds: string[] | null;
    outcomeLookupQuestions: string[] | null;
    requestedBy: string;
    errors: DataExportError[];
    summary: DataExportJobSummary | null;
    completeness: EntityCompleteness;
}

export enum DataExportJobStatus {
    Pending = 0,
    InProgress = 1,
    Completed = 2,
    Failed = 3,
}

export enum ExportDataFormat {
    Long = 0,
    Wide = 1,
    LongScreening = 2,
    WideScreening = 3,
    OutcomeData = 4,
    Bibliographic = 5,
}

export enum Category {
    Study = 0,
    DiseaseModelInduction = 1,
    Treatment = 2,
    OutcomeAssessment = 3,
    Cohort = 4,
    Experiment = 5,
}

export enum BlindingLevel {
    Unblinded = 0,
    Blinded = 1,
    Ids = 2,
}

export enum WideFormatHeaderType {
    TwoLineWithQuestion = 0,
    SingleLineWithQuestionId = 1,
    SingleLineSimple = 2,
}

export interface DataExportError {
    message: string;
    errorType: DataExportErrorType;
    category: DataExportErrorCategory;
    scope: DataExportErrorScope;
    canContinue: boolean;
    timestamp: string;
    studyId: string | null;
    fieldName: string | null;
    metadata: { [key: string]: string; } | null;
}

export enum DataExportErrorType {
    SystemError = 0,
    DatabaseTimeout = 1,
    DatabaseConnectionFailed = 2,
    InsufficientMemory = 3,
    StudyParsingFailed = 4,
    StudyDataCorrupted = 5,
    ValidationError = 6,
    InvalidFieldValue = 7,
    MissingRequiredField = 8,
    FieldFormatInvalid = 9,
    InvestigatorMismatch = 10,
    PermissionError = 11,
    StudyAccessDenied = 12,
    TimeoutError = 13,
    UnexpectedError = 14,
}

export enum DataExportErrorCategory {
    StudyProcessing = 0,
    DataValidation = 1,
    MissingData = 2,
    PermissionDenied = 3,
    SystemError = 4,
}

export enum DataExportErrorScope {
    SingleStudy = 0,
    MultipleStudies = 1,
    EntireExport = 2,
    Field = 3,
    Project = 4,
}

/** Summary information for a completed data export job */
export interface DataExportJobSummary {
    message: string;
    finalStatus: DataExportJobStatus;
    totalStudiesProcessed: number;
    totalErrors: number;
    hasCriticalErrors: boolean;
    completedAt: string;
    errorsByType: { [key: string]: number; };
    errorsByCategory: { [key: string]: number; };
    /** Determines if the export was successful (completed with no critical errors) */
    isSuccessful: boolean;
    /** Gets the success rate as a fraction (0.0 to 1.0) */
    successRate: number;
}

export interface EntityDeleteNotificationOfDataExportJobDto extends EntityNotificationOfDataExportJobDto {
    type: NotificationType;
}

export interface EntityNotificationOfProjectWithRelatedInvestigatorsDto {
    dbTime: string;
    id: string;
}

export interface EntityUpdateNotificationOfProjectWithRelatedInvestigatorsDto extends EntityNotificationOfProjectWithRelatedInvestigatorsDto {
    type: NotificationType;
    entity: ProjectWithRelatedInvestigatorsDto | null;
}

export interface ProjectWithRelatedInvestigatorsDto {
    project: ProjectDbBaseDto;
    relatedInvestigators: InvestigatorDbSummaryDto[];
    investigatorUsage: InvestigatorUsageDto | null;
}

export interface InvestigatorDbSummaryDto extends InvestigatorDbBaseDto {
    secureDetails: string;
    completeness: EntityCompleteness;
}

export interface EntityDeleteNotificationOfProjectWithRelatedInvestigatorsDto extends EntityNotificationOfProjectWithRelatedInvestigatorsDto {
    type: NotificationType;
}

export enum FileFormat {
    Csv = 0,
    Excel = 1,
    Json = 2,
}

export interface IGetBulkPdfReleaseStateResult {
    found: boolean;
    disposition: BulkPdfUploadJobStatus | null;
    hasActiveOrRetriableClaim: boolean;
    /** True when Project Management's notifier authority was disabled and the command was not
processed. Every other field then carries this contract's "not processed" shape, so a
caller that ignores this flag still reads an answer that claims nothing. The flag is
additive: a producer that predates it leaves it false, which is the correct reading
of every response that was actually processed. */
    authorityDisabled: boolean;
}

export interface IResolveBulkPdfStorageBindingResult {
    matchCount: number;
    bindingEvidenceDigest: string | null;
    /** The server-owned release identity of the single match, and null for zero or many.
A rejected capture row derives its own release id from the object coordinates alone — the
upload id it would need is exactly the metadata that was unreadable — so without this the
notifier can never name the binding it must adopt cleanup-only authority for. It carries no
project, search or upload identity, and registration still refuses a release that another
authority already owns, so the adopting caller derives no authority from learning it. */
    releaseId: string | null;
    /** True when Project Management's notifier authority was disabled and the command was not
processed. Every other field then carries this contract's "not processed" shape, so a
caller that ignores this flag still reads an answer that claims nothing. The flag is
additive: a producer that predates it leaves it false, which is the correct reading
of every response that was actually processed. */
    authorityDisabled: boolean;
}

export interface ResolveStorageBindingRequest {
    bucketName: string;
    objectKey: string;
    objectVersionId: string;
}

export interface IRegisterBulkPdfCleanupResult {
    registrationId: string;
    cleanupAuthorityId: string;
    registeredAt: string;
    /** True when Project Management's notifier authority was disabled and the command was not
processed. Every other field then carries this contract's "not processed" shape, so a
caller that ignores this flag still reads an answer that claims nothing. The flag is
additive: a producer that predates it leaves it false, which is the correct reading
of every response that was actually processed. */
    authorityDisabled: boolean;
}

export interface RegisterCleanupRequest {
    releaseId: string;
    bucketName: string;
    objectKey: string;
    objectVersionId: string;
    terminalDisposition: BulkPdfUploadJobStatus;
}

export interface IRegisterBulkPdfQuarantineFenceResult {
    fenceSetId: string;
    candidateCount: number;
    /** True when Project Management's notifier authority was disabled and the command was not
processed. Every other field then carries this contract's "not processed" shape, so a
caller that ignores this flag still reads an answer that claims nothing. The flag is
additive: a producer that predates it leaves it false, which is the correct reading
of every response that was actually processed. */
    authorityDisabled: boolean;
}

export interface RegisterQuarantineRequest {
    fenceSetId: string;
    releaseId: string | null;
    bucketName: string;
    objectKey: string;
    objectVersionId: string;
    evidenceDigest: string;
}

export interface ITransferBulkPdfQuarantineFenceResult {
    fenceSetId: string;
    transferId: string;
    operation: BulkPdfQuarantineTransferOperation;
    /** True when Project Management's notifier authority was disabled and the command was not
processed. Every other field then carries this contract's "not processed" shape, so a
caller that ignores this flag still reads an answer that claims nothing. The flag is
additive: a producer that predates it leaves it false, which is the correct reading
of every response that was actually processed. */
    authorityDisabled: boolean;
}

export enum BulkPdfQuarantineTransferOperation {
    Prepare = 0,
    LinkDestination = 1,
    Finalize = 2,
}

export interface TransferQuarantineRequest {
    fenceSetId: string;
    transferId: string;
    operation: BulkPdfQuarantineTransferOperation;
    evidenceDigest: string;
    destinationLedger: string | null;
    destinationAcceptanceDigest: string | null;
    sourceTombstoneDigest: string | null;
}

export interface IAcknowledgeBulkPdfCleanupResult {
    acknowledgementId: string;
    acknowledgedAt: string;
    /** Earliest retention-eligibility time. This is not deletion confirmation: the dependent
Project Management receipt reconciler must separately prove hold retirement and exact-key
outbox drain before a later conditional purge may remove the receipt. */
    expiresAt: string;
    /** True when Project Management's notifier authority was disabled and the command was not
processed. Every other field then carries this contract's "not processed" shape, so a
caller that ignores this flag still reads an answer that claims nothing. The flag is
additive: a producer that predates it leaves it false, which is the correct reading
of every response that was actually processed. */
    authorityDisabled: boolean;
}

export interface AcknowledgeCleanupRequest {
    releaseId: string;
    bucketName: string;
    objectKey: string;
    objectVersionId: string;
    deleteDigest: string;
    fenceSetId: string | null;
    transferId: string | null;
}

export interface IConfirmBulkPdfHoldRetiredResult {
    acknowledgementId: string;
    retiredAt: string;
    /** True when Project Management's notifier authority was disabled and the command was not
processed. Every other field then carries this contract's "not processed" shape, so a
caller that ignores this flag still reads an answer that claims nothing. The flag is
additive: a producer that predates it leaves it false, which is the correct reading
of every response that was actually processed. */
    authorityDisabled: boolean;
}

export interface ConfirmHoldRetiredRequest {
    releaseId: string;
    deleteDigest: string;
    outboxKey: string;
}

/** Stable, browser-safe error contract for the multipart upload protocol. The authoritative session is included when the server can identify it, allowing clients to converge after a stale callback or an optimistic-concurrency race without exposing storage or claim secrets. */
export interface BulkPdfUploadProblemDto {
    status: number;
    title: string;
    detail: string;
    code: string;
    authoritativeSession: BulkPdfUploadJobDto | null;
}

export interface BulkPdfUploadInitiateRequestDto {
    uploadId: string;
    conflictPolicy: BulkPdfConflictPolicy;
    expectedSizeBytes: number;
    expectedFileCount: number;
    payloadSha256: string;
    studyPdfPathSetProtocolVersion: string;
    studyPdfPathSetFingerprint: string;
}

export interface BulkPdfUploadPartSignatureDto {
    partNumber: number;
    url: string;
    expiresAt: string;
    requiredHeaders: { [key: string]: string; };
    authoritativeSession: BulkPdfUploadJobDto;
}

export interface BulkPdfUploadPartRequestDto {
    sizeBytes: number;
    checksumSha256: string;
}

export interface BulkPdfUploadHeartbeatDto {
    authoritativeSession: BulkPdfUploadJobDto;
    heartbeatIntervalSeconds: number;
}

export interface BulkPdfUploadAbandonRequestDto {
    commandId: string;
    reason: string | null;
}

export interface BulkPdfUploadRetryRequestDto {
    uploadId: string;
    conflictPolicy: BulkPdfConflictPolicy;
    expectedSizeBytes: number;
    expectedFileCount: number;
    payloadSha256: string;
    studyPdfPathSetProtocolVersion: string;
    studyPdfPathSetFingerprint: string;
}

/** One authoritative Study PDF-path read. The opaque server-computed binding travels with these exact rows into upload initiation; callers must never combine paths and a fingerprint from different responses. */
export interface StudyPdfPathSnapshotDto {
    protocolVersion: string;
    fingerprint: string;
    studies: StudyPdfPathDto[];
}

/** A study's expected PDF path, for the client-side pre-upload match preview. Only studies that declare a path are returned, so the payload stays lean for very large searches. */
export interface StudyPdfPathDto {
    studyId: string;
    pdfRelativePath: string | null;
    title: string | null;
}

export interface DataExportJobCreatedDto {
    jobId: string;
    status: DataExportJobStatus;
    dataExportJob: DataExportJobDto;
}

export interface DataExportRequest {
    correlationId: string;
    projectId: string;
    dataFormat: ExportDataFormat;
    category: Category | null;
    stageIds: string[] | null;
    blindingLevel: BlindingLevel;
    splitBySession: boolean | null;
    bibliographic: boolean;
    onlyIncluded: boolean;
    importCompatible: boolean;
    includeComments: boolean;
    wideFormatHeaderType: WideFormatHeaderType | null;
    onlyCompleted: boolean | null;
    outcomeLookupQuestions: string[] | null;
}

export enum CsvDelimiter {
    Comma = 0,
    Semicolon = 1,
    Tab = 2,
}

export interface TemplatedEmailSendDto {
    templateName: string;
    templateData: TemplateEmailData[];
    defaultTemplateData: any | null;
}

export interface TemplateEmailData {
    email: string;
    templateData: any;
}

export interface BatchedStatusCode {
    statusCode: HttpStatusCode;
    emails: InvestigatorEmail[];
}

export interface InvestigatorEmail {
    investigatorId: string;
    email: string;
}

export interface AwsEmailTemplateInfo {
    id: string;
    templateName: string;
    createdDateTime: string;
}

export interface AwsEmailTemplateDetails extends AwsEmailTemplateInfo {
    subject: string;
    html: string;
    text: string;
}

export interface RuntimeEnvironmentCompatibilityReport {
    schemaVersion: number;
    reportId: string;
    environmentId: string;
    bindingEpoch: string;
    collectionStartedAtUtc: string;
    collectionEndedAtUtc: string;
    expiresAtUtc: string;
    deleteAfterUtc: string;
    completeness: string;
    sources: RuntimeReportSource[];
    policy: RuntimeReportPolicy | null;
    baseline: RuntimeReportBaseline | null;
    desired: RuntimeReportDesired | null;
    applied: RuntimeReportServiceObservation[];
    prerequisites: RuntimeReportPrerequisite[];
    unknownOrUnsupported: string[];
    serviceVersion: string;
    serviceCapabilitiesDigest: string;
    deploymentConstraint: RuntimeReportDeploymentConstraint | null;
    workloads: RuntimeReportWorkload[] | null;
    statisticsControl: RuntimeReportStatisticsControl | null;
    purpose: string | null;
    requiredSources: string[] | null;
    legacyParity: RuntimeReportLegacyParity | null;
    appliedMigrations: RuntimeReportAppliedMigration[] | null;
}

export interface RuntimeReportSource {
    name: string;
    revision: string | null;
    digest: string | null;
    observedAtUtc: string | null;
    maximumAgeSeconds: number;
    state: string;
}

export interface RuntimeReportPolicy {
    identity: RuntimePolicyIdentityStatus;
    /** The stored policy document's schema: 1, or 2 when it holds targeting rules or feature settings. */
    schemaVersion: number;
    /** Keys a deployment must serve: on by saved setting or baseline, or able to be turned on by a targeting rule. */
    requiredEnabledKeys: string[];
    stoppedKeys: string[];
    /** Keys with stored targeting rules, each with the grain this server's catalog gives it. Empty for schema 1. */
    targetedKeys: RuntimeReportTargetedKey[] | null;
}

/** HTTP identity: a decimal string is lossless with both deployed JSON serializers and JavaScript. */
export interface RuntimePolicyIdentityStatus {
    environmentId: string;
    bindingEpoch: string;
    storeEpoch: string;
    revision: string;
    catalogDigest: string;
    baselineDigest: string;
    policyDigest: string;
}

/** A key with stored targeting, and the grain this binary's catalog contract gives it. */
export interface RuntimeReportTargetedKey {
    key: string;
    grain: string;
}

export interface RuntimeReportBaseline {
    catalogDigest: string;
    baselineDigest: string;
    values: { [key: string]: boolean; };
}

export interface RuntimeReportDesired {
    revision: string;
    chartTags: { [key: string]: string; };
    renderedSettingsDigest: string;
}

export interface RuntimeReportServiceObservation {
    instanceUid: string;
    service: string;
    imageVersion: string;
    catalogDigest: string;
    acknowledgedPolicy: RuntimePolicyIdentityStatus | null;
    lastSeenAtUtc: string;
    readiness: string;
}

export interface RuntimeReportPrerequisite {
    name: string;
    state: string;
}

/** Sanitized constraint facts, not coordinator authority or permission to deploy. */
export interface RuntimeReportDeploymentConstraint {
    rolloutId: string;
    constraintDigest: string;
    servingCatalogDigests: string[];
    targetCatalogDigest: string;
    policySchemaVersion: number;
    allowedEnabledKeys: string[];
    policyRevisionAtRecord: string;
    recordedAtUtc: string;
    expiresAtUtc: string;
    state: string;
    reason: string | null;
}

/** Collector evidence, distinct from self-reported policy acknowledgements. */
export interface RuntimeReportWorkload {
    observationId: string;
    service: string;
    deploymentUid: string;
    resourceVersion: string;
    generation: string;
    observedGeneration: string;
    desiredReplicas: number;
    observedAtUtc: string;
    pods: RuntimeWorkloadPod[];
    digest: string;
    desired: RuntimeDesiredDeploymentEvidence | null;
}

export interface RuntimeWorkloadPod {
    instanceUid: string;
    imageDigest: string;
    ready: boolean;
    terminating: boolean;
}

/** Collector provenance for desired configuration; never an instruction to deploy it. */
export interface RuntimeDesiredDeploymentEvidence {
    applicationUid: string;
    resourceVersion: string;
    gitOpsRevision: string;
    chartTag: string;
    renderedSettingsDigest: string;
}

/** Durable global statistics metadata, not permission or readiness to serve any project. */
export interface RuntimeReportStatisticsControl {
    mode: string;
    writeEpoch: string;
    modeEpoch: string;
    globalClientInvalidationRevision: string;
    activeReviewerTrackingAvailable: boolean;
    modeTransitionPending: boolean;
    catalogueVersion: number;
    storageVersion: number;
    sourceVersion: number;
    statisticsSchemaVersion: number;
}

/** RT-15: whether returning to deployment-controlled values would change any production-eligible decision. */
export interface RuntimeReportLegacyParity {
    agrees: boolean;
    entries: RuntimeReportLegacyParityEntry[];
}

export interface RuntimeReportLegacyParityEntry {
    key: string;
    legacyValue: boolean;
    runtimeValue: boolean;
    stopActive: boolean;
    agrees: boolean;
}

/** An applied migration as recorded by the runner: identity only, never timestamps, actors or errors. */
export interface RuntimeReportAppliedMigration {
    id: string;
    version: number;
    checksum: string;
}

export interface RuntimeCoordinatorReceipt {
    mutationId: string;
    rolloutId: string;
    action: string;
    constraintDigest: string | null;
    recordedAtUtc: string;
}

export interface RuntimeCoordinatorChangeRequest {
    mutationId: string;
    expectedIdentity: RuntimePolicyIdentityStatus;
    action: RuntimeDeploymentConstraintAction;
    reason: string;
    expiresAtUtc: string | null;
    servingCatalogDigests: string[] | null;
    targetCatalogDigest: string | null;
    allowedCapabilities: RuntimeDeploymentCapabilities | null;
    expectedConstraintDigest: string | null;
    completionTargets: RuntimeDeploymentCompletionTargets | null;
    completionKind: RuntimeDeploymentCompletionKind | null;
}

export enum RuntimeDeploymentConstraintAction {
    Record = 0,
    Extend = 1,
    Release = 2,
    BreakGlassRelease = 3,
}

/** Policy schema 1 or 2 capabilities supplied by a trusted coordinator, never by a policy editor. */
export interface RuntimeDeploymentCapabilities {
    /** The newest policy schema every host in the intersection reads: 1, or 2 once every
            host reads targeting (spec 6F). A schema-2 policy is refused while an active constraint allows only 1. */
    policySchemaVersion: number;
    enabledKeys: string[];
}

export interface RuntimeDeploymentCompletionTargets {
    target: RuntimeDeploymentImageSet;
    rollback: RuntimeDeploymentImageSet;
}

export interface RuntimeDeploymentImageSet {
    catalogDigest: string;
    serviceImages: { [key: string]: string; };
}

export enum RuntimeDeploymentCompletionKind {
    Target = 0,
    Rollback = 1,
}

export interface RuntimeWorkloadObservationReceipt {
    observationId: string;
    digest: string;
}

export interface RuntimeWorkloadObservation {
    observationId: string;
    expectedObservationId: string | null;
    environmentId: string;
    bindingEpoch: string;
    service: string;
    deploymentUid: string;
    resourceVersion: string;
    generation: string;
    observedGeneration: string;
    desiredReplicas: number;
    observedAtUtc: string;
    pods: RuntimeWorkloadPod[];
    desired: RuntimeDesiredDeploymentEvidence | null;
}

/** The dry run's answer. */
export interface GravatarBackfillPreview {
    /** Live Investigators whose stored picture is a Gravatar URL and that have no recorded lookup. */
    eligible: number;
}

/** What one backfill batch did. */
export interface GravatarBackfillBatch {
    /** Why it stopped. */
    stop: GravatarBackfillStop;
    /** Copies stored and recorded. */
    imported: number;
    /** Recorded as having no Gravatar. */
    notFound: number;
    /** Changed since they were selected (an upload, a sign-in, a recorded lookup); left alone. A
            refresh that kept the copy (Unchanged) counts here too. */
    notNeeded: number;
    /** Another writer saved first; nothing recorded, the copy removed. */
    lostRace: number;
    /** Gravatar or storage failed; nothing recorded. The cursor passes them, so a later pass from the
            start tries them again. */
    failed: number;
    /** Send as after to continue. Null when Stop is
            Completed, and when a batch begun from the start stopped before finishing anyone. */
    next: string | null;
    /** How many Investigators the selection holds now, from the start. */
    remainingEligible: number;
}

/** Why a backfill batch stopped. */
export enum GravatarBackfillStop {
    Completed = "Completed",
    BatchLimit = "BatchLimit",
    TimeLimit = "TimeLimit",
    FlagOff = "FlagOff",
    RepeatedFailures = "RepeatedFailures",
}

/** A backfill batch request. */
export interface GravatarBackfillRequest {
    /** Required: the batch contacts Gravatar and changes pictures. */
    confirm: boolean;
    /** The previous answer's next; null or omitted to start from the beginning. */
    after: string | null;
}

/** The authoritative role state of one Investigator (GET /api/investigators/{id}/application-roles). */
export interface ApplicationRolesDto {
    investigatorId: string;
    /** Every stored role name, verbatim, including ones this path cannot change. */
    roles: string[];
    /** The value a change must send back as expectedRevision. */
    revision: number;
    deactivated: boolean;
    isSelf: boolean;
    /** The roles this path may add or remove (M1b: Administrator only). */
    grantableRoles: string[];
    policyVersion: string;
}

/** A change that committed, had already committed, or needed no write. */
export interface ApplicationRoleChangeResultDto {
    /** applied, already-applied or unchanged. */
    result: string;
    operationId: string;
    investigatorId: string;
    roles: string[];
    revision: number;
    policyVersion: string;
}

/** PUT /api/investigators/{id}/application-roles. The actor is always the authenticated real user; nothing in this body can name an actor, a group or a claim. */
export interface ApplicationRolesChangeDto {
    /** The complete desired role set. */
    roles: string[] | null;
    /** The revision the caller read. A different current revision is a 409 conflict. */
    expectedRevision: number | null;
    /** Why, recorded in the audit record (required, at most 500 characters). */
    reason: string | null;
    /** A client-generated ID for this one intended change. Retrying with the same ID is idempotent;
reuse it after an unknown outcome, generate a new one for a new decision. */
    operationId: string | null;
}

/** Result of reconciling a pending account deactivation (M1c): nothing-pending or deleted. */
export interface PendingDeactivationReconcileResultDto {
    result: string;
}

/** M4a: the suspension state of one Investigator (GET /api/investigators/{id}/application-suspension). */
export interface ApplicationSuspensionDto {
    investigatorId: string;
    suspended: boolean;
    /** The account is deleted (Deactivated): never suspendable or restorable. */
    deleted: boolean;
    /** pending, completed, not-applicable, or null when not suspended. */
    withdrawal: string | null;
    suspendedAt: string | null;
    /** Whether suspensions are being enforced (applicationSuspension on). While it is
            false the stored suspension is shown read-only and refuses nothing; switching the flag on enforces it again
            unchanged (#4290). */
    enforced: boolean;
}

/** A committed (or replayed) suspension or restore. */
export interface ApplicationSuspensionResultDto {
    /** suspended, restored, or already-applied for a replay of the same operation ID. */
    result: string;
    operationId: string;
    investigatorId: string;
    suspended: boolean;
    /** The native session withdrawal: completed, not-applicable or pending. */
    withdrawal: string | null;
}

/** M4a: POST /api/investigators/{id}/application-suspension (suspend) and POST …/application-suspension/restore. The actor is always the authenticated real user. */
export interface ApplicationSuspensionChangeDto {
    /** Why, recorded in the audit record only (required, at most 500 characters; never shown to the subject). */
    reason: string | null;
    /** A client-generated ID for this one intended change. Retrying with the same ID is idempotent. */
    operationId: string | null;
}

/** Only user-facing settings leave the account boundary; no aggregate audit or dispatch metadata. MutedProjectIds is optional on a save: absent keeps the saved mutes. CategoryOptions and MutedProjects are read-only (N5): a save ignores them. */
export interface NotificationEmailPreferencesDto {
    id: string;
    version: number;
    timeZoneId: string;
    dailySendTime: string;
    categories: { [key: string]: NotificationEmailSubscription; };
    mutedProjectIds: string[] | null;
    categoryOptions: NotificationEmailCategoryOptionDto[] | null;
    mutedProjects: NotificationMutedProjectDto[] | null;
}

export interface NotificationEmailSubscription {
    mode: string;
    /** Set by the server when a category leaves off. Opt-in never emails history from before this time. */
    enabledAtUtc: string | null;
}

/** An email category the screen offers: its key and its label, in the kind registry's order (N5). */
export interface NotificationEmailCategoryOptionDto {
    key: string;
    label: string;
}

/** A muted project: its ID (the key, never displayed) and its name, null when the reader can no longer view it. */
export interface NotificationMutedProjectDto {
    id: string;
    name: string | null;
}

/** The daily digest preview (N5). Html, Text and Subject are null when nothing would be sent. PreparedScheduledAtUtc is set when a digest is already prepared and not yet sent (its scheduled time). With a rendered digest it is waiting to be sent; without one (Html null) nothing from it will be sent. */
export interface NotificationDigestPreviewDto {
    hasDailyCategories: boolean;
    nextDigestAtUtc: string;
    itemCount: number;
    needsYouCount: number;
    subject: string | null;
    html: string | null;
    text: string | null;
    preparedScheduledAtUtc: string | null;
}

export interface NotificationPageDto {
    items: NotificationDto[];
    hasMore: boolean;
    unreadCount: number;
    /** Opaque position after the last item; null when HasMore is false. */
    nextCursor: string | null;
    /** True when there are more than 99 available unread items: UnreadCount is then 99 (show "99+"). N2. */
    unreadCountCapped: boolean;
}

/** One saved notice. View is the server-shaped card (N1), always set by the API; the typed fields before it are the older shape, kept unchanged for existing clients. The caller's own state from N2 follows the view: DismissedAtUtc, ResolvedAtUtc and Resolution (null when not dismissed or not resolved). */
export interface NotificationDto {
    id: string;
    createdAtUtc: string;
    readAtUtc: string | null;
    title: string;
    actionPath: string | null;
    exportResult: NotificationExportResultDto | null;
    importResult: NotificationImportResultDto | null;
    invitation: NotificationInvitationDto | null;
    stageResult: NotificationStageResultDto | null;
    view: NotificationViewDto | null;
    dismissedAtUtc: string | null;
    resolvedAtUtc: string | null;
    resolution: NotificationResolutionDto | null;
    dismissReason: string | null;
}

export interface NotificationExportResultDto {
    studiesProcessed: number | null;
    errorCount: number;
}

export interface NotificationImportResultDto {
    searchName: string;
    studiesImported: number;
}

export interface NotificationInvitationDto {
    projectName: string;
    message: string;
    status: string;
}

export interface NotificationStageResultDto {
    stageName: string;
    active: boolean;
    workloadChange: NotificationWorkloadChangeDto | null;
}

/** The recipient's configured workload before and after; the wire copy of the saved ReviewerWorkloadChange. */
export interface NotificationWorkloadChangeDto {
    previousBasisPoints: number | null;
    basisPoints: number | null;
    previousReviewsPerStudy: number;
    reviewsPerStudy: number;
}

/** The server-shaped card for one saved notice (C15 v2 "Source and view", N1), beside the older typed fields of NotificationDto. Every kind fills the same slots. When the reader can no longer open the related item (Availability is unavailable) the view carries the kind's label and nothing else: no key fact, blocks, actions or workflow state. */
export interface NotificationViewDto {
    /** The stored kind (for example exportCompleted). */
    kind: string;
    /** What the kind is called (for example "Export completed"). Never names a protected detail. */
    label: string;
    /** available or unavailable (NotificationAvailability). */
    availability: string;
    /** One line saying what happened; the label when unavailable. */
    headline: string;
    /** The one supporting fact shown under the headline; null when unavailable. */
    keyFact: string | null;
    /** Typed body blocks, in display order; empty when unavailable. */
    blocks: NotificationBodyBlockDto[];
    /** Where the notice leads; null when unavailable or when there is nowhere to go now. */
    primaryAction: NotificationActionDto | null;
    /** Extra actions the kind offers; none of the foundation kinds offers one yet. */
    typeActions: NotificationActionDto[];
    /** The related workflow's state where the kind has one (an invitation: pending). */
    workflowState: string | null;
    /** The related project (N3): its ID, for the Inbox's Project filter and the inline invitation answer (never shown), and
its name. Null when unavailable, and for a kind with no project. */
    project: NotificationProjectDto | null;
    /** The released feature a featureRelease notice is about (N7): its ID, from which the web offers "Try it" where the
feature has a walkthrough, and its user-guide page for "Read the guide". Null when unavailable, and for every other kind. */
    feature: NotificationFeatureDto | null;
}

/** One typed body block. Type says which other members it uses (NotificationBlockTypes): facts (Items), stat (Value, Label), state and callout (Text, Tone), note (Text), quote (Label, Text, Author), compare (Rows) and markdown (Text: untrusted Markdown, a feature release's What's New text, N7; a client renders it only through its untrusted Markdown pipe). A client skips a type it does not know. The author (N4, additive; Chris, 28 October 2026) is the display name of the person who wrote a quote's words (an invitation's inviter), read at the time of the request; null when that account is gone, deactivated or has no name, and on every other block. Never an ID. Older clients ignore it and keep showing the label. */
export interface NotificationBodyBlockDto {
    type: string;
    text: string | null;
    tone: string | null;
    value: string | null;
    label: string | null;
    items: string[] | null;
    rows: NotificationCompareRowDto[] | null;
    author: string | null;
}

/** One before-and-after row of a compare block. */
export interface NotificationCompareRowDto {
    label: string;
    from: string;
    to: string;
}

/** An action: a stable Id, its button text and the in-app path it opens. */
export interface NotificationActionDto {
    id: string;
    label: string;
    path: string;
}

/** The project a notice relates to: its ID (a filter and request key, not for display) and its name. N3. */
export interface NotificationProjectDto {
    id: string;
    name: string;
}

/** The released feature of a featureRelease notice (N7): its registry ID and its What's New entry's guide page (relative to the user guide, as availability reports it), or null when the entry names none. */
export interface NotificationFeatureDto {
    id: string;
    guidePath: string | null;
}

/** Why the notice resolved (ACD §3.7): the Reason (decided, completed, withdrawn, expired, superseded) and the workflow transition (an invitation: accepted or declined). Who resolved it is stored but not returned until the disclosure policy shapes it. */
export interface NotificationResolutionDto {
    reason: string;
    sourceTransition: string | null;
}

export interface NotificationCountDto {
    unreadCount: number;
    /** True when there are more than 99 available unread items (the count is 99): show "99+". N2. */
    unreadCountCapped: boolean;
}

/** How many of the named notices Mark all as read marked read now (already read and foreign IDs are not counted). */
export interface NotificationMarkAllReadResultDto {
    read: number;
}

/** The notices Mark all as read marks read: the IDs the client shows (1 to 100). N3. */
export interface NotificationMarkAllReadDto {
    ids: string[];
}

/** How many of the named notices Clear all dismissed now (already dismissed and foreign IDs are not counted). */
export interface NotificationClearAllResultDto {
    dismissed: number;
}

/** The notices Clear all dismisses: the IDs the client shows (1 to 100). */
export interface NotificationClearAllDto {
    ids: string[];
}

export interface CreateProjectDto {
    name: string;
    protocolLink: string;
    keywords: string[];
    inclusionCriteria: string;
    exclusionCriteria: string;
    contactEmail: string;
    isPrivate: boolean;
    description: string;
    livingSearch: CreateLivingSearchDto | null;
    screeningMachineLearningEnabled: boolean;
}

export interface ProjectsWithRelatedInvestigatorsDto {
    projects: ProjectDbBaseDto[];
    relatedInvestigators: InvestigatorDbSummaryDto[];
}

export interface SerializableError {

    [key: string]: any;
}

export interface OperationBase {
    path: string | null;
    op: string | null;
    from: string | null;
}

export interface Operation extends OperationBase {
    value: any | null;
}

export interface InclusionInfoUpdateResults {
    addInclusionInfoFieldCount: RecordsModified;
    insertInclusionInfoElementCount: RecordsModified;
    replaceMatchingInclusionInfoElementCount: RecordsModified | null;
    allSuccess: boolean;
}

export interface ValueObjectOfRecordsModified {
}

export interface RecordsModified extends ValueObjectOfRecordsModified {
    numberModified: number;
    numberMatched: number;
}

export interface UpdateResultsByProject {
    successes: { [key: string]: InclusionInfoUpdateResults; };
    failures: { [key: string]: string; };
}

export interface JoinRequestResponseDto {
    response: string;
    project: ProjectDbBaseDto;
    relatedInvestigators: InvestigatorDbSummaryDto[];
    accessGranted: boolean;
}

export interface AcceptJoinRequestsDto {
    investigatorIds: string[];
    groups: string[];
}

export interface DeclineJoinRequestsDto {
    investigatorIds: string[];
}

export interface InviteMembersResponseDto {
    responseReport: { [key: string]: InviteResponse; };
    project: ProjectDbBaseDto;
}

export enum InviteResponse {
    Invited = 0,
    AlreadyMember = 1,
    InvitationAlreadyPending = 2,
    NoFurtherInvitationsRequested = 3,
    PendingJoinRequestAcceptedInstead = 4,
}

export interface NewInvitationsDto {
    inviteeEmails: string[];
    groupIds: string[];
    message: string;
}

export interface ProjectWithInvitationAndRelatedInvestigatorsDto {
    project: ProjectDbBaseDto;
    invitation: InvitationFullDto;
    relatedInvestigators: InvestigatorDbSummaryDto[];
}

export interface InvitationResponseDto {
    conclusionType: InvitationConclusionType;
    token: string | null;
}

export interface ResendInvitationsDto {
    inviteeEmails: string[];
    groupIds: string[] | null;
    message: string | null;
}

export interface UpdateInvitationGroupsDto {
    inviteeEmails: string[];
    groupIds: string[];
}

export interface UpsertCustomAnnotationQuestionDto {
    id: string;
    isNew: boolean;
    target: TargetDto | null;
    question: string;
    description: string | null;
    optional: boolean;
    multiple: boolean;
    options: QuestionOptionDto[] | null;
    category: string;
    questionType: string;
    controlType: string;
    answerArray: boolean;
    defaultCheckboxStatus: CheckboxStatus | null;
    /** Singular noun naming one repeatable answer instance, e.g. "experimental
protocol". Null lets the client derive one from the question text. */
    answerLabel: string | null;
    /** True when AnswerLabel follows the generated heuristic;
false when authored. Null is legacy/unknown and must be treated as
authored by later writer behaviour. */
    answerLabelGenerated: boolean | null;
}

export interface CopyQuestionSuccessDto {
    originalQuestionId: string;
    copiedQuestionId: string;
    affectedQuestions: AnnotationQuestionDto[];
}

export interface CreateStageDto {
    id: string;
    name: string;
    reviewMode: ReviewMode;
    studySelectionMode: StudySelectionMode;
    additionalScreeningPolicy: AdditionalScreeningPolicy | null;
    description: string;
    maxInProgress: number | null;
    active: boolean;
    projectId: string;
    extraction: boolean;
}

/** The project's complete set of default "Guidance for reviewers" texts after a write (revision-2 README §6.5). Deliberately narrow: a guidance edit changes nothing else about the project, so the response carries only the map the browser needs to refresh rather than a whole project projection whose completeness depends on the caller's role. */
export interface ProjectCategoryGuidanceDto {
    projectId: string;
    /** Keyed by annotation-question category. Empty — never null — when none is written. */
    categoryGuidance: { [key: string]: string; };
}

/** One administrator-written project-level default "Guidance for reviewers" entry for a single annotation-question category (revision-2 README §6.5). An empty or whitespace-only Guidance clears the entry, leaving categories with no default. Stage overrides are written through the stage endpoint and are unaffected. */
export interface ProjectCategoryGuidanceUpdateDto {
    /** The annotation-question category name, for example "Disease Model Induction". */
    category: string;
    /** Plain-text guidance, at most 600 characters. Null or empty clears the entry. */
    guidance: string | null;
}

/** A project's normalised screening keyword lists after a write (FEAT-025). Deliberately narrow, like the category-guidance response: a keyword edit changes nothing else about the project. */
export interface ScreeningKeywordsDto {
    projectId: string;
    /** Normalised inclusion keywords. Empty — never null — when none are written. */
    inclusionKeywords: string[];
    /** Normalised exclusion keywords. Empty — never null — when none are written. */
    exclusionKeywords: string[];
}

/** Replaces both of a project's screening keyword lists (FEAT-025). Terms are trimmed, internal whitespace collapsed, empties dropped and case-insensitive duplicates removed. A term may be at most 100 characters, a list at most 200 terms, and the same term may not appear in both lists. An empty list clears that list. */
export interface ScreeningKeywordsUpdateDto {
    /** Keywords or phrases whose matches are highlighted as inclusion cues. */
    inclusionKeywords: string[];
    /** Keywords or phrases whose matches are highlighted as exclusion cues. */
    exclusionKeywords: string[];
}

/** One administrator-written "Guidance for reviewers" entry for a single annotation-question category on a single stage (revision-2 README §6.5). An empty or whitespace-only Guidance clears the entry. */
export interface StageCategoryGuidanceUpdateDto {
    /** The annotation-question category name, for example "Disease Model Induction". */
    category: string;
    /** Plain-text guidance, at most 600 characters. Null or empty clears the entry. */
    guidance: string | null;
}

export interface UpdateProjectMembershipsDto {
    investigatorIds: string[];
    projectGroupIds: string[];
}

export interface UpdateStagePermissionDto {
    activity: StageActivity;
    allowedProjectGroupIds: string[];
    allowAllProjectMembers: boolean;
}

export interface UpdateProjectPermissionDto {
    activity: ProjectActivity;
    allowedProjectGroupIds: string[];
    allowAllProjectMembers: boolean;
}

/** The summary an administrative backfill or rebuild returns. */
export interface ProjectStatisticsBackfillSummaryDto {
    projectId: string;
    metricFamily: string;
    forced: boolean;
    scopesRebuilt: number;
    scopesAlreadyCurrent: number;
    scopesStale: number;
    scopesAbsent: number;
    scopesContended: number;
    checkpointStatus: string | null;
    scopes: ProjectStatisticsScopeOutcomeDto[];
}

/** One scope's result in an administrative backfill or rebuild response. */
export interface ProjectStatisticsScopeOutcomeDto {
    scopeKind: string;
    scopeKey: string;
    disposition: string;
    status: string;
    failureReason: string;
    publishedGeneration: number;
    detail: string | null;
}

export interface ProjectStatisticsDeltaMaintenanceResult {
    outcome: string;
    recordsDeleted: number;
    replayFloorRevision: number;
    safeThroughRevision: number;
}

/** The counts of one re-persist run (issue #3960). */
export interface ReviewerScreeningDriftRePersistResult {
    /** The project. */
    projectId: string;
    /** How the run ended. */
    outcome: ReviewerScreeningDriftRePersistOutcome;
    /** Studies the scan compared with what a save would write (the project's, or the requested ones found in it). */
    studiesChecked: number;
    /** Of those, Studies a whole-Study save would change. */
    driftedStudies: number;
    /** Drifted Studies saved through the ordinary whole-Study writer. */
    rePersisted: number;
    /** Drifted at the scan, no longer drifted when loaded to save (another save re-persisted them). */
    alreadyCurrent: number;
    /** The known legacy shape no whole-Study writer can save (a null screening list): skipped, never written. */
    notResavable: number;
    /** Requested Studies that are not in the project (or vanished during the run). */
    notFound: number;
    /** Requested Studies found but not drifted: skipped. */
    notDrifted: number;
    /** Drifted Studies that could not be re-persisted. */
    failed: number;
    /** Up to MaximumReportedFailures failures with their typed reasons. */
    failures: ReviewerScreeningDriftRePersistFailure[];
    /** The fence's final state for this run's operation id: ReleasedStale when a fence (this run's, or one an
earlier run stranded) was released; NotHeld when none was held; NotRequested when no statistics
are written or served for the project; ReleaseFailed when the release failed (repeat the run). */
    fenceStatus: string;
    /** The project-wide drift report read after the run; null when the run was refused. */
    remainingDrift: ReviewerScreeningInclusionDrift | null;
}

/** How a re-persist run ended. */
export enum ReviewerScreeningDriftRePersistOutcome {
    Completed = 0,
    CompletedWithFailures = 1,
    ProductionRefused = 2,
}

/** One drifted Study the run could not re-persist. Reason is a typed token, never a message. */
export interface ReviewerScreeningDriftRePersistFailure {
    studyId: string;
    reason: string;
}

/** The Studies of one project whose stored derived screening fields differ from what a whole-Study save would write (issues #3937 and #3960), read in one pass over the project's Studies.            Seven families are legacy queries over stored derived fields: ReviewerScreening over the inclusion status for the project's threshold; MembershipScreening and ProjectScreening over the agreement measure, inclusion fraction and included count; StageAnnotation, DomainReconciliation, MembershipStageAnnotation and ReviewerAnnotation over the SufficientlyExcluded partition for the threshold. Every whole-Study writer re-persists them recalculated from the screenings, and most of those writers (annotation saves, reservation changes, presence and idle-session updates, risk-of-bias saves) carry no statistics move, on either write path. So while such a Study exists a Fresh row of a family that reads the drifted field can be made wrong by an ordinary save. A current row of that family is therefore never published while this report finds drift for it (, ); with no drift every whole-Study save re-persists the values it read, and only screening saves, which carry the statistics move, change them. QuestionAnswers and SearchPopulation read no stored screening field. */
export interface ReviewerScreeningInclusionDrift {
    /** Every Study of the project. */
    studiesChecked: number;
    /** Studies a save would change ReviewerScreening's stored sufficiency input for. */
    statusDriftedStudies: number;
    /** Studies a save would change the stored agreement input MembershipScreening and ProjectScreening read for. */
    agreementDriftedStudies: number;
    /** Studies of the one known legacy shape that cannot be recalculated (a null screening list). No
whole-Study writer other than a screening save can save them, so they do not block. */
    notResavableStudies: number;
    /** Up to SampleSize drifted Study ids, any kind, in read order. */
    sampleDriftedStudyIds: string[];
    /** Studies with any kind of drift: the Studies the re-persist rewrites. */
    driftedStudies: number;
    /** Studies whose full stored StudyScreenStatus for the threshold a save would change, including an
Included/Excluded/Disagree mismatch that leaves the sufficiency answer (StatusDriftedStudies)
unchanged. No family refuses on this count alone; it is cleared by the re-persist. */
    screenStatusDriftedStudies: number;
    /** Studies whose stored SufficientlyExcluded answer for the threshold a save would change: the inclusion
partition StageAnnotation, DomainReconciliation, MembershipStageAnnotation and ReviewerAnnotation read. */
    exclusionDriftedStudies: number;
    /** Studies whose stored Overscreened flag for the threshold a save would change. No statistics family
reads it, so it refuses nothing; it is cleared by the re-persist. */
    overscreenedDriftedStudies: number;
    hasDrift: boolean;
}

/** The re-persist request body. */
export interface ReviewerScreeningDriftRePersistBody {
    /** Re-persist only these Studies (each verified drifted first). Omit with All. */
    studyIds: string[] | null;
    /** Re-persist every drifted Study of the project. */
    all: boolean;
    /** Required: the operation rewrites Studies. */
    confirm: boolean;
    /** The production override; honoured only for the statistics operator credential. */
    allowProduction: boolean;
}

/** The read-only stranded-fence report for one project's inclusion-recalculation fence (issue #3086's recommended default: report, never release on a timer). Every field is a typed durable fact; no exception text is carried. */
export interface ProjectStatisticsInclusionFenceDiagnostic {
    projectId: string;
    fenceHeld: boolean;
    token: string | null;
    operationId: string | null;
    currentConfigurationOperationId: string;
    tokenMatchesCurrentConfiguration: boolean;
    fenceRaisedAtUtc: string | null;
    fenceAgeMinutes: number | null;
    liveSourceJob: boolean;
    strandedAfterMinutes: number;
    stranded: boolean;
    strandedReason: ProjectStatisticsStrandedFenceReason;
    sourceInvalidationRevision: number;
    clientInvalidationRevision: number;
    activeOperationFenceCount: number;
    activeOperationFenceCountTruncated: boolean;
    families: ProjectStatisticsInclusionFenceFamilyDiagnostic[];
    recordedAdminFailureCount: number;
    recovery: string | null;
    observedAtUtc: string;
}

/** Why a held inclusion-recalculation fence is reported as stranded. */
export enum ProjectStatisticsStrandedFenceReason {
    None = 0,
    NoLiveSourceJob = 1,
    OlderThanThreshold = 2,
}

/** One affected family's view of the fence. */
export interface ProjectStatisticsInclusionFenceFamilyDiagnostic {
    metricFamily: string;
    guardLifecycle: string | null;
    guardActiveFenceCount: number;
    guardActiveOperationId: string | null;
    activeOperationFenceCount: number;
}

/** Bounded operational progress; projection/history truth remains in existing coordinators. */
export interface ProjectStatisticsFleetRun {
    id: string;
    schemaVersion: number;
    requestDigest: string;
    initiatedBy: string;
    createdAtUtc: string;
    repair: boolean;
    targets: ProjectStatisticsFleetTarget[];
    cursor: number;
    attempts: number;
    pauseRequested: boolean;
    status: ProjectStatisticsFleetStatus;
    results: ProjectStatisticsFleetItemResult[];
}

export interface ProjectStatisticsFleetTarget {
    projectId: string;
    family: ProjectStatisticsMetricFamily;
}

/** The bounded catalogue of materialized-statistics metric families. Source: FEAT-024 technical plan, "Catalogue baseline". The set is deliberately fixed and small: it bounds the number of publication guards, notification slots and lifecycle summaries a project can hold. Persisted numeric values are append-only; never renumber an existing member. */
export enum ProjectStatisticsMetricFamily {
    ProjectScreening = 0,
    MembershipScreening = 1,
    ReviewerScreening = 2,
    StageAnnotation = 3,
    MembershipStageAnnotation = 4,
    ReviewerAnnotation = 5,
    QuestionAnswers = 6,
    DomainReconciliation = 7,
    SearchPopulation = 8,
    DerivedSummary = 9,
}

export enum ProjectStatisticsFleetStatus {
    Pending = 0,
    Paused = 1,
    Completed = 2,
}

/** One target's latest attempt. LifecycleStatus and FailureReason carry the backfill's typed answer as bounded enum names, so an operator can tell retryable contention from a fence, digest mismatch or capacity refusal without the free-text detail being persisted. */
export interface ProjectStatisticsFleetItemResult {
    index: number;
    observedAtUtc: string;
    succeeded: boolean;
    outcome: string;
    publishedScopes: number;
    alreadyCurrentScopes: number;
    staleScopes: number;
    lifecycleStatus: string | null;
    failureReason: string | null;
}

export interface ProjectStatisticsFleetCreateRequest {
    runId: string;
    targets: ProjectStatisticsFleetTarget[];
    repair: boolean;
}

export interface ProjectStatisticsFleetControl {
    id: string;
    schemaVersion: number;
    revision: number;
    stopped: boolean;
    activeRunId: string | null;
    leaseToken: string;
    leaseGeneration: number;
    leaseExpiresAtUtc: string;
    nextAdmissionAtUtc: string;
    pruneSequence: number;
    recentPrunes: ProjectStatisticsFleetPruneAudit[];
}

/** One bounded pruning record. DeletedTargets and DeletedOutcomes summarise the typed results of the runs actually deleted, so the audit keeps what the removed progress said without keeping it. */
export interface ProjectStatisticsFleetPruneAudit {
    sequence: number;
    administratorId: string;
    observedAtUtc: string;
    requestedRunIds: string[];
    deletedRuns: number;
    deletedTargets: number;
    deletedOutcomes: ProjectStatisticsFleetPruneOutcomeCount[] | null;
}

/** How many deleted target results carried one typed LifecycleStatus and FailureReason pair. Null names are results written before the typed fields existed; they are counted, never dropped. */
export interface ProjectStatisticsFleetPruneOutcomeCount {
    lifecycleStatus: string | null;
    failureReason: string | null;
    count: number;
}

export interface ProjectStatisticsFleetPruneRequest {
    runIds: string[];
}

/** The read-only report of the pending-statistics index. */
export interface StudyPendingStatisticsIndexStatus {
    /** The server-side state. */
    state: StudyPendingStatisticsIndexState;
    /** The index name the design fixes (IX_Study_PendingStatistics). */
    indexName: string;
    /** A plain description of the state, including the conflicting definition when there is one. */
    detail: string;
    /** The failure of the most recent build this process started, if it failed; null otherwise. Another
replica's builds are not visible here, only through State. */
    lastBuildFailure: string | null;
    isReady: boolean;
}

/** Where the pending-statistics index stands on pmStudy, as the server reports it. */
export enum StudyPendingStatisticsIndexState {
    Absent = 0,
    Building = 1,
    Ready = 2,
    Conflicting = 3,
}

/** One project's fold state, as the administrative status route reports it. */
export interface ProjectStatisticsFoldStatus {
    projectId: string;
    foldMode: string;
    stampedProtocol: number;
    binaryProtocol: number;
    foldEverEnabled: boolean;
    foldEnabledAtUtc: string | null;
    foldDisablingSinceUtc: string | null;
    quarantineIncompleteSinceUtc: string | null;
    /** Studies with a pending set, counted up to one past the overlay's threshold. */
    pendingStudies: number;
    pendingEntries: number;
    pendingOverflow: boolean;
    oldestPendingAtUtc: string | null;
    workerHeartbeatLive: boolean;
    workerHeartbeatAgeSeconds: number | null;
    pendingIndexReady: boolean;
    foldFlagOn: boolean;
    allowlisted: boolean;
    coverageSufficient: boolean;
    isStaging: boolean;
    allowPartialCoverage: boolean;
}

/** A fold-mode transition's typed answer. */
export interface ProjectStatisticsFoldTransitionResult {
    outcome: ProjectStatisticsFoldTransitionOutcome;
    detail: string;
    isSuccess: boolean;
}

/** How a fold-mode administrative transition ended. */
export enum ProjectStatisticsFoldTransitionOutcome {
    Applied = 0,
    AlreadyApplied = 1,
    NotFound = 2,
    FoldFlagOff = 3,
    NotAllowlisted = 4,
    RolloutNotConfirmed = 5,
    PendingIndexMissing = 6,
    FoldFleetUnsupported = 7,
    FoldCoverageIncomplete = 8,
    InvalidState = 9,
    ConcurrencyLost = 10,
}

/** The operator's enable request. */
export interface ProjectStatisticsFoldEnableRequest {
    /** The operator confirms that both the api and project-management rollouts completed, with no old
ReplicaSet pod alive (ArgoCD Healthy and a read-only kubectl rollout status). */
    rolloutCompleteConfirmed: boolean;
}

/** One project's stamp-advance answer. */
export interface ProjectStatisticsFoldStampAdvanceResult {
    projectId: string;
    outcome: ProjectStatisticsFoldStampAdvanceOutcome;
    fromProtocol: number | null;
    toProtocol: number | null;
    detail: string;
    isSuccess: boolean;
}

/** How one project's fold-protocol stamp advance ended. */
export enum ProjectStatisticsFoldStampAdvanceOutcome {
    Advanced = 0,
    AlreadyCurrent = 1,
    NothingToAdvance = 2,
    NotAllowed = 3,
    FleetNotReady = 4,
    WorkerHeartbeatNotLive = 5,
    NotFound = 6,
    NotInFoldMode = 7,
    StampOutsideWindow = 8,
    PendingBelowPrevious = 9,
    ConcurrencyLost = 10,
}

export interface ScreeningHistoryPage {
    points: ScreeningHistoryPoint[];
    nextCursor: string | null;
}

/** Observed overall state only; decision-detail permissions are not widened by this endpoint. */
export interface ScreeningHistoryPoint {
    checkpoint: string;
    observedAtUtc: string | null;
    trigger: string | null;
    sourceVersion: number | null;
    catalogueVersion: number | null;
    configurationDigest: string | null;
    availability: string;
    total: number | null;
    sufficientlyScreened: number | null;
    insufficientlyScreened: number | null;
    /** #3636: later instants at which the project was recorded unchanged since this checkpoint,
oldest first. Each carries this checkpoint's values forward and must be shown as carried
forward, not observed. Empty unless this point is Available; a day with neither a point nor
an entry here is a gap. */
    unchangedAtUtc: string[];
    /** #3636: how far this checkpoint's values are verified: Confirmed (every value was
calculated from source, or a later drift check confirmed it), Unconfirmed (some values
were copied from the current materialised statistics and await a drift check) or
Suspect (a drift check found the materialised statistics disagreeing with source, so
copied values may be wrong). Carried-forward days in UnchangedAtUtc share it.
Null unless this point is Available. */
    verificationState: string | null;
}

export interface ProjectStatisticsHistoryMaintenanceResult {
    rootsScanned: number;
    rootsRemoved: number;
    pagesDeleted: number;
    rootsDeleted: number;
    observationsScanned: number;
    observationsDeleted: number;
    nextObservationId: string | null;
    markersReclaimed: number;
    unchangedDaysDeleted: number;
    verificationsDeleted: number;
}

export interface ProjectStatisticsHistoryMaintenanceRequest {
    afterObservationId: string | null;
}

/** What one mode transition left behind. */
export interface ProjectStatisticsModeTransitionDto {
    /** "Fleet" or "Project": which gate the transition acted on. */
    scope: string;
    /** The project whose narrow gate was acted on; null for a fleet transition. */
    projectId: string | null;
    /** The typed transition outcome. */
    outcome: string;
    /** The durable mode the gate was left in, read back from its row. */
    mode: string;
    /** The write epoch that mode is fenced by. */
    writeEpoch: number;
    /** The client-invalidation revision the gate carries. */
    clientInvalidationRevision: number;
    /** The catalogue version recorded on the durable control row this transition acted on — the
fleet singleton for a fleet transition, the project's own control row for a narrow-gate one.
            
It is deliberately not the version this deployment's writers produce. A row enabled by an
older deployment keeps that deployment's numbers, and the reader refuses every row whose versions
disagree with its control, so echoing the running build's constants would agree with itself by
construction and hide exactly the drift this field exists to show.
            
Null when the transition found no control row to report: a narrow gate refused
NotFound, or a fleet transition whose singleton neither existed nor was created. */
    recordedCatalogueVersion: number | null;
    /** The storage version recorded on that same durable control row, under the same rules as
RecordedCatalogueVersion. */
    recordedStorageVersion: number | null;
    /** The source version recorded on that same durable control row, under the same rules as
RecordedCatalogueVersion. */
    recordedSourceVersion: number | null;
    /** How many scopes a re-enable's rebuild sweep published, when one ran. */
    scopesRebuilt: number;
    /** The operator-facing explanation of what the transition did or refused. */
    detail: string;
}

/** The requested fleet-wide durable serving mode. */
export interface ProjectStatisticsFleetModeRequestDto {
    mode: string;
}

/** Whether one project's narrow serving gate should be open. */
export interface ProjectStatisticsNarrowGateRequestDto {
    enabled: boolean | null;
}

/** The admin parity report for one project's materialized metric family — project screening by default, or the family named by the read's family parameter.            For the default (project screening) every original field keeps its exact meaning. A multi-scope family reports Metrics empty and each scope's comparison in Scopes; MaterializedAvailable then means every scope was served, and ScopeStates lists every scope. Verdict is the single answer: InParity, Mismatch, or Inconclusive with an InconclusiveReason (SourceAdvanced, NotServed, NoScopes, ScopesTruncated). It is broader than IsInconclusive, which keeps its original meaning (values compared, but a write landed underneath): a served side that fell back is an Inconclusive verdict, never a pass.            InParity is false whenever the projection produced nothing to compare — a bundle that legitimately refuses to serve is not "in parity", it is unaudited, and FallbackReason says which.            ConfigurationMatchesCurrentSettings is separate from the verdict on purpose. False there means the control row is still stamped under settings the project no longer has, so its counters answer a superseded question even when they agree with today's calculation — a drift to chase separately, not a divergence in the values compared here. It says nothing about how the digest came to be stamped: a rebuild adopts the digest of the project it read, so a fresh forced rebuild reports a match. Null means the comparison could not be made, never that it passed.            It is also false when IsInconclusive is true: a write landed underneath the comparison, so the deltas below may be an artefact of the race rather than real drift. That is the distinction an operator reading a staging parity report most needs, and it is why a racing run is never reported as a divergence to chase. */
export interface ProjectStatisticsParityReportDto {
    projectId: string;
    metricKey: string;
    inParity: boolean;
    isInconclusive: boolean;
    sourceAdvancedDuringAudit: boolean;
    materializedAvailable: boolean;
    readSource: string;
    fallbackReason: string;
    capacityFailure: string;
    checkpoint: ProjectStatisticsCheckpointIdDto | null;
    watermarks: ProjectStatisticsWatermarksDto;
    scopeStates: ProjectStatisticsParityScopeStateDto[];
    metrics: ProjectStatisticsParityMetricDto[];
    observedAtUtc: string;
    controlConfigurationDigest: string | null;
    currentSettingsConfigurationDigest: string | null;
    configurationMatchesCurrentSettings: boolean | null;
    metricFamily: string;
    verdict: string;
    inconclusiveReason: string;
    scopesTruncated: boolean;
    scopes: ProjectStatisticsParityScopeDto[];
}

/** The three-component checkpoint identity a materialized answer was observed at. */
export interface ProjectStatisticsCheckpointIdDto {
    checkpointSourceRevision: number;
    checkpointProjectionRevision: number;
    checkpointModeEpoch: number;
    canonical: string;
}

/** The revision, version and digest envelope the read observed. */
export interface ProjectStatisticsWatermarksDto {
    globalClientInvalidationRevision: number;
    sourceInvalidationRevision: number;
    committedProjectionRevision: number;
    clientInvalidationRevision: number;
    modeEpoch: number;
    catalogueVersion: number;
    storageVersion: number;
    sourceVersion: number;
    configurationDigest: string | null;
}

/** One requested selection's observed projection state. */
export interface ProjectStatisticsParityScopeStateDto {
    selection: string;
    scope: string;
    availability: string;
    state: string | null;
    isTombstone: boolean;
    isPublished: boolean;
    publicationGeneration: number | null;
    lastChangedRevision: number | null;
}

/** One metric key's expected/actual/delta row of a parity report. */
export interface ProjectStatisticsParityMetricDto {
    /** The catalogue counter path, e.g. screening.sufficientlyScreened. */
    metricKey: string;
    /** The authoritative value. */
    expected: number;
    /** The materialized value, or null when the projection produced none. */
    actual: number | null;
    /** Actual - Expected, or null when there is nothing to compare. */
    delta: number | null;
    /** True only when a materialized value exists and equals the expected one. */
    inParity: boolean;
}

/** One scope of a per-family parity audit: the selection and scope labels (a reviewer scope is labelled reviewer- plus a per-project pseudonym rather than an investigator id; the pseudonym is an unkeyed hash, reversible by anyone who knows the project's member ids), how the reader answered it, the verdict, and the metric-by-metric comparison. */
export interface ProjectStatisticsParityScopeDto {
    selection: string;
    scope: string;
    readSource: string;
    fallbackReason: string;
    capacityFailure: string;
    /** True when the reader answered from the projection (a live row or a tombstone). */
    served: boolean;
    /** True when the family's authoritative calculation has no answer for the scope. */
    authoritativeAbsent: boolean;
    inParity: boolean;
    /** InParity, Mismatch or Inconclusive. */
    verdict: string;
    /** None, SourceAdvanced or NotServed. */
    inconclusiveReason: string;
    availability: string;
    state: string | null;
    isTombstone: boolean;
    isPublished: boolean;
    publicationGeneration: number | null;
    lastChangedRevision: number | null;
    metrics: ProjectStatisticsParityMetricDto[];
}

export interface ProjectStatisticsPilotStatusDto {
    writesEnabled: boolean;
    servingEnabled: boolean;
    screeningEnabled: boolean;
    pagesEnabled: boolean;
    projectOverviewEnabled: boolean;
    stagingTestAllowed: boolean;
    fleetMode: string | null;
    fleetWriteEpoch: number;
    projects: ProjectStatisticsPilotProjectDto[];
    observedAtUtc: string;
}

export interface ProjectStatisticsPilotProjectDto {
    projectId: string;
    name: string;
    mode: string | null;
    writeEpoch: number;
    disableCompletesAfterUtc: string | null;
}

/** The administrative projection read (GET api/admin/project-statistics/{id}/projection-read, issue #3952): one family's consumer reads, with where each answer came from.            reads holds one entry per consumer read. A consumer that reads per stage or per reviewer is read once per scope (at most 256 reads; truncated when more existed); the others read the family in one bundle. The top-level provenance aggregates them for the evidence validator: readSource is Materialized only when every read served; fallbackReason and readerFallbackReason are the first non-served read's (NoScopes when there was no scope to read); checkpoint is the checkpoint every served read shares, or null; scopeStates is every read's scope states, in read order. consumerRoute names the consumer read mirrored (null for domain reconciliation, which has none).            For ProjectScreening every field #4012 defined keeps its meaning: one read, its values in values. values is null for every other family; their values are per read.            It deliberately has no inParity/isInconclusive pair: it is a consumer read with provenance, not a parity poll, and the evidence validator rejects a read that looks like one. */
export interface ProjectStatisticsProjectionReadDto {
    projectId: string;
    family: string;
    values: ProjectScreeningStats | null;
    readSource: string;
    fallbackReason: string;
    readerFallbackReason: string;
    checkpoint: ProjectStatisticsCheckpointIdDto | null;
    scopeStates: ProjectStatisticsProjectionReadScopeStateDto[];
    consumerRoute: string | null;
    reads: ProjectStatisticsProjectionReadEntryDto[];
    truncated: boolean;
}

/** One requested selection's projection state as the projection read observed it: the parity report's scope fields plus the metric Family and the formatted ScopeKey.            A reviewer is never named: the investigator component of a membership or membership-stage scope is the per-project pseudonym the per-family parity audit uses (reviewer- and 12 hex digits of SHA-256 over the project and investigator ids). Stage, question and search ids are configuration identifiers and appear as they are. */
export interface ProjectStatisticsProjectionReadScopeStateDto {
    /** The metric family name, e.g. ProjectScreening. */
    family: string;
    /** The scope label, e.g. project or membership:reviewer-1a2b3c4d5e6f. */
    scopeKey: string;
    /** The selection label, e.g. project-screening@project. */
    selection: string;
    /** The scope label again (the parity report's name for ScopeKey). */
    scope: string;
    /** The selection availability name: Available or NotAvailable. */
    availability: string;
    /** The row's scope state name (Fresh, Stale, ...), or null with no row. */
    state: string | null;
    /** True when the selected row is a deletion tombstone. */
    isTombstone: boolean;
    /** True only when a row exists and is published. */
    isPublished: boolean;
    /** The row's publication generation, when there is a row. */
    publicationGeneration: number | null;
    /** The row's last changed revision, when there is a row. */
    lastChangedRevision: number | null;
}

/** One consumer read the projection read performed: the scope it was issued for, the consumer's values and where they came from. */
export interface ProjectStatisticsProjectionReadEntryDto {
    /** What the read was issued for: project, stage:{stageId}, membership:{reviewer} or
membership-stage:{reviewer}:{stageId}, reviewers by pseudonym. */
    scope: string;
    /** The consumer's answer for this read in its own wire shape, with every investigator and membership id
of the project replaced by that reviewer's pseudonym. Search counts are reported as
[{ searchId, numberOfStudies }]; domain reconciliation as [{ stageId, counters }], or
null when the projection could not serve it (it has no consumer and no authoritative calculation). */
    values: any | null;
    /** Materialized or AuthoritativeFallback. */
    readSource: string;
    /** The consumer's reason; None exactly when materialized. */
    fallbackReason: string;
    /** The bundle reader's reason; None when no bundle was read or it served. */
    readerFallbackReason: string;
    /** The checkpoint a materialized read was observed at. */
    checkpoint: ProjectStatisticsCheckpointIdDto | null;
    /** Every selection this read's bundle selected; empty when no bundle was read. */
    scopeStates: ProjectStatisticsProjectionReadScopeStateDto[];
}

export interface ProjectStatisticsReceiptMaintenanceResult {
    outcome: string;
    recordsScanned: number;
    recordsDeleted: number;
    idempotencyFloorUtc: string | null;
    /** Receipts of the page left in place because their Study still has a pending statistics set (async
point fold). A page that reclaimed nothing for that reason answers
BlockedByPendingStatistics rather than
"nothing eligible": the same rows head the next page until the fold drains those Studies. */
    recordsBlockedByPending: number;
}

export interface QuestionAnswerCountsResponse {
    projectId: string;
    enabled: boolean;
    questionIds: string[];
    counts: AnnotationAnswerTallyStore[];
}

export interface AnnotationAnswerTallyStore {
    id: string;
    studies: number;
    annotations: number;
}

export interface SavedSessionResponseDto {
    savedSession: AnnotationSessionDetailDto;
}

export interface AnnotationSessionBaseDto {
    id: string;
    investigatorId: string;
    projectId: string;
    studyId: string;
    stageId: string;
    status: SessionStatus;
    reconciliation: boolean;
    /** Reviewer-owned root annotation IDs in display order. Omission or explicit null preserves saved order; an array reorders the listed IDs within their existing slots. */
    entityOrder: string[] | null;
    isOnServer: boolean;
    isDirty: boolean;
}

export interface AnnotationSessionDetailDto extends AnnotationSessionBaseDto {
    outcomeData: OutcomeDataDto[];
    annotations: AnnotationDto[];
}

export interface OutcomeDataDto {
    id: string;
    stageId: string;
    studyId: string;
    experimentId: string;
    outcomeId: string;
    cohortId: string;
    units: string;
    averageType: string;
    investigatorId: string;
    projectId: string;
    reconciled: boolean;
    greaterIsWorse: boolean;
    errorType: string;
    numberOfAnimals: number;
    timePoints: TimePointDto[];
    graphId: string | null;
}

export interface TimePointDto {
    time: number;
    average: number | null;
    error: number | null;
}

export interface AnnotationDto {
    id: string;
    studyId: string;
    annotatorId: string;
    projectId: string;
    questionId: string;
    question: string;
    root: boolean;
    answerType: string;
    notes: string;
    stageId: string;
    children: string[];
    parentId: string | null;
    reconciled: boolean;
}

export enum SessionStatus {
    Incomplete = 0,
    Completed = 1,
}

export interface AnnotationSubmissionConflictDto {
    outcome: string;
    message: string;
}

export interface SessionSubmissionWebDto {
    id: string;
    stageId: string;
    status: SessionStatus;
    reconciliation: boolean;
    /** Reviewer-owned root annotation IDs in display order. Omission or explicit null preserves saved order; an array reorders the listed IDs within their existing slots. */
    entityOrder: string[] | null;
    investigatorId: string;
    projectId: string;
    studyId: string;
    outcomeData: OutcomeDataDto[] | null;
    annotations: AnnotationDto[];
    isDirty: boolean;
}

export interface NextStudyResponseDto {
    reviewStatus: ReviewStatus;
    investigatorUsage: InvestigatorUsageDto | null;
    nextStudy: StudyBaseDto | null;
    /** Access-check result populated only for direct-study-navigation flows.
Null for list/next-study flows that don't attempt a slot reservation.
Clients seed the presence store from this so the initial render already
reflects the correct lock state — see ADR-008. */
    accessResult: StudyReviewAccessResult | null;
    /** Review-eligibility decisions for NextStudy (S1b). Present only while the reviewEligibilityPolicy
flag is on and a study is returned; null otherwise. Additive: clients ignoring it behave as before. Its
studyRevision may be newer than NextStudy's audit.version; the decisions are then authoritative and the study
should be refetched before its content is relied on. */
    eligibility: ReviewEligibilityDto | null;
    /** Set when this request released the reviewer's leftover annotation claim on one of their studies (D8 decision
2): they are no longer allocated it and no slot is left. Only the released study's id; null otherwise. */
    claimRelease: AnnotationClaimReleaseDto | null;
}

export interface ReviewStatus {
    studyReviewStatus: StudyReviewStatus;
    poolSwitchStatus: PoolSwitchStatus;
}

export enum StudyReviewStatus {
    Complete = 0,
    SavedSessions = 1,
    NewReconciliation = 2,
    NewScreeningOnly = 3,
    NewSessions = 4,
    ScreenOrNew = 5,
    SpecificStudyRequested = 6,
}

export enum PoolSwitchStatus {
    NoSwitch = 0,
    MaxSavedThresholdReached = 1,
    NoNewStudiesToReview = 2,
    NoSavedSessionsLeft = 3,
    SpecificStudySelected = 4,
}

export interface StudyBaseDto extends AggregateRootDtoOfGuid {
    studyId: string;
    title: string;
    abstract: string;
    referenceType: string;
    projectId: string;
    authors: string[];
    linkToPdf: string;
    url: string;
    systematicSearchId: string;
    referenceFileId: string;
    year: number;
    publicationName: PublicationName;
    agreementMeasure: StudyAgreementMeasure;
    numberOfScreenings: number;
    customId: string | null;
}

export interface ValueObjectOfPublicationName {
}

export interface PublicationName extends ValueObjectOfPublicationName {
    name: string;
    alternateName: string;
}

export interface StudyAgreementMeasure extends AgreementMeasure {
}

/** Shared access-result payload returned by every channel that can be asked "does this reviewer have access to this study?" — the REST study-load endpoint and the SignalR JoinStudyReview hub method.            Both channels carry the same shape so the client can reconcile them uniformly: the most recent ServerTimestamp wins. See ADR-008. */
export interface StudyReviewAccessResult {
    /** True when the reviewer has access to review this study. */
    granted: boolean;
    /** Why access was denied. Null when Granted is true. */
    denialReason: AccessDenialReason | null;
    /** Current presence snapshot observed by the server. Populated whether or
not access was granted so the client always has fresh state. */
    snapshot: StudyReviewPresenceSnapshot;
    /** Whether the server applied a hard capacity guard for this review claim.
Screening claims always enforce their target; annotation claims follow
the stage's EnforceAnnotationTarget setting. */
    capacityEnforced: boolean;
    /** Set when this request released the reviewer's leftover annotation claim (D8 decision 2); null otherwise. */
    claimRelease: AnnotationClaimReleaseDto | null;
}

export enum AccessDenialReason {
    AtCapacity = 1,
    StageDisabled = 2,
    ReservationExpired = 3,
    NotAMember = 4,
    ReservationMigrationRequired = 5,
    ClaimReleased = 6,
    LockedByBulkUpdate = 7,
    StudyDeleted = 8,
}

/** Pushed to connected clients whenever presence state changes on a study. Contains the full list of slot reservations for the study so the UI can reconcile its local state with a single authoritative snapshot.            Only pre-save reviewers (those holding a SlotReservation) appear in the Reservations list. Saved reviewers (with an AnnotationSession) are reflected in TotalAllocatedSessionCountByStage, which reports the larger of the annotation and screening allocations for each stage. This mirrors the phase-specific capacity guard without double-counting a combined stage's reviewers. */
export interface StudyReviewPresenceSnapshot {
    studyId: string;
    reservations: SlotReservationDto[];
    /** Per-stage total allocated count for the active review phase. Annotation
allocation is saved AnnotationSessions plus active reservations;
screening allocation is completed stage screenings plus reservations whose
reviewer has not already completed that screening. The larger phase count is
exposed so screening-only and combined-stage capacity denials cannot project
an artificially empty room. */
    totalAllocatedSessionCountByStage: { [key: string]: number; };
    /** UTC timestamp of the persisted aggregate state represented by this snapshot.
Retained as an ordering fallback during rolling deployments. */
    serverTimestamp: string;
    /** Persisted optimistic-concurrency version of the represented Study aggregate.
Clients use this as the primary snapshot ordering key so projection timing
cannot make stale state appear newer. */
    aggregateVersion: number;
}

/** Lightweight projection of SlotReservation for client consumption. */
export interface SlotReservationDto {
    investigatorId: string;
    stageId: string;
    hasStartedAnnotating: boolean;
    isSuspended: boolean;
    /** UTC timestamp when the reservation was suspended (involuntary disconnect).
Null when active. Used by other clients to display suspended reviewer state. */
    suspendedSince: string | null;
    /** Absolute UTC instant when the server will release this reservation if the
reviewer does not reconnect. Computed as SuspendedSince + grace period.
Null when the reservation is not suspended. Clients render the disconnection
countdown against this value, so all timing is anchored to server time. */
    releaseAt: string | null;
    isIdle: boolean;
    /** UTC timestamp when the reservation was marked idle. Null when active.
Used by the client to compute remaining time until reservation removal. */
    idleSince: string | null;
}

/** D8 decision 2: the reviewer's leftover annotation claim on one of their own studies was released because they are no longer allocated it and no slot is left for it. Carries only that study's id so the client can name it. */
export interface AnnotationClaimReleaseDto {
    warning: ReviewEligibilityWarning;
    /** The study whose annotation claim was released (the reviewer's own claim). */
    studyId: string;
}

/** Non-blocking notices shown alongside an allowed decision; they never refuse an action. */
export enum ReviewEligibilityWarning {
    ReconciliationNotReady = 0,
    AnnotationClaimReleased = 1,
}

/** The review-eligibility policy's decisions for the current reviewer and the returned study (S1b), present only while the reviewEligibilityPolicy flag is on. Every action and candidate selection is decided separately; there is no single canReview bit. A decision here never authorizes a later save, which rechecks the same policy. The decisions come from their own fresh (uncached) read, so StudyRevision may be newer than the returned study's audit.version; see that property for how a client must treat the difference. */
export interface ReviewEligibilityDto {
    policyVersion: number;
    /** The project revision whose configuration and grants were evaluated. */
    projectRevision: number;
    /** The study revision the decisions were evaluated at. They are evaluated from an independent fresh read, so this
may be newer than the returned study's audit.version (the study itself can come from a cached read). When the two
differ, treat these decisions as authoritative and refetch the study before relying on its content. */
    studyRevision: number;
    submitNewScreening: ReviewEligibilityDecisionDto;
    correctOwnScreening: ReviewEligibilityDecisionDto;
    startAnnotation: ReviewEligibilityDecisionDto;
    saveOwnAnnotation: ReviewEligibilityDecisionDto;
    completeOwnAnnotation: ReviewEligibilityDecisionDto;
    reopenOwnAnnotation: ReviewEligibilityDecisionDto;
    removeOwnAnnotation: ReviewEligibilityDecisionDto;
    startReconciliation: ReviewEligibilityDecisionDto;
    saveOwnReconciliation: ReviewEligibilityDecisionDto;
    newScreeningPool: ReviewEligibilityDecisionDto;
    newAnnotationPool: ReviewEligibilityDecisionDto;
    resumeSaved: ReviewEligibilityDecisionDto;
    directAccess: ReviewEligibilityDecisionDto;
    reconciliationPool: ReviewEligibilityDecisionDto;
    /** Reported only; performing the release is a later slice (S3). */
    annotationClaimRelease: ReviewEligibilityClaimReleaseDto | null;
}

/** One action or selection decision: allowed, or refused with a stable reason; warnings never refuse. */
export interface ReviewEligibilityDecisionDto {
    allowed: boolean;
    /** Stable refusal code; null when allowed. */
    reason: ReviewEligibilityReason | null;
    /** Non-blocking notice on an allowed decision; null otherwise. */
    warning: ReviewEligibilityWarning | null;
}

/** Stable refusal codes. Codes shared with ReviewWriteRefusal keep its names so the save path and the eligibility response agree (ToWriteRefusal); the activity is implied by the action (for example ActivityUnavailable on an annotation action is the doc's AnnotationDisabledInStage). */
export enum ReviewEligibilityReason {
    Forbidden = 0,
    StageDisabled = 1,
    ActivityUnavailable = 2,
    NotFound = 3,
    DuplicateSession = 4,
    ScreeningComplete = 5,
    AtCapacity = 6,
    ExistingDecisionUseCorrection = 7,
    ExcludedFromNewAnnotation = 8,
    AllocationNotAssigned = 9,
    ExcludedSavedWorkHidden = 10,
    ReconciliationNotReady = 11,
    AnnotationTargetMet = 12,
}

/** A leftover annotation claim the server must release, with its reason and warning (D8). */
export interface ReviewEligibilityClaimReleaseDto {
    reason: ReviewEligibilityReason;
    warning: ReviewEligibilityWarning;
}

export enum ScreeningDecision {
    Excluded = 0,
    Included = 1,
}

export interface StudySummaryDto extends StudyBaseDto {
    sessions: AnnotationSessionSummaryDto[];
    screening: ScreeningWebDto | null;
    isSufficientlyExcluded: boolean;
    studyDetails: string;
    completeness: EntityCompleteness;
}

export interface AnnotationSessionSummaryDto extends AnnotationSessionBaseDto {
    outcomeData: string[];
    annotations: string[];
}

export interface ScreeningWebDto {
    id: string;
    studyId: string;
    screenerId: string;
    projectId: string;
    screeningDecision: ScreeningDecision;
    stageId: string;
}

export interface StageReviewerStats {
    screeningStats: ReviewerScreeningStats | null;
    annotationStats: ReviewerAnnotationStats | null;
}

export interface ReviewerScreeningStats {
    investigatorId: string;
    projectId: string;
    membershipId: string;
    id: string;
    screened: number;
    available: number;
    unavailable: number;
    total: number;
}

export interface ReviewerAnnotationStats {
    id: string;
    stageId: string;
    investigatorId: string;
    projectId: string;
    membershipId: string;
    unexcludedInProgress: number;
    unexcludedCompleted: number;
    unexcludedAvailable: number;
    unavailable: number;
    excludedInProgress: number;
    excludedCompleted: number;
    total: number;
    hasReachedMaxInProgress: boolean;
}

export interface ProjectReviewerStats {
    currentProgress: ProjectReviewerProgressMetadata | null;
    screeningStats: ReviewerScreeningStats;
    annotationStats: ReviewerAnnotationStats[];
}

export interface ProjectReviewerProgressMetadata {
    projectId: string;
    investigatorId: string;
    readSource: string;
    stages: ProjectReviewerStageDefinition[];
}

export interface ProjectReviewerStageDefinition {
    stageId: string;
    excludedSessionStatsGrouping: ExcludedSessionStatsGrouping;
    hideExcludedStudiesFromReviewers: boolean;
}

export interface ReviewerAnnotationHistoryPage {
    points: ReviewerAnnotationHistoryPoint[];
    nextCursor: string | null;
}

/** Retained membership-stage state composed with its same-root stage denominator. */
export interface ReviewerAnnotationHistoryPoint {
    checkpoint: string;
    observedAtUtc: string | null;
    trigger: string | null;
    configurationDigest: string | null;
    excludedGrouping: string | null;
    availability: string;
    completed: number | null;
    inProgress: number | null;
    available: number | null;
    unavailable: number | null;
    /** #3636: later instants at which the project was recorded unchanged since this checkpoint,
oldest first. Each carries this checkpoint's values forward and must be shown as carried
forward, not observed. Empty unless this point is Available; a day with neither a point nor
an entry here is a gap. */
    unchangedAtUtc: string[];
    /** #3636: how far this checkpoint's values are verified: Confirmed (every value was
calculated from source, or a later drift check confirmed it), Unconfirmed (some values
were copied from the current materialised statistics and await a drift check) or
Suspect (a drift check found the materialised statistics disagreeing with source, so
copied values may be wrong). Carried-forward days in UnchangedAtUtc share it.
Null unless this point is Available. */
    verificationState: string | null;
}

export interface ReviewerScreeningHistoryPage {
    points: ReviewerScreeningHistoryPoint[];
    nextCursor: string | null;
}

/** One reviewer's retained membership-screening values; no current-state substitution. */
export interface ReviewerScreeningHistoryPoint {
    checkpoint: string;
    observedAtUtc: string | null;
    trigger: string | null;
    sourceVersion: number | null;
    catalogueVersion: number | null;
    configurationDigest: string | null;
    availability: string;
    total: number | null;
    screened: number | null;
    available: number | null;
    unavailable: number | null;
    /** #3636: later instants at which the project was recorded unchanged since this checkpoint,
oldest first. Each carries this checkpoint's values forward and must be shown as carried
forward, not observed. Empty unless this point is Available; a day with neither a point nor
an entry here is a gap. */
    unchangedAtUtc: string[];
    /** #3636: how far this checkpoint's values are verified: Confirmed (every value was
calculated from source, or a later drift check confirmed it), Unconfirmed (some values
were copied from the current materialised statistics and await a drift check) or
Suspect (a drift check found the materialised statistics disagreeing with source, so
copied values may be wrong). Carried-forward days in UnchangedAtUtc share it.
Null unless this point is Available. */
    verificationState: string | null;
}

/** Per-reviewer review-page preferences. Cross-project: they belong to the account, never a project or stage. Stored alongside ReviewWorkspaceLayout in the same narrow settings document, never on Investigator. HideScreeningKeywordHighlights (FEAT-025): the reviewer has hidden the project's screening keyword highlights for themselves. A document written before the field existed has no element and reads as false (shown), so no migration is needed. The keyword lists themselves stay on the project. */
export interface ReviewPreferences {
    stayAfterDecision: boolean;
    stayAfterComplete: boolean;
    overflowMode: string;
    firstRunHintSeen: string[] | null;
    hideScreeningKeywordHighlights: boolean;
    categoryOverflow: string;
}

/** The write (PUT) shape of ReviewPreferences. Reads keep the concrete record so the GET contract never changes; writes use this one because a web bundle cached from before a field existed omits it. Rule: every preference added after the original four (StayAfterDecision, StayAfterComplete, OverflowMode, FirstRunHintSeen, which are always written) is nullable here, and an omitted or null value keeps the stored one — the repository skips that field's $set. Without this, an older client saving any preference reset the later ones to their defaults (#4028). Add future fields the same way. */
export interface ReviewPreferencesUpdate {
    stayAfterDecision: boolean;
    stayAfterComplete: boolean;
    overflowMode: string;
    firstRunHintSeen: string[] | null;
    hideScreeningKeywordHighlights: boolean | null;
    categoryOverflow: string | null;
}

export interface ReviewWorkspaceLayoutsDto {
    layouts: { [key: string]: ReviewWorkspaceLayout; };
}

export interface ReviewWorkspaceLayout {
    version: number;
    sourceMode: string | null;
    sourceBounds: ReviewSourceBounds | null;
    dockJson: string | null;
    sizingMode: string | null;
    customHeights: boolean;
}

export interface ReviewSourceBounds {
    x: number;
    y: number;
    width: number;
    height: number;
}

export interface RuntimeFeatureFlagSnapshot {
    revision: number;
    refreshedAtUtc: string;
    mutationAllowed: boolean;
    values: { [key: string]: boolean; };
    flags: RuntimeFeatureFlagDescriptor[];
    /** Canonical lossless revision for JavaScript clients; numeric Revision remains for older clients. */
    revisionText: string;
    /** Present only for a verified Shared global snapshot; no personal targeting context is implied. */
    authority: RuntimeFeatureFlagSnapshotAuthority | null;
    /** Null for ordinary snapshots. DeploymentControlledAuthorityPreserved when a Legacy reader found initialized
runtime authority: every value is deployment-controlled, the saved runtime policy is preserved but not applied,
and no change is accepted. */
    policyState: string | null;
    groups: RuntimeFeatureFlagGroup[];
}

export interface RuntimeFeatureFlagDescriptor {
    key: string;
    category: string;
    description: string;
    activationRequirement: string;
    staticValue: boolean;
    overrideValue: boolean | null;
    effectiveValue: boolean;
    dependencies: RuntimeFeatureFlagDependencyDescriptor[];
    runtimeManageable: boolean;
    managementReason: string | null;
}

export interface RuntimeFeatureFlagDependencyDescriptor {
    key: string;
    description: string;
    impact: string;
    requiredValue: boolean;
    currentValue: boolean;
    satisfied: boolean;
    runtimeManageable: boolean;
}

export interface RuntimeFeatureFlagSnapshotAuthority {
    schemaVersion: number;
    identity: RuntimePolicyIdentityStatus;
    /** Keys whose emergency stop is in force at this policy, ordinal-sorted. Additive within schema version 1:
a stop is global policy state, not personal data, and saved overrides are unchanged by it. */
    stoppedKeys: string[];
}

export interface RuntimeFeatureFlagGroup {
    key: string;
    name: string;
    description: string;
    keys: string[];
}

export interface RuntimeFeatureFlagProviderStatus {
    mode: string;
    state: string;
    authorityFormat: string;
    observedRevision: number | null;
    savedRevision: number | null;
    policyDigest: string | null;
    observedAtUtc: string | null;
    lastAttemptAtUtc: string | null;
    consumerKey: string;
    evaluatedValue: boolean | null;
    appliedToApi: boolean;
    fleetScope: string;
    /** Null normally. DeploymentControlledAuthorityPreserved when this Legacy API found initialized authority: it serves
deployment-controlled values and the runtime policy is preserved but not applied (PolicyStateDetail). */
    policyState: string | null;
    policyStateDetail: string | null;
}

export interface RuntimePolicyAuthorityStatus {
    mode: string;
    host: string;
    fleetScope: string;
    state: string;
    identity: RuntimePolicyIdentityStatus | null;
    observedAtUtc: string | null;
    lastAttemptAtUtc: string | null;
    reason: string | null;
}

/** Administrative local evaluation; identity revisions remain lossless across HTTP. */
export interface RuntimePolicyEvaluationStatus {
    key: string;
    host: string;
    mode: string;
    fleetScope: string;
    state: string;
    value: boolean | null;
    safeValue: boolean | null;
    productionEligible: boolean;
    grain: string | null;
    maximumAgeSeconds: number | null;
    identity: RuntimePolicyIdentityStatus | null;
}

export interface RuntimePolicyFleetStatus {
    key: string;
    state: string;
    reason: string | null;
    identity: RuntimePolicyIdentityStatus;
    expectedReplicas: { [key: string]: number; };
    hosts: RuntimePolicyFleetHost[];
}

export interface RuntimePolicyFleetHost {
    acknowledgement: RuntimePolicyHostAcknowledgement;
    state: string;
    reason: string | null;
}

export interface RuntimePolicyHostAcknowledgement {
    instanceUid: string;
    service: string;
    processStartId: string;
    processStartedAtUtc: string;
    imageVersion: string;
    catalogDigest: string;
    identity: RuntimePolicyIdentityStatus | null;
    authorityCheckedAtUtc: string | null;
    lastSeenAtUtc: string;
    state: string;
    errorClass: string | null;
    expectedReplicas: number;
    autoscaled: boolean;
    transport: string;
    /** The policy document schemas this host can read, ascending. A host that does not report it reads only schema 1. */
    policySchemaVersions: number[] | null;
    /** The additive policy features this host reads within its schemas (spec 6F.F2: rolloutPausedAt). Additive in the
stored payload: a row without it (a host before 6F.F2) reads none, so the writer stamps no rollout pause time while
such a host is fresh. */
    policyFeatures: string[] | null;
}

/** Unknown is not an abort. Committed identifies the original receipt, not current policy or fleet adoption. */
export interface RuntimePolicyMutationOutcome {
    mutationId: string;
    outcome: string;
    committedIdentity: RuntimePolicyIdentityStatus | null;
}

export interface RuntimePolicyPreview {
    previewDigest: string;
    before: RuntimePolicyIdentityStatus;
    proposed: RuntimePolicyIdentityStatus;
    changes: RuntimePolicyPreviewChange[];
    fleetReadiness: string;
}

export interface RuntimePolicyPreviewChange {
    key: string;
    baselineValue: boolean;
    previousOverride: boolean | null;
    proposedOverride: boolean | null;
    wasStopped: boolean;
    willBeStopped: boolean;
    beforeEffective: boolean;
    proposedEffective: boolean;
    cause: string;
}

export interface RuntimePolicyChangeRequest {
    mutationId: string;
    expectedIdentity: RuntimePolicyIdentityStatus;
    value: boolean | null;
    reason: string;
    action: RuntimePolicyAction;
    includeDependencies: boolean;
    confirmedDependencies: { [key: string]: boolean; } | null;
    previewDigest: string | null;
}

/** The policy actions. Targeting (spec 6F.2) replaces one key's targeting rules (null or empty clears them) and changes no saved value, stop or dependency. FeatureSettings (spec 6F.7, D30 = A) replaces one registry feature's environment setting (a consent stricter than the code's; null clears it, returning to the code's setting); its request names the feature ID as Key and changes nothing else. */
export enum RuntimePolicyAction {
    Change = 0,
    EmergencyStop = 1,
    ReleaseStop = 2,
    Targeting = 3,
    FeatureSettings = 4,
}

/** Durable commit acknowledgement only; fleet adoption is observed separately. */
export interface RuntimePolicyCommitStatus {
    mutationId: string;
    identity: RuntimePolicyIdentityStatus;
}

/** One key's stored targeting as the policy in force holds it (6F W2, the admin Targeting page): the policy identity the rules were read at (the expected identity of the next preview), the key's grain from this binary's catalog contract (Global without one), its rules by kind in the displayed order, and the owning feature's consent. Read-only. Projects names the projects the rules name (project and pair subjects), but only for a caller who may change the policy, the capability under which the targeting preview already returns project names; for a caller who may only inspect it is empty and the page shows project IDs. People are always IDs only (a name needs ListUsers). */
export interface RuntimeTargetingState {
    key: string;
    grain: string;
    identity: RuntimePolicyIdentityStatus;
    rules: RuntimeTargetingRulesByKind;
    projects: RuntimeTargetingProject[];
    consent: RuntimeTargetingConsentState | null;
}

/** A key's rules grouped by kind, in canonical order (displayed order: exclusions, allows, rollout). */
export interface RuntimeTargetingRulesByKind {
    exclude: RuntimeTargetingRuleView[];
    allow: RuntimeTargetingRuleView[];
    rollout: RuntimeTargetingRuleView[];
}

/** One targeting rule on the wire, in the stored rule's shape: exclude and allow carry Enabled (absent means true; D28 = A, false switches the rule off and is stored as written) and Subjects; rollout carries the rollout fields (reported when stored, refused on write before 6F.8). PausedAtUtc (6F.F2) is reported only: MongoDB's time when a stored rollout moved to Paused (null when it is not paused, when it was paused before 6F.F2, or, in a preview, for a pause the commit will stamp). It is ignored on a request: the writer stamps it. */
export interface RuntimeTargetingRuleView {
    id: string;
    kind: string;
    label: string;
    enabled: boolean | null;
    subjects: RuntimeTargetingSubjectView[] | null;
    subjectType: string | null;
    group: string | null;
    basisPoints: number | null;
    state: string | null;
    pausedAtUtc: string | null;
}

/** One targeting subject on the wire: { type: project | person, id } or { type: pair, projectId, personId }. */
export interface RuntimeTargetingSubjectView {
    type: string;
    id: string | null;
    projectId: string | null;
    personId: string | null;
}

/** A project whose decision changes, with its name when it has one (deleted projects keep theirs). */
export interface RuntimeTargetingProject {
    projectId: string;
    name: string | null;
}

/** The consent of the registry feature that owns a key (spec 6F.7, D30 = A): the code's setting, the environment's stored setting and its reason (null when none is stored), and the effective consent (the stricter of the two). The admin Targeting page shows "Choices projects have made" only when Effective is not none. */
export interface RuntimeTargetingConsentState {
    featureId: string;
    code: string;
    environment: string | null;
    environmentReason: string | null;
    effective: string;
}

/** One project the targeting rule editor may offer, with what tells two similarly named projects apart (owner feedback on #4519): its ID, name and whether it is active (not archived); its owner (OwnerId, and OwnerName when the owner's investigator record has a name); its active members and stages; its studies (StudyCount, null when the count was unavailable or timed out); and when it was created (CreatedAtUtc, null when the project stores no creation time). Nothing else: no member names, settings or study content. */
export interface RuntimeTargetingProjectMatch {
    projectId: string;
    name: string;
    active: boolean;
    ownerId: string | null;
    ownerName: string | null;
    memberCount: number;
    stageCount: number;
    studyCount: number | null;
    createdAtUtc: string | null;
}

/** The read-only preview of one key's targeting replacement (spec 6F.2). Gains and losses are decided with the targeting switch on (the routes exist only then), for every project the current or proposed rules name and, when the rollout's membership changes (6F.8: an amount raised or lowered, a group changed, turned off or on), for every non-deleted project whose rollout membership differs; no other project's decision can change, because a targeting write changes no saved value, stop or baseline. Lowering an amount therefore lists exactly the projects that lose the key, with their count. RolloutNotes says in plain words what the proposed rollout state means (Pause holds the amount and keeps out anyone created after it, owner decision D32 = C; Turn off keeps the amount for turning it on again). While the key's rollout is paused with a pause time (6F.F2), each project is decided with its stored creation time, so resuming lists the projects created during the pause that gain the key. On a Personal key (6F.6) a project rule means the project's active members, so a project's gain or loss is decided for an active member no person or pair rule names; GainingPeople and LosingPeople list the people that person and pair rules change, and InactivePeople the people the proposed rules name who are no longer active Investigators: they never match and are listed for removal (D34; rules are never rewritten automatically). All three are empty on a Project key. */
export interface RuntimeTargetingPreview {
    previewDigest: string;
    before: RuntimePolicyIdentityStatus;
    proposed: RuntimePolicyIdentityStatus;
    key: string;
    grain: string;
    beforeRules: RuntimeTargetingRulesByKind;
    afterRules: RuntimeTargetingRulesByKind;
    gaining: RuntimeTargetingProjectChanges;
    losing: RuntimeTargetingProjectChanges;
    dependencyNotes: string[];
    schemaAdmission: RuntimeTargetingSchemaAdmission;
    fleetReadiness: string;
    rolloutNotes: string[];
    gainingPeople: RuntimeTargetingPeopleChanges;
    losingPeople: RuntimeTargetingPeopleChanges;
    inactivePeople: string[];
}

/** How many projects gain or lose the key, and up to MaximumPreviewNames of them. */
export interface RuntimeTargetingProjectChanges {
    count: number;
    projects: RuntimeTargetingProject[];
}

/** Policy-schema admission of the write: the schema the candidate needs, how many fresh host acknowledgements read it, and Ready or Blocked. Only the first schema-2 write needs the fleet; later writes are Ready. */
export interface RuntimeTargetingSchemaAdmission {
    required: number;
    hostsSupporting: number;
    hostsTotal: number;
    state: string;
}

/** How many people gain or lose the key, and up to MaximumPreviewNames of them. */
export interface RuntimeTargetingPeopleChanges {
    count: number;
    people: RuntimeTargetingPerson[];
}

/** A person whose decision changes on a Personal key (6F.6): everywhere (a person rule, ProjectId null) or as an active member of ProjectId (a pair rule). IDs only: rules hold opaque person IDs (D34), and a person's name needs ListUsers, which this route does not check. */
export interface RuntimeTargetingPerson {
    personId: string;
    projectId: string | null;
}

/** A targeting refusal (HTTP 422): code is always runtime_targeting_refused; reason is stable. */
export interface RuntimeTargetingRefusal {
    code: string;
    reason: string;
    message: string;
}

/** Body of POST api/runtime-feature-flags/{key}/targeting/preview. */
export interface RuntimeTargetingPreviewRequest {
    expectedIdentity: RuntimePolicyIdentityStatus;
    targeting: RuntimeTargetingRules | null;
}

/** One key's replacement targeting rules (spec 6F.2). A null body, or no rules, clears the key's targeting. */
export interface RuntimeTargetingRules {
    rules: RuntimeTargetingRuleView[] | null;
}

/** Body of PUT api/runtime-feature-flags/{key}/targeting: the previewed rules with the preview's digest, a reason and a mutation ID. Retry the same mutation ID with the unchanged body after an unknown outcome. */
export interface RuntimeTargetingCommitRequest {
    mutationId: string;
    expectedIdentity: RuntimePolicyIdentityStatus;
    targeting: RuntimeTargetingRules | null;
    previewDigest: string;
    reason: string;
}

/** The "Preview and check" result: the trace under the policy in force and, when a draft was given, under the draft applied to it. The subject is echoed as sent, with no names. A project or person that does not exist is refused before any result (422 unknownProject / unknownPerson, owner decision D59 = B), so a result always names subjects the grain's reads found (or could not read). */
export interface RuntimeTargetingSimulationResult {
    key: string;
    grain: string;
    subject: RuntimeTargetingSimulationSubject;
    current: RuntimeTargetingTrace;
    draft: RuntimeTargetingTrace | null;
    comparison: RuntimeTargetingSimulationComparison | null;
}

/** The person and project to simulate. They are subjects of the simulation, never the caller. */
export interface RuntimeTargetingSimulationSubject {
    projectId: string | null;
    personId: string | null;
}

/** A decision with its reason, the step that decided (the first on or off) and every step. */
export interface RuntimeTargetingTrace {
    value: boolean;
    reason: string;
    decidedByStep: number;
    ruleId: string | null;
    steps: RuntimeTargetingTraceStep[];
}

/** One precedence step, in the displayed order (requirements, stops, exclusions, allows, rollout, default, baseline). On the rollout step of a paused rollout with a pause time (6F.F2), PausedAtUtc is the pause time and, when the subject's position is inside the held share, SubjectCreatedAtUtc is the creation time compared with it (null: the subject has none, so it counts as existing before the pause). */
export interface RuntimeTargetingTraceStep {
    step: number;
    name: string;
    outcome: string;
    detail: string;
    ruleId: string | null;
    ruleLabel: string | null;
    bucket: number | null;
    subjectCreatedAtUtc: string | null;
    pausedAtUtc: string | null;
}

/** Draft against policy in force: whether the value changes, and the first step whose outcome or rule differs. */
export interface RuntimeTargetingSimulationComparison {
    valueChanged: boolean;
    changedStep: number | null;
}

/** Body of POST api/runtime-feature-flags/{key}/simulate (spec 6F.5). */
export interface RuntimeTargetingSimulationRequest {
    subject: RuntimeTargetingSimulationSubject | null;
    draft: RuntimeTargetingSimulationDraft | null;
}

/** A draft replacement of the key's rules. No rules means the draft clears the key. */
export interface RuntimeTargetingSimulationDraft {
    rules: RuntimeTargetingRuleView[] | null;
}

/** The read-only preview of one feature's environment setting (spec 6F.7): the code's consent, the environment's before and after (null when none is stored), the effective consent before and after (the stricter of code and environment), and policy-schema admission. CodeSettingChanged is true when an environment setting is stored but the code's setting is now at least as strict, so it no longer tightens anything: the code setting changed in a deployment after the environment's was saved (the admin page says "code setting changed in this deployment"). A code change that tightens a setting applies at once; it needs no write here. */
export interface RuntimeFeatureSettingsPreview {
    previewDigest: string;
    before: RuntimePolicyIdentityStatus;
    proposed: RuntimePolicyIdentityStatus;
    featureId: string;
    grain: string;
    code: string;
    environmentBefore: string | null;
    environmentAfter: string | null;
    effectiveBefore: string;
    effectiveAfter: string;
    codeSettingChanged: boolean;
    schemaAdmission: RuntimeTargetingSchemaAdmission;
}

/** Body of POST api/runtime-feature-flags/features/{featureId}/settings/preview; a null setting clears it. */
export interface RuntimeFeatureSettingsPreviewRequest {
    expectedIdentity: RuntimePolicyIdentityStatus;
    setting: RuntimeFeatureSettingValue | null;
}

/** An environment setting for one feature (spec 6F.7): consent offered or required, and why. */
export interface RuntimeFeatureSettingValue {
    consent: string;
    reason: string;
}

/** Body of PUT api/runtime-feature-flags/features/{featureId}/settings: the previewed setting (null clears it) with the preview's digest, a reason for the change and a mutation ID. Retry the same mutation ID with the unchanged body after an unknown outcome. */
export interface RuntimeFeatureSettingsCommitRequest {
    mutationId: string;
    expectedIdentity: RuntimePolicyIdentityStatus;
    setting: RuntimeFeatureSettingValue | null;
    previewDigest: string;
    reason: string;
}

/** How many subjects of one feature's subject type have joined and left, in one binding (counts only, never IDs). */
export interface RuntimeFeatureConsentCounts {
    subjectType: string;
    joined: number;
    left: number;
}

export interface RuntimeReleaseIntentPreview {
    previewDigest: string;
    expectedPolicy: RuntimePolicyIdentityStatus;
    proposedPolicy: RuntimePolicyIdentityStatus;
    guidanceState: string;
}

/** Body of the release preview and prepare routes. A Global feature's release is Policy's saved-value Set. A Project or Personal feature's release (6F.10) sets policy.action to Targeting, leaves policy.value null and carries the key's replacement rules in Targeting; its enabled allow rules name the release's audience. */
export interface RuntimeReleasePreparationRequest {
    releaseId: string;
    releaseKey: string;
    stage: RuntimeReleaseStage;
    scheduledForUtc: string | null;
    contentBundleDigest: string | null;
    policy: RuntimePolicyChangeRequest;
    previewDigest: string | null;
    targeting: RuntimeTargetingRules | null;
}

export enum RuntimeReleaseStage {
    LimitedRelease = 0,
    GeneralRelease = 1,
}

/** A release record as read: its preparation result with the record's current status and version, and, once applied, its milestones keyed by stage (Milestones is null while none exist). The stored preparation result never carries milestones, so it stays byte-identical to what preparation wrote. */
export interface RuntimePreparedRelease {
    releaseId: string;
    environmentId: string;
    bindingEpoch: string;
    featureId: string;
    releaseKey: string;
    stage: RuntimeReleaseStage;
    status: string;
    version: string;
    requestedAtUtc: string;
    scheduledForUtc: string | null;
    expectedPolicy: RuntimePolicyIdentityStatus;
    proposedPolicy: RuntimePolicyIdentityStatus;
    contentBundleDigest: string | null;
    milestones: { [key: string]: RuntimeReleaseMilestone; } | null;
    announcements: RuntimeReleaseAnnouncement[] | null;
    /** Only the reconciler confirms activation, from MongoDB time and current fleet evidence (RT-21). */
    confirmedAtUtc: string | null;
}

/** One stage's milestone. Apply records RequestedAtUtc and ScheduledForUtc; the reconciler sets ConfirmedAtUtc and RecordedAtUtc from MongoDB time once the fleet is Active for the committed capability, with Semantics ObservedActivation or ObservedAfterRecovery and the policy identity it confirmed. A confirmed milestone is never rewritten. */
export interface RuntimeReleaseMilestone {
    requestedAtUtc: string | null;
    scheduledForUtc: string | null;
    confirmedAtUtc: string | null;
    recordedAtUtc: string | null;
    semantics: string | null;
    precision: string;
    confirmedPolicy: RuntimePolicyIdentityStatus | null;
}

/** One announcement (outbox) row of a release, as the admin Releases screen shows it (6G.11). Kind and State are the stored names (MaterialiseWhatsNew / NotifyInApp; Pending, Leased, Done, Cancelled, Failed). TestSink is whether a finished delivery went to a test sink, null while nothing was delivered. Since D60 A (26 Oct 2026) every delivery is false; true appears only on staging rows that the retired test sink completed before then, and they stay as they were (rows are never rewritten). */
export interface RuntimeReleaseAnnouncement {
    kind: string;
    state: string;
    attempts: number;
    lastErrorClass: string | null;
    cancelReason: string | null;
    completedAtUtc: string | null;
    testSink: boolean | null;
}

/** A page of releases, newest first. NextBefore is the before cursor of the next page, null on the last. */
export interface RuntimeReleaseListPage {
    releases: RuntimeReleaseListItem[];
    nextBefore: string | null;
}

/** One release in the list: identity, status, milestones and its announcement rows. An imported historical release has no preparation (RequestedAtUtc is null). */
export interface RuntimeReleaseListItem {
    releaseId: string;
    featureId: string;
    releaseKey: string;
    stage: RuntimeReleaseStage;
    status: string;
    version: string;
    imported: boolean;
    requestedAtUtc: string | null;
    scheduledForUtc: string | null;
    confirmedAtUtc: string | null;
    milestones: { [key: string]: RuntimeReleaseMilestone; } | null;
    announcements: RuntimeReleaseAnnouncement[];
}

/** A release's events in recorded order; Truncated when more than the bound exist. */
export interface RuntimeReleaseEventsPage {
    releaseId: string;
    events: RuntimeReleaseEvent[];
    truncated: boolean;
}

/** One event on a release's timeline. Only what the screen shows: no actor, request body or digest. Type is a RuntimeReleaseEventType name. */
export interface RuntimeReleaseEvent {
    eventId: string;
    type: string;
    recordedAtUtc: string | null;
    occurredAtUtc: string | null;
    stage: string | null;
    provenance: string | null;
    reason: string | null;
}

/** GET /api/feature-releases/content-preview: the features that have content to preview, from the current verified server bundle and the registry. Bundle is Current, or Unavailable when the bundle is missing or does not verify (then only registry walkthroughs are listed). */
export interface FeatureContentIndex {
    bundle: string;
    bundleDigest: string | null;
    features: FeatureContentIndexEntry[];
}

/** One feature with content: whether the bundle has a What's New entry for it, how many articles, and whether it has a walkthrough. */
export interface FeatureContentIndexEntry {
    featureId: string;
    whatsNew: boolean;
    topics: number;
    walkthrough: boolean;
}

/** GET /api/feature-releases/content-preview/{featureId}?audience=: exactly what one audience would get for one feature, once its release is confirmed and the feature is on. Content left out for the audience carries only its identifiers and a FeatureContentReasons value, never its text. FeatureAudience is the registry audience (signedIn, projectMembers, projectAdministrators, applicationAdministrators, or null) and Reaches whether it includes the chosen audience (always false signed out). */
export interface FeatureContentPreviewResponse {
    featureId: string;
    audience: string;
    featureAudience: string | null;
    reaches: boolean;
    bundle: string;
    bundleDigest: string | null;
    whatsNew: FeatureContentWhatsNew;
    help: FeatureContentHelpTopic[];
    walkthrough: FeatureContentWalkthrough;
}

/** The What's New entries the audience would see, or none and the Reason. */
export interface FeatureContentWhatsNew {
    reason: string | null;
    entries: FeatureContentWhatsNewEntry[];
}

/** One runtime What's New entry as the audience would see it: the bundle text, the release Stages at which this audience sees it, Notice when it carries the "New to you" label (signed in, notifying the release audience) and Public when the public projection shows it at general release (to everyone, signed in or not). */
export interface FeatureContentWhatsNewEntry {
    id: string;
    revision: string;
    title: string;
    body: string;
    topicId: string;
    guidePath: string | null;
    stages: string[];
    notice: boolean;
    public: boolean;
}

/** One help article of the feature. Shown (Reason null): its Title and Markdown (the topic's section of the page, or the whole page). Left out: only its identifiers and publication class. */
export interface FeatureContentHelpTopic {
    topicId: string;
    variantId: string | null;
    publication: string | null;
    reason: string | null;
    title: string | null;
    markdown: string | null;
}

/** The feature's walkthrough (its steps ship in the web bundle, walkthroughs.generated.ts), or the Reason it does not start. */
export interface FeatureContentWalkthrough {
    reason: string | null;
    walkthroughId: string | null;
}

/** Every Release-type feature that is not Settled or Withdrawn, in registry order, as of AsOfUtc (the injected clock). Each environment computes its own list from its own records (D21, D24): EnvironmentId is the verified binding's. */
export interface RuntimeReadyToSettlePage {
    environmentId: string;
    asOfUtc: string;
    features: RuntimeReadyToSettleFeature[];
}

/** One Release-type feature as the admin "Ready to settle" read reports it (6G.12, D21, D43 = B). Two sources say when the feature went live for everyone in this environment: its confirmed GeneralRelease record (ReleaseRecordSinceUtc, the later of the confirmation and the last restore) and the flag change history in the runtime policy audit (FlagHistorySinceUtc, the commit of the change after which every one of its flags was on for everyone). LiveSinceUtc is the later of the two, so a feature is never called ready sooner than both allow, and ReadyOnUtc is that plus SettleDays. status is one of ready, notYet, stopped, notLive. disagreement is null when the sources agree (or only one has a date). flagHistoryLater or releaseRecordLater when both have a date more than an hour apart (a day for a Date-precision import; the later one is used); releaseRecordButNotLive when the release record says live but the flags are not on for everyone now. releaseRecordNote says why the release record gave no date although one exists: stopped (its last stop event has no restore after it) or imprecise (only a Month or Unknown precision import, and Settle needs a date). flagHistoryCoverage says how far the flag history answers: exact (the switch-on was found), fromStart (on since this environment's policy history began, so the date is when it began), truncated (more changes than the read takes, so the date is the oldest one read: a later date than the truth, never an earlier one), notCovered (production flags the deployment controls, which the policy history does not record), notLive (the flags are not on for everyone now) or unavailable (the history does not reach the current policy). */
export interface RuntimeReadyToSettleFeature {
    featureId: string;
    flags: string[];
    lifecycle: string;
    status: string;
    settleDays: number;
    liveSinceUtc: string | null;
    releaseRecordSinceUtc: string | null;
    flagHistorySinceUtc: string | null;
    generalReleaseId: string | null;
    disagreement: string | null;
    releaseRecordNote: string | null;
    flagHistoryCoverage: string;
    readyOnUtc: string | null;
    stopped: boolean;
}

/** Side-effect-free Apply plan. AdmissionRefusal is a stable RuntimeReleaseAdmission reason, or null when Apply would be admitted now. GuidanceState is Verified, Exempt or Unverified; GuidanceBundleDigest is the verified server bundle's digest and GuidanceTopics the feature's topics found in it (both empty for an exempt feature). */
export interface RuntimeReleaseApplyPreview {
    previewDigest: string;
    expectedPolicy: RuntimePolicyIdentityStatus;
    proposedPolicy: RuntimePolicyIdentityStatus;
    changes: RuntimePolicyPreviewChange[];
    guidanceState: string;
    guidanceBundleDigest: string | null;
    guidanceTopics: string[];
    admitted: boolean;
    admissionRefusal: string | null;
    announcement: RuntimeReleaseAnnouncementMode;
    quietReason: string | null;
    queuedAnnouncements: RuntimeReleaseOutboxKind[];
}

/** Whether an Apply queues the feature's resolved registry announcements (Default) or none (Quiet, which needs a reason that the preview shows and the release records; decision D13). */
export enum RuntimeReleaseAnnouncementMode {
    Default = 0,
    Quiet = 1,
}

/** A side effect an Apply queues. Rows wait Pending until the dispatcher finds a handler for the kind. MaterialiseWhatsNew is completed by RuntimeReleaseWhatsNewHandler and NotifyInApp by RuntimeReleaseInAppNoticeHandler, the same in every valid environment (D60 A, 26 Oct 2026; staging's test sink and the preview and local refusal are retired). */
export enum RuntimeReleaseOutboxKind {
    MaterialiseWhatsNew = 0,
    NotifyInApp = 1,
}

/** Apply a Prepared release. The policy change (flag and value) and the definition snapshot are fixed at preparation; ExpectedIdentity and PreviewDigest come from a fresh Apply preview against current policy, so unrelated policy changes since preparation need only a new preview (decision D-Q3). */
export interface RuntimeReleaseApplyRequest {
    mutationId: string;
    expectedIdentity: RuntimePolicyIdentityStatus;
    previewDigest: string | null;
    reason: string;
    announcement: RuntimeReleaseAnnouncementMode;
    quietReason: string | null;
}

/** An applied release: its policy is committed. Activation is not confirmed until the reconciler observes it. */
export interface RuntimeAppliedRelease {
    releaseId: string;
    environmentId: string;
    bindingEpoch: string;
    featureId: string;
    releaseKey: string;
    stage: RuntimeReleaseStage;
    status: string;
    version: string;
    mutationId: string;
    committedPolicy: RuntimePolicyIdentityStatus;
    requestedAtUtc: string;
    committedAtUtc: string;
    guidanceState: string;
    announcement: RuntimeReleaseAnnouncementMode;
    quietReason: string | null;
    queuedAnnouncements: RuntimeReleaseOutboxKind[];
    confirmedAtUtc: string | null;
}

export interface RuntimePolicyEmergencyStopRequest {
    mutationId: string;
    expectedIdentity: RuntimePolicyIdentityStatus;
    reason: string;
}

export interface RuntimeDeploymentBreakGlassRequest {
    mutationId: string;
    expectedIdentity: RuntimePolicyIdentityStatus;
    reason: string;
    expectedConstraintDigest: string;
}

export interface RuntimeFeatureFlagDependencyProblem {
    code: string;
    message: string;
    canApplyAutomatically: boolean;
    dependencies: RuntimeFeatureFlagDependencyDescriptor[];
}

export interface RuntimeFeatureFlagMutation {
    value: boolean | null;
    expectedRevision: number | null;
    reason: string;
    includeDependencies: boolean;
    confirmedDependencies: { [key: string]: boolean; } | null;
}

/** Project-wide screening graphs; no stage or annotation dependency. MembershipScreening comes from MembershipScreening unchanged, so every row has already left through MembershipScreeningVisibilityShaper (#3083 tiers): no graph permission, no rows; graph only, anonymised rows with the caller's own flagged; decisions as well, named rows. There is no annotation list to join an anonymised row against. */
export interface ScreeningOverviewStatistics {
    enabled: boolean;
    projectId: string;
    readSource: string;
    checkpoint: string | null;
    clientInvalidationRevision: string | null;
    globalClientInvalidationRevision: string | null;
    screeningAgreementMode: AgreementMode | null;
    screeningAgreementThreshold: ProjectAgreementThreshold | null;
    screening: ProjectScreeningStats | null;
    membershipScreening: MembershipScreeningStats[];
}

export interface MyAllocatedStudiesDto {
    enabled: boolean;
    stale: boolean;
    version: number;
    assignedCount: number;
    completedCount: number;
    inProgressCount: number;
    remainingCount: number;
    availableCount: number;
    offset: number;
    limit: number;
    studies: AllocatedStudyDto[];
}

export interface AllocatedStudyDto {
    studyId: string;
    title: string | null;
    status: string;
    canOpen: boolean;
}

export interface StageAllocationProgressDto {
    enabled: boolean;
    stale: boolean;
    version: number;
    reviewers: ReviewerAllocationProgressDto[];
    inactiveReviewerIds: string[];
    regime: AllocationRegimeDto | null;
}

export interface ReviewerAllocationProgressDto {
    investigatorId: string;
    basisPoints: number;
    assignedCount: number;
    completedCount: number;
    inProgressCount: number;
    remainingCount: number;
    availableCount: number;
}

/** The allocation regime currently admitting the stage's new annotation work; each new review session records this identity as its provenance. Origin is LegacyConfiguration for a configuration that predates regime records, Configuration for one published through the allocation API, LegacyAfterPointerMismatch when a release below the compatibility floor changed the configuration after a regime was published (the published regime no longer governs), and null when Supported is false (a newer release's regime, which this server fails closed on). */
export interface AllocationRegimeDto {
    regimeId: string;
    origin: AllocationRegimeOrigin | null;
    schemaVersion: number;
    supported: boolean;
}

/** How the regime admitting new work came to exist. Serialised by name. */
export enum AllocationRegimeOrigin {
    Configuration = "Configuration",
    LegacyConfiguration = "LegacyConfiguration",
    LegacyAfterPointerMismatch = "LegacyAfterPointerMismatch",
}

/** The Stage Overview's pies and leaderboards as one snapshot. MembershipScreening is shaped by MembershipScreeningVisibilityShaper exactly as the legacy full-stats routes are (#3083): no screening graph permission, no rows; the graph alone, anonymised rows with the caller's own flagged; the decisions permission as well, named rows. The screening and annotation leaderboards are separate lists so an anonymised screening row cannot be joined to an identified annotation row. */
export interface StageOverviewStatistics {
    enabled: boolean;
    projectId: string;
    stageId: string;
    readSource: string;
    checkpoint: string | null;
    clientInvalidationRevision: string | null;
    globalClientInvalidationRevision: string | null;
    screeningAgreementMode: AgreementMode | null;
    screeningAgreementThreshold: ProjectAgreementThreshold | null;
    screening: ProjectScreeningStats | null;
    annotation: StageAnnotationStats | null;
    membershipScreening: MembershipScreeningStats[];
    membershipAnnotation: StageOverviewMembershipAnnotation[];
}

/** One reviewer's annotation leaderboard row. Annotation rows carry identity by design (#3578 tiers). */
export interface StageOverviewMembershipAnnotation {
    membershipId: string;
    investigatorId: string;
    annotation: MembershipStageStats;
}

export interface ReviewSettingsReadResponse {
    settings: ReviewSettingsSaveRequest;
    effectiveSessionCountTarget: number;
    /** The review evidence a settings change on this stage is judged against: current saved reviews (from statistics
when they show saved work, otherwise the authoritative stage-attributed check), where that answer came from, and
the stage's monotonic review history. Additive; shown by the browser before a conversion is attempted. */
    reviewEvidence: StageReviewEvidence | null;
}

export interface ReviewSettingsSaveRequest {
    expectedProjectVersion: number;
    reviewMode: ReviewMode;
    studySelectionMode: StudySelectionMode | null;
    additionalScreeningPolicy: AdditionalScreeningPolicy | null;
    active: boolean;
    extraction: boolean;
    maxInProgress: number | null;
    sessionCountTarget: number | null;
    excludedSessionStatsGrouping: ExcludedSessionStatsGrouping;
    hideExcludedStudiesFromReviewers: boolean;
    enforceAnnotationTarget: boolean;
    idleSessionTimeoutMinutes: number | null;
    confirmReviewedConversion: boolean;
    applyAnyway: boolean;
}

/** The current and historical review evidence a stage settings decision used. */
export interface StageReviewEvidence {
    current: CurrentStageReviewEvidence;
    source: StageReviewEvidenceSource;
    historical: HistoricalStageReviewEvidence;
}

export enum CurrentStageReviewEvidence {
    Unavailable = 0,
    NoSavedReviews = 1,
    SavedReviews = 2,
}

/** Where a settings-save review evidence answer came from. */
export enum StageReviewEvidenceSource {
    Statistics = 0,
    Authoritative = 1,
}

export enum HistoricalStageReviewEvidence {
    Unknown = 0,
    NeverReviewed = 1,
    Reviewed = 2,
}

export interface ReviewSettingsSaveResponse {
    outcome: string;
    projectVersion: number;
    screeningClaimsToRelease: number;
    annotationClaimsToRelease: number;
    /** On a save, the target the stage now resolves to, including the
            project default when the override was cleared; null on refusals. */
    effectiveSessionCountTarget: number | null;
}

export interface StageAnnotationHistoryPage {
    points: StageAnnotationHistoryPoint[];
    nextCursor: string | null;
}

/** Retained completion state for unexcluded studies, not cumulative activity. */
export interface StageAnnotationHistoryPoint {
    checkpoint: string;
    observedAtUtc: string | null;
    trigger: string | null;
    configurationDigest: string | null;
    excludedGrouping: string | null;
    availability: string;
    completed: number | null;
    insufficient: number | null;
    /** #3636: later instants at which the project was recorded unchanged since this checkpoint,
oldest first. Each carries this checkpoint's values forward and must be shown as carried
forward, not observed. Empty unless this point is Available; a day with neither a point nor
an entry here is a gap. */
    unchangedAtUtc: string[];
    /** #3636: how far this checkpoint's values are verified: Confirmed (every value was
calculated from source, or a later drift check confirmed it), Unconfirmed (some values
were copied from the current materialised statistics and await a drift check) or
Suspect (a drift check found the materialised statistics disagreeing with source, so
copied values may be wrong). Carried-forward days in UnchangedAtUtc share it.
Null unless this point is Available. */
    verificationState: string | null;
}

export interface StageWorkloadSharesDto {
    version: number;
    enabled: boolean;
    reviewsPerStudy: number;
    reviewers: ReviewerWorkloadShareDto[];
    availableReviewerIds: string[];
}

export interface ReviewerWorkloadShareDto {
    investigatorId: string;
    basisPoints: number;
}

export interface UpdateStageWorkloadSharesDto {
    enabled: boolean;
    expectedVersion: number;
    reviewers: ReviewerWorkloadShareDto[];
}

export interface PagedDataDtoOfStudyDetailsDto {
    tableProps: OutgoingTableParamsDto;
    data: StudyDetailsDto[];
}

export interface OutgoingTableParamsDto {
    pageSize: number;
    fromRow: number;
    total: number;
    unfilteredTotal: number;
}

export interface StudyDetailsDto extends StudyBaseDto {
    sessions: AnnotationSessionDetailDto[];
    screening: ScreeningWebDto | null;
    studyDetails: FurtherStudyDetails;
    completeness: EntityCompleteness;
}

export interface FurtherStudyDetails {
    id: string;
    inclusionStatus: string;
    investigatorDecision: UserInclusionFilter;
    riskOfBiasInfo: NewRiskOfBiasInfo | null;
    studyCorrections: StudyCorrectionDto[];
}

export enum UserInclusionFilter {
    NotScreened = 1,
    Included = 2,
    Excluded = 4,
    Unavailable = 8,
    All = 15,
}

export interface NewRiskOfBiasInfo {
    jobId: string;
    calculatedDateTime: string;
    result: RiskOfBiasResult;
}

export interface RiskOfBiasResult {
    random: number;
    blind: number;
    interest: number;
    welfare: number;
    exclusion: number;
}

export interface StudyCorrectionDto extends AggregateRootDtoOfGuid {
    studyId: string;
    searchId: string;
    investigatorId: string;
    projectId: string;
    pdfIssue: PdfIssue;
    incorrectPdfUrl: string;
    correction: SuggestedPdfCorrection;
    completeness: EntityCompleteness;
}

export enum PdfIssue {
    PdfLinkNotWorking = 0,
    IncorrectPdf = 1,
}

export interface ValueObjectOfSuggestedPdfCorrection {
}

export interface SuggestedPdfCorrection extends ValueObjectOfSuggestedPdfCorrection {
    replacementUrl: string;
    uploadedToSyrf: boolean;
}

export interface IncomingTableParamsDtoOfStudyFilters {
    pageSize: number;
    fromRow: number;
    sortOrder: ColumnOrder[];
    filters: StudyFilters | null;
}

export interface ColumnOrder {
    column: string | null;
    dir: ColumnDir;
}

export enum ColumnDir {
    ASC = 0,
    DESC = 1,
}

export interface StudyFilters {
    stageId: string | null;
    searchTerm: string;
    projectInclusionFilter: ProjectInclusionFilter;
    userInclusionFilter: UserInclusionFilter;
    systematicSearchFilter: string[];
    userSessionFilter: UserSessionStatusFilter;
    projectSessionFilter: ProjectSessionStatusFilter;
}

export enum ProjectInclusionFilter {
    None = 0,
    InsufficientlyScreened = 1,
    Included = 2,
    Excluded = 4,
    Undetermined = 8,
    All = 15,
}

export enum UserSessionStatusFilter {
    NotStarted = 1,
    InProgress = 2,
    Complete = 4,
    Unavailable = 8,
    All = 15,
}

export enum ProjectSessionStatusFilter {
    None = 1,
    InProgress = 2,
    Completed = 4,
    All = 7,
}

export interface PdfUploadSignatureRequestDto {
    uploadInfo: SearchUploadS3RequestInfoDto;
    projectId: string;
    investigatorId: string;
    studyId: string;
    searchId: string;
    filename: string;
}

export interface StudyROBOutputDto {
    studyId: string;
    pdfPath: string;
}

export interface StudyRiskOfBiasInputDto {
    studyId: string;
    pdfStatus: string;
    blinding: boolean;
    randomisation: boolean;
    ssc: boolean;
}

export interface SearchUpdateSignatureRequestDto {
    name: string;
    referenceFileId: string;
    payloadHash: string;
    screeningImportSettings: ScreeningImportSettings | null;
    /** CSV size in bytes, signed as Content-Length and bounded by the CSV parser limit (256 MiB).
Optional during the mixed-client transition; older clients can omit it (#4589). */
    contentLength: number | null;
}

export interface ConversationCandidateDto {
    sessionId: string;
    label: string;
}

export interface StudyConversationDto {
    id: string;
    projectId: string;
    studyId: string;
    stageId: string;
    version: number;
    contextPath: string;
    participants: string[];
    canReply: boolean;
    posts: ConversationPostDto[];
}

export interface ConversationPostDto {
    id: string;
    author: string;
    text: string;
    createdAtUtc: string;
}

export interface ConversationQuestionRequest {
    requestId: string;
    projectId: string;
    studyId: string;
    stageId: string;
    sessionIds: string[];
    text: string;
}

export interface ConversationSummaryDto {
    id: string;
    question: string;
    createdAtUtc: string;
}

export interface ConversationReplyRequest {
    requestId: string;
    version: number;
    text: string;
}

/** Who may be chosen for impersonation: only what the picker shows. */
export interface SupportImpersonationCandidateDto {
    id: string;
    firstName: string;
    surname: string;
    preferredName: string | null;
    email: string;
    deactivated: boolean;
}

/** What the operator's tab needs to present impersonation (M2b). */
export interface SupportImpersonationSessionDto {
    /** read-only, or edit when the presented edit context is valid now. */
    mode: string;
    /** When the presented edit context expires, if it is valid. */
    editExpiresUtc: string | null;
    /** The maximum edit-context lifetime (proposed: 30). */
    maxEditMinutes: number;
    policyVersion: string;
}

/** A new edit context. Handle is shown once: keep it in the tab's memory only. */
export interface SupportImpersonationEditContextDto {
    handle: string;
    expiresUtc: string;
    maxEditMinutes: number;
}

export interface DevLoginRequest {
    investigatorId: string;
    returnUrl: string | null;
}

export interface E2ELoginRequest {
    userId: string;
    email: string | null;
    displayName: string | null;
    givenName: string | null;
    familyName: string | null;
    syrfGroups: string | null;
    roles: string[] | null;
}

export enum OptionConditionalTargetParentOptionsDtoConditionType {
    _0 = 0,
}

export enum BooleanConditionalTargetParentOptionsDtoConditionType {
    _1 = 1,
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}